export default {
  // Common
  'common.am': 'ص',
  'common.pm': 'م',
  'common.unit.h': 'س',
  'common.unit.m': 'د',
  'common.unit.hour': 'ساعة',
  'common.unit.hours': 'ساعات',
  'common.unit.minute': 'دقيقة',
  'common.unit.minutes': 'دقائق',
  'common.smart vision': 'سمارت فيجن',
  'common.success': 'نجاح',
  'common.error': 'خطأ',
  'common.ok': 'موافق',
  'common.run': 'تشغيل',
  'common.dashboard': 'لوحة المعلومات',
  'common.sorrySomethingWentWrong': 'عذرًا، حدث خطأ ما',
  'common.requestFailed': 'تعذر الاتصال بالخادم. يرجى المحاولة لاحقاً.',
  'common.connectionError': 'تعذر الاتصال بالخادم. يرجى المحاولة لاحقاً.',
  'common.operationSuccess': 'تمت العملية بنجاح.',
  'common.saveFailed': 'فشل الحفظ',
  'common.thisItem': 'هذا العنصر',
  'common.createdSuccessfully': 'تم الإنشاء بنجاح',
  'common.updatedSuccessfully': 'تم التحديث بنجاح',
  'common.deletedSuccessfully': 'تم الحذف بنجاح',
  'common.updateSuccess': 'تم التحديث بنجاح',
  'common.recordsDeletedSuccessfully': 'تم حذف السجلات بنجاح',
  'common.pleaseSelectAtLeastOneRecordToDelete': 'يرجى اختيار سجل واحد على الأقل للحذف',
  'common.deleteConfirmWithName': 'هل أنت متأكد أنك تريد حذف {name}؟',
  'common.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف {count} سجلات؟',
  'common.consumed':'مُستهلَك',
  'workflow.bulkInvalidRequest': 'لا يمكن معالجة بعض الطلبات المحددة لوجود معلومات مطلوبة غير مكتملة في مرحلة الموافقة الحالية. يرجى مراجعة الطلبات غير المكتملة والمحاولة مرة أخرى.',
  // رسائل إجراءات الموافقة المجمعة - تعيين رسائل الأكواد
  'workflow.bulk.successfullyProcessed': 'تمت المعالجة بنجاح',
  'workflow.bulk.invalidOrInactiveAction': 'إجراء غير صالح أو غير نشط.',
  'workflow.bulk.requiredFieldsNotCompleted': 'هناك طلب واحد أو أكثر من الطلبات المحددة يحتوي على حقول مطلوبة لم تُستكمل.',
  'workflow.bulk.noLongerPending': 'هناك طلب واحد أو أكثر من الطلبات المحددة لم يعد بانتظار موافقتك.',
  'workflow.bulk.noValidPending': 'لم يتم العثور على طلبات معلقة صالحة للمعالجة.',
  'workflow.bulk.unexpectedNoChanges': 'حدث خطأ غير متوقع أثناء معالجة الطلبات. لم يتم تطبيق أي تغييرات.',
  'workflow.bulk.databaseError': 'خطأ في قاعدة البيانات',
  'workflow.bulk.alreadyApproved': 'تمت الموافقة مسبقًا',
  'workflow.bulk.alreadyRejected': 'تم الرفض مسبقًا',
  'tenant.error.workspaceNotResolved': 'لم يمكن حل مساحة العمل. يرجى التحقق من عنوان URL الخاص بمساحة العمل والمحاولة مرة أخرى.',
  'tenant.error.tenantCodeRequired': 'رمز المستأجر مطلوب. يرجى فتح صفحة تسجيل الدخول باستخدام عنوان URL الخاص بمساحة العمل.',
  'tenant.error.tenantConfigurationNotFound': 'لم يتم العثور على تكوين المستأجر. يرجى الاتصال بالمسؤول الخاص بك.',
  'common.savedSuccessfully': 'تم الحفظ بنجاح',
  'common.approved': 'مقبول',
  'common.rejected': 'مرفوض',
  'common.pending': 'معلق',
  'common.absent': 'غائب',
  'common.violation': 'مخالفة',
  'common.noviolation': 'بدون مخالفة',
  'common.rest_day': 'يوم راحة',
  'common.restday': 'يوم راحة',
  'common.holiday': 'عطلة',
  'common.eidAlAdha': 'عيد الأضحى',
  'common.present': 'حاضر',
  'common.present(no_violation)': 'حاضر (بدون مخالفة)',
  'common.wfh': 'عمل عن بُعد',
  'common.punchOut': 'خروج',
  'common.overtime': 'وقت إضافي',
  'common.early_out': 'خروج مبكر',
  'common.step_out': 'خروج مؤقت',
  'common.remote': 'عن بعد',
  'common.leave': 'إجازة',
  'common.afternoon shift': 'وردية بعد الظهر',
  'common.morning shift': 'وردية الصباح',
  'common.night shift': 'وردية الليل',
  'common.weekdays.sun': 'أحد',
  'common.weekdays.mon': 'اثنين',
  'common.weekdays.tue': 'ثلاثاء',
  'common.weekdays.wed': 'أربعاء',
  'common.weekdays.thu': 'خميس',
  'common.weekdays.fri': 'جمعة',
  'common.weekdays.sat': 'سبت',
  'common.employeesNoPlaceHolder': 'رقم الموظف  1, رقم الموظف 2',
  'common.missingRequiredField': 'يرجى ملء كافة الحقول المطلوبة',
  'common.recordDeleted': 'تم حذف السجل',
  'common.deleteFailed': 'فشل الحذف',
  'common.successfullyDeletedRecords': 'تم حذف {count} سجلات بنجاح',
  'common.someDeletesFailed': 'فشل حذف بعض السجلات',
  'common.missingId': 'رقم التعريف مفقود',
  'common.downloadComingSoon': 'خدمة التحميل ستكون متوفرة قريباً',
  'sidebar.form': 'باني النماذج',
  'common.by': 'حسب',
  'common.download': 'تحميل',
  'common.readMore': 'اقرأ المزيد',
  'common.readLess': 'اقرأ أقل',
  'assignWorkSchedule.addButtonText': 'تعيين',
  'common.rawHtml': 'نص HTML',
  'common.richText': 'نص منسق',
  'common.workDays': 'أيام العمل',
  'common.dailyScheduleType': 'نوع الجدول اليومي',
  'common.duration': 'المدة',
  'common.pageName': 'اسم الصفحة',
  'common.referenceId': 'رقم المرجع',
  'common.serialNumber': 'الرقم التسلسلي',
  'common.copy': 'نسخ',
  'notification.dropdown.title': 'الإشعارات',
  'notification.dropdown.readAll': 'قراءة الكل',
  'notification.dropdown.clear': 'مسح',
  'notification.dropdown.empty': 'لا توجد إشعارات',
  'notification.dropdown.loadingMore': 'جاري التحميل…',
  'notification.dropdown.scrollForMore': 'مرر للتحميل المزيد',
  'common.searchBy(EmployeeName,EmployeeNO)': 'بحث عن  (اسم الموظف,رقم الموظف)',
  'common.show': 'عرض',
  'common.from': 'من',
  'common.pleaseSelect': '-- الرجاء الاختيار --',
  'common.cardTemplate': 'قالب البطاقة',
  'common.selectTemplateToPreview': 'يرجى اختيار قالب البطاقة للمعاينة',
  'common.noPreviewAvailable': 'لا تتوفر معاينة',
  'common.print': 'طباعة',
  'common.printCard': 'طباعة البطاقة',
  'common.notification': 'نوع الإشعار',
  'common.fromDate': 'من التاريخ',
  'common.toDate': 'إلى التاريخ',
  'common.to': 'إلى',
  'employee.region': 'المنطقة',
  'common.week': 'أسبوع',
  'common.month': 'الشهر ',
  'common.january': 'يناير',
  'common.february': 'فبراير',
  'common.march': 'مارس',
  'common.april': 'أبريل',
  'common.may': 'مايو',
  'common.june': 'يونيو',
  'common.july': 'يوليو',
  'common.august': 'أغسطس',
  'common.september': 'سبتمبر',
  'common.october': 'أكتوبر',
  'common.november': 'نوفمبر',
  'common.december': 'ديسمبر',
  'common.fromTime': 'من الوقت',
  'common.toTime': 'إلى الوقت',
  'common.permissionType': 'نوع الإذن',
  'common.permission': 'إذن',
  'common.fieldsToUpdate':'الحقول للتحديث',
  'common.workInfo': 'معلومات العمل',
  'common.assignment': 'التعيين',
  "common.workflowFor":"سير العمل ل",
  'common.employee': 'الموظف',
  'common.employeeType': 'نوع الموظف',
  'common.requiredField': 'هذا الحقل مطلوب',
  'common.notificationType': 'نوع الإشعار',
  'common.escalateType': 'نوع الترقي',
  'common.entity': 'وحدة العمل',
  'common.subEntity': 'الوحدة الفرعية',
  'common.company': 'الشركة',
  'common.department': 'الإدارة',
  'common.group': 'المجموعة',
  'common.grade': 'الدرجة الوظيفية',
  'common.status': 'الحالة',
  'common.present': 'الحالي',
  'common.pendingWith': 'معلّق لدى',
  'common.groupTab': 'المجموعة',
  'common.requestType': 'نوع الطلب',
  'common.edit': 'تعديل',
  'common.save': 'حفظ',
  'common.saveChanges': 'حفظ التغييرات',
  'common.comingSoon': 'قريباً',
  'common.saving': 'جاري الحفظ',
  'common.unsavedChanges': 'تغييرات غير محفوظة',
  'common.unsavedChangesMessage': 'لديك تغييرات غير محفوظة. هل أنت متأكد من أنك تريد المغادرة؟',
  'common.testing': 'جاري الاختبار',
  'common.reset': 'إعادة تعيين',
  'common.fieldRequired': 'هذا الحقل مطلوب',
  'common.validPortRequired': 'يرجى إدخال رقم منفذ صحيح',
  'common.validEmailRequired': 'يرجى إدخال عنوان بريد إلكتروني صحيح',
  'common.emailConfigurationSaved': 'تم حفظ تكوين البريد الإلكتروني بنجاح',
  'common.configurationSaved': 'تم حفظ التكوين بنجاح',
  'common.emailTestSuccessful': 'تم إرسال اختبار البريد الإلكتروني بنجاح',
  'error.passwordOrApiKeyRequired': 'كلمة المرور أو مفتاح API مطلوب',
  'error.invalidEmailFormat': 'تنسيق البريد الإلكتروني غير صحيح',
  'error.invalidEmail': 'عنوان البريد الإلكتروني غير صالح',
  'error.requiredField': 'هذا الحقل مطلوب',
  'emailTestConnection.EMAIL_SENT': 'تم إرسال البريد الإلكتروني التجريبي بنجاح.',
  'emailTestConnection.SMTP_AUTH_FAILED': 'فشل التحقق. يرجى مراجعة اسم المستخدم وكلمة المرور.',
  'emailTestConnection.SMTP_HOST_UNREACHABLE': 'تعذّر الاتصال بخادم البريد. يرجى مراجعة العنوان والمنفذ.',
  'emailTestConnection.SMTP_SSL_ERROR': 'فشل الاتصال الآمن SSL/TLS. يرجى مراجعة إعداد SSL والمنفذ.',
  'emailTestConnection.SMTP_TIMEOUT': 'انتهت مهلة الاتصال. لم يستجب الخادم في الوقت المحدد.',
  'emailTestConnection.SMTP_MESSAGE_REJECTED': 'رفض الخادم إرسال الرسالة. يرجى مراجعة إعدادات SPF/DKIM.',
  'emailTestConnection.SMTP_MAILBOX_UNAVAILABLE': 'صندوق البريد غير متاح أو غير موجود.',
  'emailTestConnection.SMTP_ERROR': 'حدث خطأ في خادم البريد. يرجى مراجعة الإعدادات.',
  'emailTestConnection.INVALID_EMAIL_FORMAT': 'عنوان البريد الإلكتروني غير صحيح.',
  'emailTestConnection.UNEXPECTED_ERROR': 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.',
  'error.failedToSaveEmailConfiguration': 'فشل في حفظ تكوين البريد الإلكتروني',
  'error.couldNotLoadEmailConfiguration': 'تعذر تحميل تكوين البريد الإلكتروني',
  'error.emailTestFailed': 'فشل اختبار البريد الإلكتروني',
  'common.savedSuccessfully': 'تم الحفظ بنجاح',
  'common.delete': 'حذف',
  'lookup.dashboardConfiguration': 'تكوين لوحة المعلومات',
  'dashboard.configurationSaved': 'تم حفظ التكوين بنجاح',
  'dashboard.configurationSaveFailed': 'فشل حفظ التكوين',
  'dashboard.layoutConfigSaved': 'تم حفظ تكوين تخطيط لوحة المعلومات بنجاح',
  'dashboard.layoutConfigSaveFailed': 'فشل حفظ تكوين تخطيط لوحة المعلومات',
  'common.submit': 'إرسال',
  'common.tryAgain': 'حاول مرة أخرى',
  'common.typeID': 'معرف النوع',
  'common.cancel': 'إلغاء',
  'common.confirm': 'تأكيد',
  'common.employeeList': 'قائمة الموظفين',
  'common.selectedEmployee': 'الموظف المختار',
  'common.selectedEmployeeList': 'قائمة الموظفين المختارة',
  'common.search': 'بحث',
  'common.add': 'إضافة',
  'common.thisItem': 'هذا العنصر',
  'common.view':'منظر',
  'common.viewUser' :'عرض الموظف',
  'common.by': 'بواسطة',
  'common.to': 'إلى',
  'common.employees': 'الموظفين',
  'common.manager': 'المدير',
  'common.confirmation': 'تأكيد',
  'common.pleaseSelectAtLeastOneRecordToDelete': 'يرجى اختيار سجل واحد على الأقل لحذفه',
  'common.downloadConfirmMsg': 'هل تريد تحميل العناصر التالية؟',
  'common.itemsWillBeDownloaded': 'يتم تحميل {count} سجلات بنجاح',
  'common.ok': 'موافق',
  'common.addCompany': 'إضافة شركة',
  'common.editCompany': 'تعديل شركة',
  'common.logo': 'شعار',
  'common.reportLogo': 'شعار التقرير',
  'common.noImage': 'لا توجد صورة',
  'common.startRecording': 'بدء التسجيل',
  'common.loading': 'جارٍ التحميل...',
  'common.copy': 'نسخ',
  'common.exportPDF': 'تصدير PDF',
  'common.exportCSV': 'تصدير Excel',
  'common.importData': 'استيراد البيانات',
  'common.allRecordExportPDF': 'سيتم تصدير جميع العناصر إلى PDF.',
  'common.allRecordExportCSV': 'سيتم تصدير جميع العناصر إلى ملف CSV.',
  'common.allRecordImport': 'سيتم استيراد جميع العناصر.',
  'common.confirmActionMsg': 'هل أنت متأكد أنك تريد القيام بهذا الإجراء؟',
  'common.itemsWillBeDownloaded': 'سيتم تحميل {count} عنصر/عناصر.',
  'common.itemWillBeCopied': 'سيتم نسخ {count} عنصر/عناصر.',
  'common.areYouSure': 'هل أنت متأكد؟',
  'common.deleteConfirm': 'تأكيد الحذف',
  'common.deleteConfirmMsg': 'هل أنت متأكد أنك تريد حذف {name}؟',
  'common.bulkDeleteConfirmMsg': 'هل أنت متأكد أنك تريد حذف {count} سجل(ات)؟',
  'common.validationError': 'خطأ في التحقق',
  'common.selectAtLeastOneField': 'يرجى اختيار حقل واحد على الأقل للتحديث',
  'common.alreadyExists': 'موجود بالفعل',
  'common.montlyLimitHH': 'الحد الشهري (بالساعة)',
  'common.montlyLimitMM': 'الحد الشهري (بالدقيقة)',
  'common.import': 'استيراد',
  'common.add schedule': 'إضافة جدول',
  'common.employeeNo': 'رقم الموظف',
  'common.duration': 'المدة (دقائق)',
  'common.retrieve': 'استرجاع',
  'common.close': 'إغلاق',
  'common.ok': 'نعم',
  'common.minute': 'دقيقة',
  'common.minutes': 'دقائق',
  'common.pleaseSelectFile': 'مطلوب',
  'common.onlyExcelFilesAllowed': 'يسمح فقط بملفات Excel (.xlsx, .xls)',
  'common.downloadTemplateError': 'فشل تحميل القالب. يرجى المحاولة مرة أخرى.',
  'common.downloadExcelTemplate': 'تحميل قالب Excel',
  'common.loadingTemplate': 'جاري تحميل القالب...',
  'common.fileParseError': 'فشل في تحليل ملف Excel',
  'common.fileReadError': 'فشل في قراءة الملف',
  'common.verify': 'تحقق',
  'common.verifying': 'جاري التحقق...',
  'common.allRecordsVerified': 'تم التحقق من جميع السجلات',
  'common.noDataToImport': 'لا توجد بيانات للاستيراد',
  'common.importError': 'فشل الاستيراد',
  'common.importSuccess': 'تم استيراد البيانات بنجاح',
  'common.importSuccessWithCount': '{successCount}/{totalRows} سجل تم استيراده.',
  'common.hour': 'ساعة',
  'common.uploadedFile': 'تم تحميل الملف',
  'common.excelFile': 'ملف Excel',
  'common.records': 'سجلات',
  'common.templateNotFound': 'القالب غير موجود. يرجى الاتصال بالمسؤول لإعداد القالب.',
  'common.hours': 'ساعات',
  'common.next': 'التالي',
  'common.previous': 'السابق',
  'common.page': 'صفحة',
  'common.of': 'من',
  'common.recordDeleted': 'تم حذف السجل',
  'common.deleteFailed': 'فشل الحذف',
  'common.successfullyDeletedRecords': 'تم حذف {count} سجل(ات) بنجاح',
  'common.someDeletesFailed': 'فشل حذف بعض السجلات',
  'common.missingId': 'المعرف مفقود.',
  'common.managerName': 'اسم المدير',
  'common.avatar': 'الصورة الشخصية',
  'common.error': 'خطأ',
  'common.unknown': 'غير معروف',
  'common.workLocation': 'موقع العمل',
  'common.lat': 'خط العرض',
  'common.long': 'خط الطول',
  'common.mapUrl': 'رابط الخريطة',
  'common.radius': 'نصف القطر',
  'common.time': 'الوقت',
  'common.remoteWork': 'العمل عن بُعد',
  'common.addRemoteEntry': 'إضافة سجل عمل عن بعد',
  'common.count': 'العدد',
  'common.count>=': 'العدد >=',
  'common.totalDays': 'إجمالي الأيام',
  'common.manager': 'المدير',
  'common.delegation': 'التفويض',
  'common.absentRuleDurationPlaceholder': 'المدة (س:د)',
  'common.absentRuleDurationTooltipExample': 'أدخل المدة (HH:MM)، مثال: 01:30 = ساعة و30 دقيقة',
  'common.absentRuleDurationTooltip': 'أدخل المدة (HH:MM) وليس وقتاً محدداً',
  'common.designationID': 'المسمى الوظيفي',
  'common.startDate': 'تاريخ البدء',
  'common.endDate': 'تاريخ الانتهاء',
  'common.keyword': 'الكلمة المفتاحية',
  'common.id': 'بطاقة تعريف',
  'common.icon': 'الأيقونة',
  'common.code': 'الكود',
  'common.nameArabic': 'الاسم العربي',
  'common.nameEnglish': 'الاسم الإنجليزي',
  'common.nameAr': 'الاسم (بالعربية)',
  'common.nameEn': 'الاسم (بالإنجليزية)',
  'common.na': 'غير متوفر',
  'common.timeZone': 'المنطقة الزمنية',
  'unauthorized.title': 'محاولة وصول غير مصرح بها',
  'unauthorized.detail': 'ليس لديك صلاحية لعرض الصفحة التي تحاول الوصول إليها.',
  'Go back to Home': 'العودة إلى الصفحة الرئيسية',

  'attendanceDuration.iconDefault': 'افتراضي',
  'attendanceDuration.iconEvening': 'مساء',
  'attendanceDuration.iconMorning': 'صباح',
  'attendanceDuration.iconAfternoon': 'بعد الظهر',
  'attendanceDuration.iconMidnight': 'منتصف الليل',

  'recalculateAttendance.error.dateRangeOverlap':
    'يتداخل نطاق التاريخ مع إجراء إعادة احتساب موجود مسبقاً.',
  'common.lastUpdatedDate': 'تاريخ آخر تحديث',
  'common.createdDate': 'تاريخ الإنشاء',
  'common.createdOn': 'تاريخ الإنشاء',
  'common.trackingRequest': 'تتبع الطلب',
  'common.leaveRequest': 'طلب إجازة',
  'common.permissionRequest': 'طلب إذن',
  'common.remoteWorkRequest': 'طلب عمل عن بعد',
  'common.manualEntryRequest': 'طلب إدخال يدوي',
  'common.fromDate': 'من تاريخ',
  'common.toDate': 'إلى تاريخ',
  'dashboard.employeeCalendar.title': 'تقويم الموظفين',
  'dashboard.customizeLayout': 'تخصيص تخطيط لوحة المعلومات',
  'dashboard.customizeLayoutDescription': 'قم بتبديل المفاتيح أدناه لإظهار أو إخفاء البطاقات في لوحة المعلومات الخاصة بك. يتم حفظ تفضيلاتك تلقائياً.',
  'dashboard.shiftScheduleBar': 'شريط الوردية / الجدول',
  'dashboard.overviewCards': 'بطاقات النظرة العامة',
  'dashboard.attendanceTimeline': 'الخط الزمني للحضور',
  'dashboard.shiftOverview': 'نظرة عامة على الوردية',
  'dashboard.attendanceOverview': 'نظرة عامة على الحضور',
  'dashboard.addonCards': 'بطاقات الإضافات',
  'dashboard.quickActions': 'الإجراءات السريعة',
  'dashboard.attendanceCalendar': 'تقويم الحضور',
  'dashboard.stateSelected': 'محدد',
  'dashboard.stateAllowed': 'مسموح',
  'dashboard.stateDisabled': 'معطّل',
  'dashboard.wfh.title': 'العمل عن بعد',
  'dashboard.wfh.subtitle': 'تمت الموافقة على عملك عن بعد اليوم.',
  'dashboard.wfh.approved': 'تمت الموافقة على العمل عن بعد',
  'dashboard.wfh.validFor': 'صالح لتاريخ',
  'dashboard.wfh.requestDate': 'تاريخ الطلب',
  'dashboard.wfh.approvedBy': 'تمت الموافقة بواسطة',
  'dashboard.wfh.validDate': 'تاريخ الصلاحية',
  'dashboard.wfh.clockIn': 'تسجيل حضور',
  'dashboard.wfh.clockInSubtitle': 'ابدأ يوم عملك',
  'dashboard.wfh.clockOut': 'تسجيل انصراف',
  'dashboard.wfh.clockOutSubtitle': 'أنهِ يوم عملك',
  'dashboard.wfh.completedForToday': 'تم تسجيل الحضور والانصراف لهذا اليوم',
  'dashboard.wfh.punchInSuccess': 'تم تسجيل الحضور بنجاح',
  'dashboard.wfh.punchOutSuccess': 'تم تسجيل الانصراف بنجاح',
  'dashboard.wfh.error.invalidPunchType': 'نوع تسجيل غير صالح.',
  'dashboard.wfh.error.punchTodayOnly': 'يُسمح بالتسجيل لليوم الحالي فقط.',
  'dashboard.wfh.error.noApprovedRequest': 'لا يوجد طلب عمل عن بعد معتمد لهذا اليوم.',
  'dashboard.wfh.error.onlinePunchDisabled': 'تسجيل الحضور/الانصراف الإلكتروني غير مفعّل.',
  'dashboard.wfh.error.noWorkingSchedule': 'لا يوجد جدول عمل محدد لهذا اليوم.',
  'dashboard.wfh.error.outsideSchedule': 'وقت التسجيل خارج جدول العمل لهذا اليوم.',
  'dashboard.wfh.error.alreadyCheckedIn': 'تم تسجيل الحضور مسبقًا لهذا اليوم.',
  'dashboard.wfh.error.alreadyCheckedOut': 'تم تسجيل الانصراف مسبقًا لهذا اليوم.',
  'dashboard.wfh.error.checkOutRequired': 'تم تسجيل الحضور بالفعل. يلزم تسجيل الانصراف.',
  'dashboard.wfh.error.checkInRequired': 'يلزم تسجيل الحضور قبل تسجيل الانصراف.',
  'dashboard.wfh.error.alreadyCompleted': 'تم تسجيل الحضور والانصراف بالفعل لهذا اليوم.',
  'dashboard.wfh.error.recalcNotConfigured': 'هذه الميزة غير مُهيأة بالكامل بعد. يرجى التواصل مع المسؤول.',
  'dashboard.wfh.error.databaseError': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'dashboard.component': 'المكوّن',
  'appLayout.resetConfiguration': 'إعادة تعيين الإعدادات',
  'appLayout.submit': 'إرسال',
  'common.justification': 'التبرير',
  'common.approval level': 'مستوى الموافقة',
  'common.purpose': 'الغرض',
  'common.nameAr': 'الاسم آر',
  'common.nameEn': 'الاسم إن',

  'common.refresh': 'تحديث',
  'common.serverTime': 'توقيت الخادم',
  'common.remove': 'إزالة',
  'common.back': 'رجوع',

  'dashboard.employeeCalendar.tabs.month': 'شهر',
  'dashboard.employeeCalendar.tabs.week': 'أسبوع',
  'dashboard.employeeCalendar.tabs.day': 'يوم',
  'common.scheduleType': 'نوع الجدول',
  'common.permissionTypeID': 'نوع الإذن',
  'common.isActive': 'فعّال',
  'common.isDefault': 'افتراضي',
  'common.Monday': 'الاثنين',
  'employee.terminationDate': 'تاريخ إنهاء الخدمة',
  'common.joiningDate': 'تاريخ الانضمام',
  'common.showDetails': 'عرض التفاصيل',
  'common.designation': 'المسمى الوظيفي',
  'common.jobGrade': 'الدرجة الوظيفية',
  'common.notAvailable': 'غير متوفر',
  'common.nextActionBy': 'الإجراء التالي بواسطة',
  'common.branding_AppName': 'اسم التطبيق للعلامة التجارية',
  'common.branding_PrimaryColor': 'اللون الأساسي للعلامة التجارية',
  'common.branding_LogoUrl': 'رابط شعار العلامة التجارية',
  'common.reportLogo': 'شعار التقرير',
  'common.backDateBuffer': 'المخزن المؤقت للتاريخ السابق',
  'common.companyType': 'نوع الشركة',
  'common.noOfLocations': 'عدد المواقع',
  'common.companySize': 'حجم الشركة',
  'common.addCompany': 'إضافة شركة',
  'common.editCompany': 'تعديل الشركة',
  'common.categoryID': 'الفئة',
  'common.Tuesday': 'الثلاثاء',
  'common.Wednesday': 'الأربعاء',
  'common.Thursday': 'الخميس',
  'common.Friday': 'الجمعة',
  'common.Saturday': 'السبت',
  'common.Sunday': 'الأحد',
  'common.mon': 'اثنين',
  'common.tue': 'ثلاثاء',
  'common.wed': 'أربعاء',
  'common.thu': 'خميس',
  'common.fri': 'جمعة',
  'common.sat': 'سبت',
  'common.sun': 'أحد',
  'common.full-request': 'عرض الطلب كاملا',
  'common.workHours': 'ساعات العمل',
  'common.day': 'اليوم',
  'common.ok': 'موافق',
  'common.cancel': 'إلغاء',
  'common.Ramdan-Period': 'فترة رمضان',
  'common.Holiday-Period': 'فترة العطلة',
  'common.organizationHierarchy': 'التسلسل الهرمي للمنظمة',

  'dashboard.hr.employeeCountOverview.employeeDetailsTitle': 'تفاصيل الموظف',
  'dashboard.hr.employeeCountOverview.showDetails': 'عرض التفاصيل',
  'dashboard.hr.employeeCountOverview.status.present': 'حاضر',
  'dashboard.hr.employeeCountOverview.status.presentNoViolation': 'حاضر (بدون مخالفة)',
  'dashboard.hr.employeeCountOverview.status.absent': 'غائب',
  'dashboard.hr.employeeCountOverview.status.leave': 'إجازة',
  'dashboard.hr.employeeCountOverview.status.delay': 'تأخير',
  'dashboard.hr.employeeCountOverview.status.ontime': 'في الوقت المحدد',
  'dashboard.hr.employeeCountOverview.status.remote': 'العمل عن بعد',
  'dashboard.hr.employeeCountOverview.status.earlyOut': 'خروج مبكر',
  'dashboard.hr.employeeCountOverview.status.violation': 'مخالفة',
  'dashboard.hr.employeeCountOverview.status.holiday': 'عطلة',
  'dashboard.hr.employeeCountOverview.status.restDay': 'يوم راحة',
  'dashboard.hr.employeeCountOverview.status.permission': 'إذن',
  'dashboard.hr.overallStatistics.title': 'إحصائيات عامة',
  'dashboard.hr.weeklyAttendanceStatistics.title': 'إحصائيات الحضور',
  'dashboard.hr.todayPunchStatistics.title': 'إحصائيات البصمة',
  'dashboard.hr.todayPunchStatistics.tooltipTitle': 'ملخص',
  'dashboard.hr.todayPunchStatistics.labels.punchOut': 'تسجيل الخروج',
  'dashboard.hr.todayPunchStatistics.labels.present': 'حاضر',
  'dashboard.hr.todayPunchStatistics.labels.wfh': 'عمل من المنزل',
  'dashboard.hr.todayPunchStatistics.labels.leave': 'إجازة',
  'dashboard.hr.todayPunchStatistics.labels.absent': 'غائب',
  'dashboard.hr.todayPunchStatistics.labels.exception': 'استثناء',
  'dashboard.hr.todayPermissionStatistics.title': 'إحصائيات الأذونات',
  'dashboard.hr.leaveStatistics.title': 'إحصائيات الإجازات',
  'dashboard.hr.leaveStatistics.description': 'نظرة عامة على طلبات الإجازات حسب الحالة.',
  'dashboard.hr.leaveStatistics.labels.approved': 'موافق عليها',
  'dashboard.hr.leaveStatistics.labels.requested': 'مطلوبة',
  'dashboard.hr.leaveStatistics.labels.pending': 'قيد الانتظار',
  'dashboard.hr.punchInOutStatistics.title': 'إحصائيات تسجيل الدخول والخروج',
  'dashboard.hr.punchInOutStatistics.description': 'نظرة عامة على سجلات أول دخول وآخر خروج للموظفين.',
  'dashboard.hr.punchInOutStatistics.labels.firstIn': 'دخول الموظفين',
  'dashboard.hr.punchInOutStatistics.labels.lastOut': 'خروج الموظفين',
  'dashboard.hr.title': 'لوحة معلومات الموارد البشرية',
  'dashboard.hr.calendar.showCalendar': 'عرض التقويم الكامل',
  'dashboard.hr.calendar.closeCalendar': 'إإغلاق التقويم',
  'dashboard.hr.calendar.filterProcess': 'عملية التصفية',
  'dashboard.hr.calendar.details': 'التفاصيل',
  'dashboard.hr.calendar.workLocation': 'موقع العمل',
  'dashboard.hr.calendar.group': 'المجموعة',
  'dashboard.hr.calendar.entity': 'وحدة العمل',
  'dashboard.hr.employeeDetails.columns.employeeName': 'اسم الموظف',
  'dashboard.hr.employeeDetails.columns.workDate': 'تاريخ العمل',
  'dashboard.hr.employeeDetails.columns.employeeNo': 'رقم الموظف',

  'dashboard.absenteeism.overview.title': 'نظرة عامة على الغياب (تنفيذي / رئيس الموارد البشرية)',
  'dashboard.absenteeism.overview.subtitle': 'راقب مؤشرات الغياب والاتجاهات وأداء الأقسام باستخدام أحدث بيانات الحضور.',
  'dashboard.absenteeism.filters.targetGroupLabel': 'تصفية هدف الغياب',
  'dashboard.absenteeism.filters.entity': 'وحدة العمل',
  'dashboard.absenteeism.filters.location': 'الموقع',
  'dashboard.absenteeism.filters.from': 'من',
  'dashboard.absenteeism.filters.to': 'إلى',

  'dashboard.absenteeism.kpi.absenteeismRate': 'معدل الغياب (%)',
  'dashboard.absenteeism.kpi.totalAbsentDays': 'إجمالي أيام الغياب',
  'dashboard.absenteeism.kpi.violations': 'المخالفات',
  'dashboard.absenteeism.kpi.avgAbsencePerEmployee': 'متوسط الغياب / موظف',
  'dashboard.absenteeism.kpi.policyVsActualGap': 'الفجوة بين السياسة والفعلي',
  'dashboard.absenteeism.kpi.actualAbsentDays': 'أيام الغياب الفعلية',
  'dashboard.absenteeism.kpi.policyAbsentDays': 'أيام الغياب حسب السياسة',
  'dashboard.absenteeism.kpi.lateArrivalCount': 'عدد حالات التأخير',
  'dashboard.absenteeism.kpi.earlyDepartureCount': 'عدد حالات الانصراف المبكر',
  'dashboard.absenteeism.kpi.totalAttendanceViolations': 'إجمالي مخالفات الحضور',

  'dashboard.absenteeism.kpiTooltips.absenceRate':
    'نسبة الغياب الإجمالية خلال الفترة المحددة مع استبعاد أيام العطل الرسمية وأيام الراحة. تعكس مستوى انضباط الحضور وتأثيره على الإنتاجية.',
  'dashboard.absenteeism.kpiTooltips.totalAbsenceDays':
    'إجمالي أيام العمل المفقودة بسبب غياب الموظفين خلال الفترة المحددة.',
  'dashboard.absenteeism.kpiTooltips.actualAbsenceDays':
    'أيام الغياب الفعلية غير المخطط لها والتي قد تؤثر على استمرارية العمليات التشغيلية.',
  'dashboard.absenteeism.kpiTooltips.policyAbsenceDays':
    'أيام الغياب المسجلة وفق سياسات الشركة أو الاستثناءات المعتمدة.',
  'dashboard.absenteeism.kpiTooltips.averageAbsencePerEmployee':
    'متوسط عدد أيام الغياب لكل موظف. يساعد في تقييم اتجاهات الأداء والانضباط الوظيفي.',
  'dashboard.absenteeism.kpiTooltips.lateArrivalCount':
    'إجمالي حالات التأخير عن الدوام. يعكس مستوى الالتزام بالمواعيد وكفاءة إدارة الوقت.',
  'dashboard.absenteeism.kpiTooltips.earlyDepartureCount':
    'إجمالي حالات الانصراف المبكر قبل انتهاء ساعات العمل الرسمية.',
  'dashboard.absenteeism.kpiTooltips.totalAttendanceViolations':
    'إجمالي جميع مخالفات الحضور (التأخير، الانصراف المبكر، ومخالفات السياسات). يعكس مستوى الالتزام العام بأنظمة الحضور والانضباط المؤسسي.',
  'dashboard.absenteeism.kpi.daysSuffix': ' يوم',
  'dashboard.absenteeism.kpi.totalAbsentDays.subLabel': '{actual} فعلي / {policy} سياسة',
  'dashboard.absenteeism.kpi.violations.subLabel': '{delay} تأخير / {earlyOut} انصراف مبكر',
  'dashboard.absenteeism.kpi.policyVsActualGap.subLabel': 'الإيجابي يدل على سعة متاحة',

  'dashboard.absenteeism.charts.trend.title': 'اتجاه الغياب (مخطط خطي)',
  'dashboard.absenteeism.charts.absenceByType.title': 'الغياب حسب النوع (رسم بياني دائري)',
  'dashboard.absenteeism.charts.topDepartments.title': 'أعلى الأقسام حسب معدل الغياب',
  'dashboard.absenteeism.charts.departmentAbsenceRate.title': 'معدل الغياب حسب القسم',
  'dashboard.absenteeism.charts.managerAbsenceRate.title': 'معدل الغياب حسب المدير',
  'dashboard.absenteeism.charts.heatmap.title': 'القسم مقابل أيام الأسبوع (خريطة حرارية)',
  'dashboard.absenteeism.charts.shiftWiseComparison.title': 'مقارنة الغياب حسب الشفت',
  'dashboard.absenteeism.charts.dayOfWeekPattern.title': 'نمط الغياب حسب أيام الأسبوع',
  'dashboard.absenteeism.charts.prePostHoliday.title': 'الغياب قبل/بعد العطلة',
  'dashboard.absenteeism.charts.highRiskCount.title': 'عدد الموظفين عالي الخطورة',
  'dashboard.absenteeism.charts.repeatAbsenteesTrend.title': 'اتجاه الغياب المتكرر',
  'dashboard.absenteeism.risk.title': 'لوحة نمط الغياب والمخاطر',

  'dashboard.absenteeism.series.currentYear': 'السنة الحالية',
  'dashboard.absenteeism.series.previousYear': 'السنة السابقة',
  'dashboard.absenteeism.series.absenceRate': 'معدل الغياب',
  'dashboard.absenteeism.series.absencePercent': 'نسبة الغياب %',
  'dashboard.absenteeism.series.absences': 'حالات الغياب',
  'dashboard.absenteeism.series.employees': 'الموظفون',
  'dashboard.absenteeism.series.repeatAbsentees': 'الغياب المتكرر',

  'dashboard.absenteeism.empty.noData': 'لا توجد بيانات',
  'dashboard.absenteeism.empty.noKpi': 'لا توجد بيانات مؤشرات',
  'dashboard.absenteeism.empty.noTrend': 'لا توجد بيانات اتجاه للتصفية المحددة',
  'dashboard.absenteeism.empty.noTypeBreakdown': 'تفاصيل أنواع الغياب غير متاحة',
  'dashboard.absenteeism.empty.noDepartmentRate': 'معدل غياب الأقسام غير متاح',
  'dashboard.absenteeism.empty.noDepartmentRateData': 'لا توجد بيانات لمعدل الغياب حسب القسم',
  'dashboard.absenteeism.empty.noManagerRateData': 'لا توجد بيانات لمعدل الغياب حسب المدير',
  'dashboard.absenteeism.empty.noHeatmap': 'لا توجد بيانات للخريطة الحرارية',
  'dashboard.absenteeism.empty.noRepeatMonthly': 'لا توجد بيانات للغياب المتكرر',

  'dashboard.absenteeism.fallback.metric': 'مؤشر',
  'dashboard.absenteeism.fallback.month': 'شهر {number}',
  'dashboard.absenteeism.fallback.type': 'نوع {number}',
  'dashboard.absenteeism.fallback.department': 'قسم {number}',

  'dashboard.absenteeism.holiday': 'عطلة',
  'dashboard.absenteeism.days.sun': 'الأحد',
  'dashboard.absenteeism.days.mon': 'الاثنين',
  'dashboard.absenteeism.days.tue': 'الثلاثاء',
  'dashboard.absenteeism.days.wed': 'الأربعاء',
  'dashboard.absenteeism.days.thu': 'الخميس',
  'dashboard.absenteeism.days.fri': 'الجمعة',
  'dashboard.absenteeism.days.sat': 'السبت',

  'dashboard.absenteeism.months.jan': 'يناير',
  'dashboard.absenteeism.months.feb': 'فبراير',
  'dashboard.absenteeism.months.mar': 'مارس',
  'dashboard.absenteeism.months.apr': 'أبريل',
  'dashboard.absenteeism.months.may': 'مايو',
  'dashboard.absenteeism.months.jun': 'يونيو',
  'dashboard.absenteeism.months.jul': 'يوليو',
  'dashboard.absenteeism.months.aug': 'أغسطس',
  'dashboard.absenteeism.months.sep': 'سبتمبر',
  'dashboard.absenteeism.months.oct': 'أكتوبر',
  'dashboard.absenteeism.months.nov': 'نوفمبر',
  'dashboard.absenteeism.months.dec': 'ديسمبر',

  'dashboard.absenteeism.riskLevels.chronic': 'مزمن',
  'dashboard.absenteeism.riskLevels.atRisk': 'معرض للخطر',
  'dashboard.absenteeism.riskLevels.normal': 'طبيعي',

  'dashboard.absenteeism.fallback.manager': 'مدير {number}',
  'dashboard.absenteeism.fallback.status': 'حالة {number}',

  'dashboard.absenteeism.drilldown.modalTitle': 'تفاصيل غياب الموظفين',
  'dashboard.absenteeism.drilldown.titleWithSource': '{source}',
  'dashboard.absenteeism.drilldown.tableTitle': 'جدول غياب الموظفين',
  'dashboard.absenteeism.drilldown.sectionTitle': 'تفاصيل غياب الموظف (عمليات الموارد البشرية)',
  'dashboard.absenteeism.drilldown.columns.id': 'المعرف',
  'dashboard.absenteeism.drilldown.columns.name': 'الاسم',
  'dashboard.absenteeism.drilldown.columns.department': 'القسم',
  'dashboard.absenteeism.drilldown.columns.totalDays': 'إجمالي الأيام',
  'dashboard.absenteeism.drilldown.columns.unauthorized': 'غير مصرح',
  'dashboard.absenteeism.drilldown.columns.consecutive': 'متتالي',
  'dashboard.absenteeism.drilldown.columns.lastAbsence': 'آخر غياب',
  'dashboard.absenteeism.drilldown.columns.pattern': 'النمط',

  'dashboard.absenteeism.hrbp.title': 'تحليل الأقسام (شريك أعمال الموارد البشرية)',
  'dashboard.absenteeism.drilldown.sources.trend': 'اتجاه الغياب',
  'dashboard.absenteeism.drilldown.sources.type': 'الغياب حسب النوع',
  'dashboard.absenteeism.drilldown.sources.topDepartments': 'أعلى الأقسام حسب معدل الغياب',
  'dashboard.absenteeism.drilldown.sources.departmentRate': 'معدل الغياب حسب القسم',
  'dashboard.absenteeism.drilldown.sources.managerRate': 'معدل الغياب حسب المدير',
  'dashboard.absenteeism.drilldown.sources.heatmap': 'القسم مقابل أيام الأسبوع (خريطة حرارية)',
  'dashboard.absenteeism.drilldown.sources.shiftWise': 'مقارنة الغياب حسب الشفت',
  'dashboard.absenteeism.drilldown.sources.dayOfWeek': 'نمط الغياب حسب أيام الأسبوع',
  'dashboard.absenteeism.drilldown.sources.prePostHoliday': 'الغياب قبل/بعد العطلة',
  'dashboard.absenteeism.drilldown.sources.highRisk': 'عدد الموظفين عاليي الخطورة',
  'dashboard.absenteeism.drilldown.sources.repeatTrend': 'اتجاه الغياب المتكرر',
  'common.flexDuration': 'المدة المرنة',
  'common.graceIn': 'وقت الدخول المسموح',
  'common.graceOut': 'وقت الخروج المسموح',
  'common.checkIn': 'تسجيل الدخول',
  'common.checkOut': 'تسجيل الخروج',
  'common.showMore': 'عرض المزيد',
  'common.showLess': 'عرض أقل',
  'common.viewAll': 'عرض الكل',
  'common.bufferBeforeStartTimeHhMm': 'الوقت الاحتياطي قبل وقت البدء (HH:MM)',
  'common.bufferAfterEndTimeHhMm': 'الوقت الاحتياطي بعد وقت الانتهاء (HH:MM)',
  'common.workedHours': 'ساعات العمل',
  'common.maxStepOutDuration': 'أقصى مدة للخروج',
  'common.numOutAttempts': 'عدد محاولات الخروج',
  'common.priority': 'الأولوية',
  'common.considerAsAbsent': 'يعتبر غائباً',
  'common.workingHourLess': 'إذا كانت ساعات العمل أقل من',
  'common.punchInAfter': 'إذا كانت البصمة الأولى بعد',
  'common.lastPunchOutBefore': 'إذا كانت آخر بصمة خروج قبل',
  'common.minDurApply': 'الحد الأدنى للمدة للتطبيق',
  'common.maxDurApply': 'الحد الأقصى للمدة للتطبيق',
  'common.minWorkingHoursApply': 'أقل ساعات عمل للتطبيق',
  'common.beforeSchedule': 'حساب الإضافي قبل الجدول',
  'common.afterSchedule': 'حساب الإضافي بعد الجدول',
  'common.overtimeBefore': 'إضافي قبل',
  'common.overtimeUntil': 'إضافي حتى',
  'common.selectColor': 'اختر اللون',
  'common.minutes': 'الدقائق',
  'common.remainingDuration': 'المدة المتبقية',
  'common.update': 'تعديل',
  'common.updating': 'تحديث',
  'common.employees': 'الموظفون',
  'common.temporary': 'مؤقت',
  'common.assign': 'تعيين',
  'common.nationality': 'الجنسية',
  'common.schedules': 'جداول الدوام',
  'common.type': 'النوع',
  'common.reader': 'القارئ',
  'common.action': 'الإجراء',
  'common.missingReaderTransaction': 'حركات القارئ مفقودة',
  'common.missingInOut': 'حركة دخول/خروج مفقودة',
  'common.transaction': 'الحركة',
  'common.violation': 'المخالفة',
  'common.userTypeID': 'دور المستخدم',
  'common.absentPolicy': 'سياسة الغياب',
  'common.absent': 'غياب',
  'common.leave': 'إجازة',
  'common.late': 'تأخر',
  'common.earlyOut': 'انصراف مبكر',
  'common.offDay': 'يوم راحة',
  'common.ongoing': 'مستمر',
  'common.department': 'القسم',
  'common.currentDepartment': 'القسم الحالي',
  'common.calendar': 'التقويم',
  'calendar.fromLabel': 'من',
  'calendar.toLabel': 'إلى',
  'calendar.today': 'اليوم',
  'calendar.yesterday': 'أمس',
  'calendar.thisWeek': 'هذا الأسبوع',
  'calendar.lastWeek': 'الأسبوع الماضي',
  'calendar.thisMonth': 'هذا الشهر',
  'calendar.lastMonth': 'الشهر الماضي',
  'calendar.daysUpToToday': 'أيام حتى اليوم',
  'calendar.daysStartingToday': 'أيام تبدأ من اليوم',
  'common.enabled': 'مُمكّن',
  'common.remarks': 'ملاحظات',
  'common.employeeName': 'اسم الموظف',
  'common.employeeId': 'الرقم الوظيفي',
  'common.transactionType': 'نوع الحركة',
  'common.dateTime': 'التاريخ/الوقت',
  'common.exceptionType': 'نوع الاستثناء',
  'common.clear': 'مسح',
  'common.clearAll': 'مسح الكل',
  'common.filters': 'عوامل التصفية',
  'common.addFilter': 'إضافة فلتر',
  'common.clearFilters': 'مسح عوامل التصفية',
  'common.dynamicTableColumn': 'أعمدة الجدول الديناميكي',
  'common.applyFilters': 'تطبيق عوامل التصفية',
  'common.enableAllColumns': 'تمكين جميع الأعمدة',
  'common.fixToLeft': 'تثبيت إلى اليسار',
  'common.unnamedColumn': 'عمود بدون اسم',
  'common.descending': 'تنازلي',
  'common.ascending': 'تصاعدي',
  'common.sortBy': 'فرز حسب',
  'common.noData': 'لا توجد بيانات',
  'common.noDataAvailable': 'لا توجد بيانات متاحة.',
  'common.itemsRange': 'عرض {start} إلى {end} من {total}',
  'common.showingDataCount': 'عرض {count} من {total} بيانات',
  'common.loadMore': 'تحميل المزيد',
  'common.selectedOutOf': 'المحدد: {selected} من {total}',
  'common.selected': 'المحدد',
  'common.name': 'الاسم',
  'common.roleID': 'دور المستخدم',
  'common.companyID': 'اسم الشركة',
  'common.phone': 'الهاتف',
  'common.mobile': 'الجوال',
  'common.mobileNo': 'الجوال',
  'common.durationDays': 'المدة بالأيام',
  'common.cancel': 'إلغاء الأمر',
  'common.dob': 'تاريخ الميلاد',
  'common.createdDate': 'تاريخ الإنشاء',
  'common.timeDuration': 'المدة',
  'common.remark': 'الملاحظات',
  'common.fromYear': 'من العام',
  'common.toYear': 'إلى العام',
  'common.exportData': 'تصدير البيانات',
  'common.subject': 'الموضوع',
  'common.subjectEn': 'الموضوع اللغة الإنجليزية',
  'common.subjectAr': 'الموضوع عربي',
  'common.schedule': 'جدول الدوام',
  'common.login': 'تسجيل الدخول',
  'common.logout': 'تسجيل الخروج',
  'roleAccessRemoved.title': 'تمت إزالة صلاحياتك',
  'roleAccessRemoved.message': 'لم تعد لديك صلاحيات على هذا الدور. سيتم تسجيل خروجك خلال {seconds} ثانية.',
  'common.loginConfigurationSaved': 'تم حفظ إعدادات تسجيل الدخول بنجاح',
  'common.email': 'البريد الإلكتروني',
  'common.companyEmail': 'البريد الإلكتروني للشركة',
  'common.employeeOnboardingWelcomeMessage': 'رسالة ترحيب الموظف الجديد',
  'common.sendEmployeeWelcomeEmail': 'إرسال بريد ترحيب للموظف',
  'common.submissionDate': 'تاريخ التقديم',
  'common.showDetails': 'عرض التفاصيل',
  'common.notAvailable': 'غير متاح',
  'common.downloadData': 'تحميل البيانات',
  'common.error': 'خطأ',
  'common.requestFailed': 'فشل الطلب',
  'common.loading': 'جار التحميل...',
  'common.saving': 'جاري الحفظ...',
  'common.worked': 'تم العمل',
  'common.remaining': 'المتبقي',
  'common.violations': 'المخالفات',
  'common.delay': 'تأخير',
  'common.stepOut': 'خروج مؤقت',
  'common.overtime': 'عمل إضافي',
  'common.work': 'عمل',
  'common.present': 'حاضر',
  'common.count': 'العدد',
  'common.percentage': 'النسبة المئوية',
  'common.date': 'التاريخ',
  'common.workdate': 'تاريخ العمل',
  'common.violation': 'المخالفات',
  'common.transaction': 'الحركات',
  'common.details': 'تفاصيل', 
  'common.history': 'السجل',
  'common.requestName': 'اسم الطالب',
  'common.daysCount': 'عدد الايام',
  'common.actions': 'العمليات',
  'common.first': 'الاول',
  'common.last': 'الاخير',
  'common.selectAll': 'تحديد الكل',
  'common.itemsPerPage': 'العناصر لكل صفحة',
  'dashboard.quickActions.type': 'النوع',
  'dashboard.quickActions.from': 'من',
  'dashboard.quickActions.to': 'إلى',
  'dashboard.quickActions.duration': 'المدة',
  'dashboard.quickActions.action': 'إجراء',
  'dashboard.quickActions.violations': 'المخالفات',
  'dashboard.quickActions.transactions': 'المعاملات',
  'dashboard.quickActions.inOuts': 'دخول/خروج',
  'dashboard.quickActions.leaves': 'الإجازات',
  'dashboard.quickActions.permissions': 'الأذونات',
  'dashboard.quickActions.remoteWork': 'العمل عن بعد',
  'dashboard.quickActions.gridView': 'عرض الشبكة',
  'dashboard.quickActions.listView': 'عرض القائمة',
  'dashboard.quickActions.reader': 'قارئ',
  'dashboard.quickActions.leaveName': 'اسم الإجازة',
  'dashboard.quickActions.permissionName': 'الإذن',
  'dashboard.quickActions.stepOut': 'خروج مؤقت',
  'dashboard.quickActions.violation': 'مخالفة',
  'dashboard.quickActions.earlyOut': 'انصراف مبكر',
  'dashboard.quickActions.delay': 'تأخير',
  'common.trackingEmployeeRequests': 'متابعة طلبات الموظفين',
  'common.stakeholder': '  المعٌني بالموافقة',
  'common.approved': 'تمت الموافقة',
  'common.requestInformation':'معلومات الطلب',
  'common.dayCounts':'تهم اليوم',
  'common.pendingApproval': 'في انتظار الموافقة',
  'common.rejected': 'تم الرفض',
  'common.requested': 'تم الطلب',
  'common.reject': 'ارفض',
  'common.approve': 'أوافق',
  'common.items': 'عدد الاسطر',
  'common.page': 'الصفحة',
  'common.of': 'من',
  'common.selectSupervisor': 'تحديد المشرف',
  'common.active': 'فعال',
  'common.inactive': 'غير نشط',
  'common.lang': 'اللغة',
  'common.leaveType': 'نوع الاجازة',
  'common.limitation': 'حدود الاجازة',
  'common.workflow': 'سياسة الموافقة',
  'common.workFlowID': 'سير العمل',
  'common.gender': 'الجنس',
  'common.list': 'القائمة ',
  'common.toTargetGroupEmp': 'الى المجموعة',
  'common.toAssignType': 'نوع التعيين',
  'common.dailyScheduleType': 'نوع الجدول اليومي',
  'common.scheduleTypeID': 'نوع الجدول اليومي',
  'common.apply': 'طبق',
  'common.applied': 'مُطبّق',
  'common.hide': 'إخفاء',
  'common.deleteConfirmTitle': 'هل أنت متأكد؟',
  'common.deleteEntryConfirmMsg': 'هل انت متاكد من حذف هذا العنصر؟',
  'common.deleteConfirmWithName': 'هل أنت متأكد أنك تريد حذف ؟',
  'common.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف من السجلات؟',
  'common.recordDeletedSuccessfully': 'تم حذف السجل بنجاح.',
  'common.recordsDeletedSuccessfully': 'تم حذف السجلات بنجاح.',
  'common.areYouSure': 'هل أنت متأكد؟',
  'common.OK': 'نعم',
  'common.userName': 'اسم المستخدم',
  'common.cancel': 'الغاء',
  'common.warning': 'تحذير',
  'common.exportPdf': 'تصدير PDF',
  'common.exportExcel': 'تصدير Excel',
  'common.importData': 'استيراد البيانات',
  'common.allItemsWillBeExportedToPdf': 'سيتم تصدير جميع العناصر إلى PDF.',
  'common.allItemsWillBeExportedToCsv': 'سيتم تصدير جميع العناصر إلى .csv',
  'common.allItemsWillBeImported': 'سيتم استيراد جميع العناصر.',
  'common.unsavedChanges': 'تغييرات غير محفوظة',
  'common.unsavedChangesMessage': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها واختيار موظف جديد؟',
  'common.friday': 'الجمعة',
  'common.saturday': 'السبت',
  'common.sunday': 'الأحد',
  'common.monday': 'الإثنين',
  'common.tuesday': 'الثلاثاء',
  'common.wednesday': 'الإربعاء',
  'common.thursday': 'الخميس',
  'common.transactionTime': 'تاريخ الحركة',
  'common. pendingApproval': 'في انتظار الموافقة',
  'common.targetEmployees': 'الموظفون المعنيون',
  'common.location': 'الموقع',
  'common.locationID': 'الموقع',
  'common.employeeStatusID': 'الحالة',
  'common.designationID': 'المسمى الوظيفي',
  'common.managerID': 'المدير',
  'common.gradeID': 'الدرجة الوظيفية',
  'common.cardTypeID': 'نوع البطاقة',
  'common.religionID': 'الديانة',
  'common.nationalityID': 'الجنسية',
  'common.reason': 'السبب',
  'common.reasonID': 'السبب',
  'common.martialStatus': 'الحالة الاجتماعية',
  'common.absentBypolicy': 'غائب بالسياسة',
  'common.year': 'السنة',
  'common.requestStatus': 'حالة الطلب',
  'common.permissionHoursPerDayIs': 'ألحد لااعظمي للاذن بالساعة',
  'common.supervisorName': 'اسم المدير',
  'common.supervisorRemark': 'ملاحظات المدير',
  'common.Officialpermissioncomments': '* الملاحظات لإذن العمل اكبر من 15 محرف',
  'common.minimum': 'القيمة الدنيا',
  'common.maximum': 'القيمة العليا',
  'common.workingHoursPerDayIs': 'عدد ساعات العمل باليوم هو',
  'common.hoursPerMonth': 'ساعة بالشهر',
  'common.consumedHours': 'الساعات المستهلكة',
  'common.pendingHours': 'الساعات المتبقية',
  'common.flxi': 'مرن',
  'common.Hours>=': 'الساعات >=',
  'common.Minutes': 'دقائق',
  'common.permission': 'الاذونات',
  'common.remainingHours': 'الرصيد المتبقي',
  'common.sn': 'رقم',
  'common.missingIn': 'حركات دخول مفقودة',
  'common.missingOut': 'حركات خروج مفقودة',
  'common.exception': 'استثناء',
  'common.toMonth': 'إلى الشهر',
  'common.fromMonth': 'من الشهر',
  'common.lastActionBy': 'اخر تحديث',
  'common.lastActionDate': 'تاريخ اخر تحديث',
  'common.hours': 'الساعات',
  'common.remoteWork': 'العمل عن بعد',
  'common.doYouWantToProceed': 'هل انت متاكد من المتابعة؟',
  'common.checkInConfirm': 'هل انت متاكد من تسجيل الدخول؟',
  'common.checkOutConfirm': 'هل انت متاكد من تسجيل الخروج؟',
  'common.missingCard': 'بطاقة مفقودة',
  'common.visitorCardNo': 'رقم البطاقة',
  'common.attachment': 'المرفقات',
  'common.joiningDate': 'تاريخ المباشرة',
  'common.serviceTenure': 'مدة الخدمة',
  'common.missingCard': 'بطاقة مفقودة',
  'common.cardNo': 'رقم البطاقة',
  'common.missingDate': 'التاريخ',
  'common.columnName': 'اسم العامود',
  'common.days': 'الايام',
  'common.times': 'الأوقات',
  'common.description': 'الوصف',
  'common.yearlyRepeated': 'يتكرر سنويًا',
  'common.entityName': 'اسم الكائن',
  'common.female': 'انثى',
  'common.isManager': 'مدير',
  'common.legalAge': 'العمر القانوني',
  'common.male': 'ذكر',
  'common.quarter': 'ربع',
  'common.readerIn': 'وقت الدخول',
  'common.readerOut': 'وقت الخروج',
  'common.sector': 'قطاع',
  'common.section': 'قسم',
  'common.groupHeader': 'مجموعة',
  'common.shiftHeader': 'التحول',
  'common.create': 'إنشاء',
  'common.enterKeyword': 'أدخل الكلمة الرئيسية',
  'common.select': 'الرجاء الاختيار',
  'common.selectDate': 'اختر التاريخ',
  'common.selectTime': 'اختر الوقت',
  'common.selectHour': 'اختر الساعة',
  'common.selectMinute': 'اختر الدقيقة',
  'common.selectMonth': 'اختر الشهر',
  'common.selectYear': 'اختر السنة',
  'common.employeeName': 'اسم الموظف',
  'common.filter': 'مرشح',
  'common.filterby':' تصفية حسب',
  'common.noDataFound': 'لا توجد بيانات',
  'common.noDataMatchesSelectedFilters': 'لا توجد بيانات مطابقة لعوامل التصفية المحددة. يرجى تعديل عوامل التصفية والمحاولة مرة أخرى.',
  'common.searchPlaceholder': 'ابحث...',
  'common.enterEmail': 'تفعيل البريد الإلكتروني',
  'common.enterPhone': 'تفعيل الهاتف',
  'common.enterUrl': 'تمكين رابط',
  'common.enterValue': 'تمكين القيمة',
  'common.enableAll': 'تمكين الكل',
  'common.copy': 'ينسخ',
  'common.intervalID': 'معرف الفاصل الزمني',
  'common.workedDayAnnualNonAnnual':
    'أيام العمل/الإجازات السنوية, غير السنوية, إجازات الخدمة الوطنية',
  'common.remarks': 'الملاحظات',
  'common.position': 'منصب',
  'common.grid-view': 'عرض الشبكة',
  'common.list-view': 'عرض القائمة',
  'common.calendarView': 'عرض التقويم',
  'common.ArrowToTop': 'إصلاح الصف إلى الأعلى',
  'common.ArrowFromTop': 'إصلاح الصف إلى الأسفل',
  'common.rowToggle': 'تبديل تفاصيل الصف',
  'common.last-updated-on': 'آخر تحديث بتاريخ',
  'common.last-updated-on': 'آخر تحديث بتاريخ',
  'common.startTime': 'وقت البدء',
  'common.endTime': 'وقت النهاية',
  'common.duration': 'مدة',
  'common.color': 'لون',
  'common.flexDuration': 'المدة المرنة',
  'common.flexStartTime': 'وقت البدء المرن',
  'common.flexEndTime': 'وقت انتهاء مرن',
  'common.coreStartTime': 'وقت بدء الأساسي',
  'common.coreEndTime': 'وقت انتهاء النواة',
  'common.workscheduletype': 'نوع جدول العمل',

  'common.flexStartTime': 'وقت البدء المرن',
  'common.flexEndTime': 'وقت انتهاء مرن',
  'common.coreStartTime': 'وقت بدء الأساسي',
  'common.coreEndTime': 'وقت انتهاء النواة',
  'common.workscheduletype': 'نوع جدول العمل',

  'common.shiftNameEn': 'اسم التحول باللغة الإنجليزية',
  'common.shiftNameAr': 'اسم التحول عربي',
  'common.timeTable': 'الجدول الزمني',
  'common.unit': 'وحدة',
  'common.cycle': 'دورة',
  'common.autoShift': 'التحول التلقائي',
  'common.scheduleDuration': 'مدة',
  'common.minMonthlyDuration': 'الحد الأدنى للمدة الشهرية',
  'common.minWeeklyDuration': 'الحد الأدنى للمدة الأسبوعية',
  'common.pleaseSelectAtLeastOneRecordToDelete':
    'الرجاء تحديد سجل واحد على الأقل للحذف.',
  'common.deleteConfirmMessage':
    'هل أنت متأكد أنك تريد حذف {count} سجل(سجلات)؟',
  'common.deleteConfirmWithName': 'هل أنت متأكد أنك تريد حذف {name} ؟',
  'common.deleteVerifyMessage':
    'هل تريد حقًا حذف هذه السجلات؟<br />لا يمكن التراجع عن هذه العملية.',
  'common.deleteConfirmTitle': 'هل أنت متأكد ؟',
  'common.confirmation': 'تأكيد',
  'common.confirmAction': 'هل أنت متأكد أنك تريد تنفيذ هذا الإجراء؟',
  'common.exportPdf': 'تصدير PDF',
  'common.exportExcel': 'تصدير Excel',
  'common.importData': 'استيراد البيانات',
  'common.allItemsWillBeExportedToPdf': 'سيتم تصدير جميع العناصر إلى PDF.',
  'common.allItemsWillBeExportedToCsv': 'سيتم تصدير جميع العناصر إلى .csv',
  'common.allItemsWillBeImported': 'سيتم استيراد جميع العناصر.',
  'common.itemsWillBeDownloaded': 'سيتم تنزيل {count} عنصر(عناصر).',
  'common.itemsWillBeCopied': 'سيتم نسخ {count} عنصر.',
  'common.downloadConfirmMessage': 'هل أنت متأكد أنك تريد تنزيل {count} سجل(سجلات)؟',
  'common.recordDeletedSuccessfully': 'تم حذف السجل بنجاح.',
  'common.recordsDeletedSuccessfully': 'تم حذف السجلات بنجاح.',
  'success.deleteTitle': 'نجاح',
  'success.recordsDeleted': 'تم حذف السجلات بنجاح.',
  'common.unsavedChangesTitle': 'تغييرات غير محفوظة',
  'common.unsavedChangesBody': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها؟',

  // Dashboard
  'dashboard.attendanceTimeline.title': 'الخط الزمني للحضور',
  'dashboard.attendanceTimeline.subtitle': 'مقياس ديناميكي بدقة الدقائق',
  'dashboard.dailyOverview.title': 'نظرة عامة على الوردية',
  'dashboard.dailyOverview.groupPlanned': 'المخطط',
  'dashboard.dailyOverview.groupActual': 'الفعلي',
  'dashboard.workday.goodMorning': 'صباح الخير',
  'dashboard.workday.goodAfternoon': 'مساء الخير',
  'dashboard.workday.goodEvening': 'مساء الخير',
  'dashboard.workday.title': 'يوم عملي',
  'dashboard.workday.working': 'على رأس العمل',
  'dashboard.workday.since': 'منذ',
  'dashboard.workday.completed': 'مكتمل',
  'dashboard.workday.shift': 'الوردية',
  'dashboard.workday.flex': 'المرونة',
  'dashboard.workday.remaining': 'المتبقي',
  'dashboard.workday.workedToday': 'ساعات العمل',
  'dashboard.workday.headWorking': 'أنت الآن على رأس العمل',
  'dashboard.workday.headCompleted': 'اكتمل يوم عملك',
  'dashboard.workday.headNotIn': 'لم تسجّل دخولك بعد',
  'dashboard.workday.headMissed': 'لا يوجد حضور مسجّل',
  'dashboard.workday.headUpcoming': 'وردية قادمة',
  'dashboard.workday.headOff': 'يوم راحة',
  'dashboard.workday.headHoliday': 'عطلة رسمية',
  'dashboard.workday.headLeave': 'في إجازة',
  'dashboard.workday.flexOpens': 'بداية المرونة',
  'dashboard.workday.shiftStart': 'بداية الوردية',
  'dashboard.workday.shiftEnd': 'نهاية الوردية',
  'dashboard.workday.flexCloses': 'نهاية المرونة',
  'dashboard.workday.onTime': 'في الوقت',
  'dashboard.workday.violationToday': 'مخالفة اليوم',
  'dashboard.workday.noViolations': 'لا توجد مخالفات',
  'dashboard.myAttendance.title': 'حضوري',
  'dashboard.myAttendance.attendance': 'الحضور',
  'dashboard.myAttendance.onTrack': 'على المسار الصحيح',
  'dashboard.myAttendance.needsAttention': 'يحتاج إلى انتباه',
  'dashboard.myAttendance.atRisk': 'في خطر',
  'dashboard.myAttendance.noDataYet': 'لا توجد بيانات بعد',
  'dashboard.myAttendance.noScheduledDays': 'لا توجد أيام عمل مسجلة لهذا الشهر بعد.',
  'dashboard.myAttendance.attended': 'حضرت',
  'dashboard.myAttendance.of': 'من',
  'dashboard.myAttendance.scheduledDays': 'أيام العمل المجدولة',
  'dashboard.myAttendance.soFar': 'حتى الآن هذا الشهر',
  'dashboard.myAttendance.days': 'أيام',
  'dashboard.myAttendance.daysPresent': 'أيام الحضور',
  'dashboard.myAttendance.daysAbsent': 'أيام الغياب',
  'dashboard.myAttendance.delaysViolations': 'التأخير والمخالفات',
  'dashboard.myAttendance.leaveDays': 'أيام الإجازة',
  'dashboard.myAttendance.remoteWork': 'العمل عن بعد',
  'dashboard.myAttendance.last6Months': 'آخر 6 أشهر',
  'dashboard.myAttendance.absences': 'الغياب',
  'dashboard.myAttendance.absentDays': 'يوم/أيام غياب',
  'dashboard.myAttendance.pattern': 'نمط',
  'dashboard.myAttendance.violationDays': 'يوم/أيام فيها تأخير أو خروج مبكر أو مخالفة هذا الشهر',
  'dashboard.myAttendance.allGood': 'لا غياب ولا تأخير ولا خروج مبكر هذا الشهر.',
  'dashboard.scheduleShiftBar.today': 'اليوم',
  'dashboard.scheduleShiftBar.thisWeek': 'هذا الأسبوع',
  'dashboard.scheduleShiftBar.core': 'الأساسي',
  'dashboard.scheduleShiftBar.total': 'الإجمالي',
  'dashboard.scheduleShiftBar.coreIn': 'الأساسي بعد',
  'dashboard.scheduleShiftBar.flexOpen': 'الوقت المرن',
  'dashboard.scheduleShiftBar.inProgress': 'قيد التنفيذ',
  'dashboard.scheduleShiftBar.left': 'متبقي',
  'dashboard.scheduleShiftBar.startsIn': 'يبدأ بعد',
  'dashboard.scheduleShiftBar.ended': 'انتهى',
  'dashboard.scheduleShiftBar.upcoming': 'قادم',
  'dashboard.scheduleShiftBar.dayOff': 'يوم عطلة',
  'dashboard.scheduleShiftBar.noShiftTitle': 'لا توجد وردية مجدولة',
  'dashboard.scheduleShiftBar.noShiftText': 'استمتع بيومك - لا يوجد تسجيل حضور اليوم.',
  'dashboard.workday.noPunches': 'لا توجد بصمات مسجلة لهذا اليوم بعد',
  'dashboard.workday.outSince': 'خارج منذ',
  'dashboard.workday.totalViolations': 'إجمالي المخالفات',
  'dashboard.workday.lateArrival': 'تأخر في الحضور',
  'dashboard.workday.onShift': 'وقت العمل',
  'dashboard.workday.none': 'لا يوجد',
  'dashboard.workday.break': 'الاستراحة',
  'dashboard.workday.nextShift': 'الوردية التالية',
  'dashboard.workday.noDataYet': 'لا توجد بيانات بعد',
  'dashboard.workday.of': 'من',
  'dashboard.workday.now': 'الآن',
  'dashboard.dailyOverview.groupAttendance': 'الحضور',
  'dashboard.dailyOverview.checkedIn': 'تسجيل الدخول',
  'dashboard.dailyOverview.notCheckedIn': 'لم يتم تسجيل الدخول بعد',
  'dashboard.dailyOverview.worked': 'ساعات العمل',
  'dashboard.dailyOverview.shiftLength': 'الوردية',
  'dashboard.dailyOverview.groupExceptions': 'التأخير والمخالفات',
  'dashboard.dailyOverview.noShift': 'لا توجد وردية مجدولة لهذا التاريخ',
  'dashboard.dailyOverview.selectedDateStatus': 'حالة الجدول المحدد',
  'dashboard.dailyOverview.dayStatus': 'حالة الوردية',
  'dashboard.dailyOverview.shiftDate': 'تاريخ الوردية',
  'dashboard.dailyOverview.firstIn': 'أول دخول',
  'dashboard.dailyOverview.lastOut': 'آخر خروج',
  'dashboard.dailyOverview.expectedOut': 'الخروج المتوقع',
  'dashboard.dailyOverview.delay': 'التأخير',
  'dashboard.dailyOverview.earlyOut': 'انصراف مبكر',
  'dashboard.dailyOverview.violation': 'مخالفة',
  'dashboard.dailyOverview.actualWorkDuration': 'مدة العمل الفعلية',
  'dashboard.dailyOverview.coreStartTime': 'وقت بدء الوردية الأساسية',
  'dashboard.dailyOverview.coreEndTime': 'وقت انتهاء الوردية الأساسية',
  'dashboard.dailyOverview.flexStartTime': 'وقت بدء الوردية المرنة',
  'dashboard.dailyOverview.flexEndTime': 'وقت انتهاء الوردية المرنة',
  'dashboard.dailyOverview.timeTable': 'نمط الوردية',
  'dashboard.dailyOverview.shiftTimesTitle': 'وقت الوردية',
  'dashboard.dailyOverview.core': 'أساسي',
  'dashboard.dailyOverview.flex': 'مرن',
  'dashboard.dailyOverview.coreShiftInOut': 'وقت دخول/خروج الوردية الأساسية',
  'dashboard.dailyOverview.flexShiftInOut': 'وقت دخول/خروج الوردية المرنة',
  'dashboard.scheduleShiftBar.shiftsScheduled': 'الورديات المجدولة',
  'dashboard.attendanceOverview.title': 'نظرة عامة على الحضور',
  'dashboard.attendanceOverview.downloadTooltip': 'تحميل الرسم البياني بصيغة PDF',
  'dashboard.attendanceOverview.noData': 'لا توجد بيانات',
  'dashboard.calendar.title': 'تقويم الحضور',
  'dashboard.calendar.applyLeave': 'تقديم إجازة',
  'dashboard.calendar.applyPermission': 'تقديم إذن',
  'dashboard.calendar.applyRemoteRequest': 'تقديم طلب عمل عن بعد',
  'dashboard.employeeCalendar.chips.present': 'حاضر',
  'dashboard.employeeCalendar.chips.absent': 'غائب',
  'dashboard.employeeCalendar.chips.absentBefore': 'غياب قبل',
  'dashboard.employeeCalendar.chips.absentAfter': 'غياب بعد',
  'dashboard.employeeCalendar.chips.violation': 'مخالفة',
  'dashboard.employeeCalendar.chips.delay': 'تأخير',
  'dashboard.employeeCalendar.chips.earlyOut': 'انصراف مبكر',
  'dashboard.employeeCalendar.chips.remoteWork': 'العمل عن بعد',
  'dashboard.employeeCalendar.chips.leave': 'إجازة',
  'dashboard.employeeCalendar.chips.holidays': 'عطلات',
  'dashboard.employeeCalendar.chips.restday': 'يوم راحة',
  'dashboard.employeeCalendar.chips.permission': 'إذن',
  'dashboard.quickActions.violations': 'المخالفات',
  'dashboard.quickActions.transactions': 'المعاملات',
  'dashboard.quickActions.leaves': 'الإجازات',
  'dashboard.quickActions.permissions': 'الأذونات',
  'dashboard.quickActions.remoteWork': 'العمل عن بعد',
  'dashboard.quickActions.gridView': 'عرض الشبكة',
  'dashboard.quickActions.listView': 'عرض القائمة',
  'dashboard.addons.showDetails': 'عرض التفاصيل',
  'dashboard.addons.details': 'تفاصيل الإضافة',
  'dashboard.addons.detailsPlaceholder': 'التفاصيل غير متاحة.',
  'dashboard.addons.addMore': 'إضافة المزيد',
  'dashboard.addons.addAddon': 'إضافة إضافة',
  'dashboard.addons.leaveBalance': 'رصيد الإجازات',
  'dashboard.addons.annualleavebalance': 'رصيد الإجازة السنوية',
  'dashboard.addons.sickleavebalance': 'رصيد الإجازة المرضية',
  'dashboard.addons.sickBalance': 'رصيد الإجازة المرضية',
  'dashboard.addons.totalpermission': 'إجمالي الأذونات',
  'dashboard.addons.totalviolation': 'إجمالي المخالفات',
  'dashboard.addons.totalremoteworkrequest': 'إجمالي طلبات العمل عن بعد',
  'dashboard.addons.totalpendingremoteworkrequest': 'إجمالي طلبات العمل عن بعد المعلقة',
  'dashboard.addons.totalleaverequest': 'إجمالي طلبات الإجازات',
  'dashboard.addons.totaldelay': 'إجمالي التأخير',
  'dashboard.addons.totalearlyout': 'إجمالي الانصراف المبكر',
  'dashboard.addons.totalViolationDays': 'إجمالي أيام المخالفات',
  'dashboard.addons.totalLeaveDays': 'إجمالي أيام الإجازات',
  'dashboard.addons.totalAbsentDays': 'إجمالي أيام الغياب',
  'dashboard.addons.leavebalance': 'رصيد الإجازات',
  'dashboard.addons.sickbalance': 'رصيد الإجازة المرضية',
  'dashboard.addons.totalviolationdays': 'إجمالي أيام المخالفات',
  'dashboard.addons.totalleavedays': 'إجمالي أيام الإجازات',
  'dashboard.addons.totalabsentdays': 'إجمالي أيام الغياب',
  'dashboard.addons.updateFailed': 'فشل تحديث الإضافة',
  'dashboard.addons.updateSuccess': 'تم تحديث إضافات لوحة التحكم بنجاح',
  'dashboard.loadingCalendar': 'جاري تحميل بيانات التقويم...',
  'dashboard.noData': 'لا توجد بيانات',
  'dashboard.status.active': 'نشط',
  'dashboard.status.absent': 'غائب',
  'dashboard.status.outOfOffice': 'خارج المكتب',
  'dashboard.status.remoteWork': 'عمل عن بعد',
  'dashboard.status.onLeave': 'في إجازة',
  'dashboard.status.present': 'حاضر',
  'dashboard.status.holiday': 'عطلة',
  'dashboard.status.violations': 'المخالفات',
  'dashboard.status.violation': 'مخالفة',
  'dashboard.status.off': 'يوم راحة',
  'dashboard.status.inactive': 'غير نشط',
  'dashboard.dailyStatus.title': 'حالة الجدول المحدد',
  'dashboard.dailyStatus.clickForDetails': 'انقر هنا لمزيد من التفاصيل',
  'employee.reportingManager': 'المدير المباشر',
  'employee.employeeId': 'الرقم الوظيفي',
  'employee.employee': 'الموظف',
  'common.basicSettings': 'الإعدادات الأساسية',
  'common.breakTimeSettings': 'إعدادات وقت الاستراحة',
  'common.overtimeRule': 'قاعدة العمل الإضافي',
  'common.stepOutCon': 'قاعدة الخروج',
  'common.permissionCon': 'قاعدة الأذونات',
  'common.policySettings': 'قاعدة الغياب',
  'common.taPolicy': 'سياسة المساعدة التقنية',
  'common.maxStepOutDuration': 'أقصى مدة للخروج',
  'common.numOutAttempts': 'عدد محاولات الخروج',
  'common.minDurApply': 'المدة الدنيا المطلوبة للتقديم',
  'common.maxDurApply': 'الحد الأقصى للمدة المسموح بها للتقديم',
  'common.minWorkingHoursApply': 'الحد الأدنى لساعات العمل المطلوبة للتقديم',
  'common.workingHourLess': 'ساعات العمل أقل من',
  'common.punchInAfter': 'ادفع بعد',
  'common.lastPunchOutBefore': 'اللكمة الأخيرة قبل',

  'common.stepOutCon': 'قاعدة الخروج',
  'common.permissionCon': 'قاعدة الأذونات',
  'common.absentRule': 'قاعدة الغياب',
  'common.taPolicy': 'سياسة المساعدة التقنية',
  'common.afterSchedule': 'حساب بعد الجدول الزمني',
  'common.overtimeUntil': 'حساب الوقت الإضافي حتى',
  'common.beforeSchedule': 'احسب قبل الموعد المحدد',
  'common.overtimeBefore': 'احسب العمل الإضافي مسبقًا',
  'common.maxStepOutDuration': 'أقصى مدة للخروج',
  'common.numOutAttempts': 'عدد محاولات الخروج',
  'common.priority': 'إعطاء الأولوية لـ',
  'common.workedHours': 'اعتبرها ساعات عمل',
  'common.considerAsAbsent': 'اعتبر غائبا',

  'common.minDurApply': 'المدة الدنيا المطلوبة للتقديم',
  'common.maxDurApply': 'الحد الأقصى للمدة المسموح بها للتقديم',
  'common.minWorkingHoursApply': 'الحد الأدنى لساعات العمل المطلوبة للتقديم',
  'common.workingHourLess': 'ساعات العمل أقل من',
  'common.punchInAfter': 'ادفع بعد',
  'common.lastPunchOutBefore': 'اللكمة الأخيرة قبل',
  "common.shift": "التحول مطلوب",
  "common.shiftLabel": "التحول",
  "common.group": "المجموعة مطلوبة",
  "common.groupTab":'مجموعة',
  "common.employeeTab":'موظف',
  'common.employeeID' : 'معرف الموظف',
  'common.firstName' : 'الاسم الأول',
  'common.lastName' : 'اسم العائلة',
  'common.date' : 'تاريخ',
  'common.checkIn' : 'تحقق في',
  'common.checkOut' : 'الدفع',

  'common.fullCalendarView' : 'عرض التقويم الكامل',
  'common.searchEmployee' : 'بحث عن موظف',
  'common.selectColumn':'حدد العمود',
  'common.employeeList': 'قائمة الموظفين',
  'common.employeeListLabel': 'قائمة الموظفين',
  'common.departmentListLabel': 'قائمة القسم',
  'common.entityListLabel': 'قائمة الكيان',
  'common.locationListLabel': 'قائمة الموقع',
  'common.groupListLabel': 'قائمة المجموعة',
  'common.selectGroup': 'اختر المجموعة',
  'common.selectLocation': 'اختر الموقع',
  'common.selectEntity': 'اختر وحدة العمل',
  'common.selectOperation':'حدد العملية',
  'common.pleaseSSearchTheTimeTable': 'الرجاء تحديد نمط المناوبة',
  'common.yes': 'نعم',
  'common.no': 'لا',
  'common.true': 'صحيح',
  'common.false': 'خطأ',
  'common.escalate':'إرتفاع',
  'common.afterDays':'بعد أيام',
  'common.form':'استمارة',
  'common.for': 'لـ',
  'common.restDay':'يوم الراحة',
  'common.saving':'توفير...',
  'common.shiftPattern':'نمط التحول',
  'common.halfCalendar':'عرض نصف التقويم',
  'common.fullCalendar':'عرض التقويم الكامل',

  'workflow.rejectionReason': 'سبب الرفض',

  'error.required': 'مطلوب',
  'error.endDateNotEarlierThanstartDate': '',
  'error.validPositiveNumber':'يجب أن يكون الرقم إيجابي',
  'error.must18YearsOld': 'يجب أن يكون عمرك 18 عامًا على الأقل.',
  'error.must10YearsOld': 'يجب أن يكون عمرك 10 سنوات على الأقل.',
  'error.pleaseSelectCorrectValue': '',
  'error.pleaseSelectValidYear': '',
  'error.selectFromYear': 'يرجى اختيار سنة البداية',
  'error.selectFromMonth': 'يرجى اختيار شهر البداية',
  'error.selectToYear': 'يرجى اختيار سنة النهاية',
  'error.selectToMonth': 'يرجى اختيار شهر النهاية',
  'error.toYearMustBeGreaterOrEqual': 'يجب أن تكون سنة النهاية أكبر من أو تساوي سنة البداية',
  'error.toMonthMustBeGreaterOrEqual': 'يجب أن يكون شهر النهاية أكبر من أو يساوي شهر البداية',
  'error.selectValidDate': '',
  'error.startDateIsRequired': '',
  'error.validAge': '',
  'error.required': 'مطلوب',
  'error.pleaseSelectAtLeastOneMetric': 'يرجى تحديد مقياس واحد على الأقل.',
  'error.pleaseSelectAtLeastOneDetail': 'يرجى تحديد تفصيل واحد على الأقل.',
  'error.save_failed': 'فشل الحفظ',
  'error.somethingWentWrong': 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
  'error.saveFailed': 'فشل الحفظ',
  'error.updateFailed': 'فشل التحديث',
  'error.cannotUpdateDueToDependencies': 'غير قادر على تحديث العنصر المحدد لأنه قيد الاستخدام من قبل السجلات التالية:',
  'notification.error.invalidTypeId': 'معرف نوع الإشعار غير صالح.',
  'notification.error.oneDefinitionPerType': 'تعريف واحد فقط لكل نوع إشعار.',
  'notification.error.invalidIntervalId': 'معرف الفترة الزمنية غير صالح.',
  'notification.error.scheduleTypeRequired': 'معرف نوع الجدول الزمني مطلوب.',
  'notification.error.durationRequired': 'المدة مطلوبة.',
  'notification.error.workdayRequired': 'معرف يوم العمل مطلوب.',
  'error.error': 'خطأ',
  'error.fetching_data': 'فشل في جلب البيانات',
  'error.toTimeMustBeGreaterThanFromTime':
    'يجب أن يكون وقت "إلى" أكبر من وقت "من"',
  'error.validationError':
    'يرجى ملء جميع الحقول التي تم وضع علامة عليها بنجمة حمراء (*)',
  'error.textValidation': 'الرجاء إدخال 2 أحرف على الأقل',
  'error.notificationTextValidation': 'الرجاء إدخال 2 أحرف على الأقل',
  'error.codeValidation': 'الرجاء إدخال 1 حرف على الأقل',
  'error.fromDateGreater': 'لا يمكن أن يكون تاريخ "من" أكبر من تاريخ "إلى"',
  'error.toDateLess': 'لا يمكن أن يكون تاريخ "إلى" أقل من تاريخ "من"',
  'error.toDateGreaterThanFromDate': 'لا يمكن أن يكون تاريخ "إلى" أقدم من تاريخ "من"',
  'error.selectAtLeastOneEmployee': 'يرجى اختيار موظف واحد على الأقل',
  'error.selectAtLeastOneDepartment': 'يرجى اختيار قسم واحد على الأقل',
  'error.selectAtLeastOneLocation': 'يرجى اختيار موقع واحد على الأقل',
  'error.selectAtLeastOneGroup': 'يرجى اختيار مجموعة واحدة على الأقل',
  'error.selectDepartment': 'القسم مطلوب',
  'error.selectLocation': 'الموقع مطلوب',
  'error.selectGroup': 'المجموعة مطلوبة',
  'error.fillRequiredFields': 'يرجى ملء جميع الحقول المطلوبة',
  'error.recordAlreadyExists': 'السجل موجود بالفعل',
  'error.unableToUpdateAssignShift': 'غير قادر على تحديث تعيين الشفت',
  'error.unableToCreateAssignShift': 'غير قادر على إنشاء تعيين الشفت',
  'error.updateFailed': 'فشل التحديث',
  'error.createFailed': 'فشل الإنشاء',
  'error.saveFailed': 'فشل الحفظ',
  'sidebar.selectedColumnsList': '',
  'sidebar.selectionCriteria': 'معايير الاختيار',
  'sidebar.newReportBuilder': 'ビルدر التقارير',

  pleaseSelectAtleaseColumn: 'يرجى اختيار عمود واحد على الاقل من جدول الموظفين',
  'error.selectValidDateRange': 'الرجاء ادخال فترة زمنية صحيحة',
  'error.toDateNotEarlierThanFromDate':
    'الى تاريخ يجب ان يكون اكبر او يساوي من تاريخ',
  'error.isRequired': 'حقل اجباري',
  'error.required': 'مطلوب',
  'error.enterAValid': 'يرجى ادخال قيم صحيحة',
  'error.enterAValidFormat': 'يرجى ادخال صيغة صحيحة',
  'error.enterThe': 'ادخل ',
  'error.enterA': 'ادخل',
  'error.ProbationPeriodDateNotLessThanJoiningDate':
    'تاريخ فترة الاختبار يجب ألا يكون أقل من تاريخ الانضمام.',
  'error.TerminatedDateNotLessThanJoiningDate':
    'تاريخ الانتهاء يجب ألا يكون أقل من تاريخ الانضمام.',
  'error.invalidEmiratesIDFormat': 'تنسيق بطاقة الهوية الإماراتية غير صالح.',
  'error.endDateGraterThanStartDate':
    'لا يمكن أن يكون وقت النهاية قبل وقت البدء',
  'error.yearIsAlreadyExist': 'السنة موجودة بالفعل',
  'error.selectValidMonthAndYear': 'الرجاء اختيار شهر وسنة صحيحين',
  'error.arabicValidation': 'يسمح فقط بالأحرف العربية، ثلاثة أحرف على الأقل',
  'error.selectValidTime': 'الرجاء إدخال وقت صالح بتنسيق HH:MM',
  'error.invalidTime': 'لا يمكن أن يكون الوقت 00:00',
  'error.provideStartTime': 'يرجى إدخال وقت البدء',
  'error.provideEndTime': 'يرجى إدخال وقت الانتهاء',
  'error.durationMustBePositive': 'يجب أن تكون المدة أكبر من 0 دقيقة',
  'error.provideStartEndTime': 'يرجى إدخال وقت البدء والانتهاء',
  'error.durationExceedsRange': 'لا يمكن أن تتجاوز الوقت المتاح',
  'error.fromTimeCannotBeZero': 'لا يمكن أن يكون الوقت 00:00',
  'error.toTimeCannotBeZero': 'لا يمكن أن يكون الوقت 00:00',
  'error.fromTimeNotGrevnToTime':
    'يجب أن يكون "من الوقت" أقل من "إلى الوقت',
  'error.invalidNumber': 'الرجاء إدخال رقم صالح',
  'error.joiningDateCannotBeInTheFuture': 'لا يمكن أن يكون تاريخ المباشرة في المستقبل.',
  'error.invalidTerminationDateFormat': 'تنسيق تاريخ إنهاء الخدمة غير صالح.',
  'error.ramadanPeriodRangeTooShort': 'يرجى اختيار فترة بين 29 إلى 31 يومًا. الفترة المحددة {diffDays} يومًا (أقل بـ {lessBy} يومًا).',
  'error.ramadanPeriodRangeTooLong': 'يرجى اختيار فترة بين 29 إلى 31 يومًا. الفترة المحددة {diffDays} يومًا (أكثر بـ {moreBy} يومًا).',
  'error.overlapDateRange': 'نطاق التاريخ المحدد يتداخل مع سجل موجود.',
  'error.ramadanPeriodInvalidDurationOrOverlap':
    'يجب أن تكون فترة رمضان بين 29 و31 يومًا، ويجب ألا تتداخل مع فترة رمضان موجودة أو تكون قريبة جدًا منها.',
  'error.holidayPeriodDuplicateOrOverlap':
    'توجد فترة زمنية نشطة أخرى بنفس الاسم العربي أو الاسم الإنجليزي أو الرمز أو بنطاق تاريخ متداخل لهذه الشركة.',
  'error.activeEmployeeAlreadyExists':
    'يوجد موظف نشط بنفس رقم الموظف أو البريد الإلكتروني بالفعل لهذه الشركة.',
  'error.failedToLoadDataTryAgain': 'فشل في تحميل البيانات. يرجى المحاولة مرة أخرى.',
  'error.saveOperationFailed': 'فشلت عملية الحفظ',
  'employee.unableToSaveEmployee': 'تعذر حفظ الموظف',
  'error.duplicateWithFieldsPrefix': 'يوجد سجل بنفس',
  'error.duplicateWithFieldsSuffix': 'موجود بالفعل.',
  'error.recordMayAlreadyExistOrInvalid': 'حدث خطأ. قد يكون السجل موجودًا بالفعل أو البيانات غير صحيحة.',
  'error.failedToFetchData': 'فشل في جلب البيانات',
  'error.failedToLoad': 'فشل في تحميل {page}',
  'lookup.saveErrorTitle': 'تعذر حفظ {lookup}',
  'lookup.saveErrorMessage': 'تعذر حفظ {lookup}. يرجى المحاولة مرة أخرى.',
  'lookup.userRole.error.defaultAlreadyExists': 'يمكن تعيين دور مستخدم افتراضي نشط واحد فقط. يرجى إلغاء تعيين الافتراضي الحالي ثم المحاولة مرة أخرى.',
  'error.unableToFetchTryAgain': 'تعذر جلب {page}. يرجى المحاولة مرة أخرى.',
  'error.sorrySomethingWentWrong': 'عذرًا، حدث خطأ ما',
  'error.couldNotConnectTryAgainLater': 'تعذر الاتصال بالخادم. يرجى المحاولة مرة أخرى لاحقًا.',
  'error.failedToDeleteRecordsTitle': 'فشل حذف السجلات',
  'error.errorOccurredWhileDeletingRecord': 'حدث خطأ أثناء حذف السجل.',
  'error.errorOccurredWhileDeletingRecords': 'حدث خطأ أثناء حذف السجلات.',
  'error.failedToDownloadRecordsTitle': 'فشل تنزيل السجلات',
  'error.errorOccurredWhilePreparingDownload': 'حدث خطأ أثناء تجهيز التنزيل.',
  // Employee assignment errors
  'error.assignmentLoadTitle': 'فشل تحميل التعيينات',
  'error.assignmentLoadMessage': 'تعذر جلب التعيينات. يرجى المحاولة مرة أخرى.',
  'error.assignmentUpdateTitle': 'فشل التحديث',
  'error.assignmentUpdateMessage': 'تعذر تحديث التعيين. يرجى المحاولة مرة أخرى.',
  'error.assignmentDeleteTitle': 'فشل الحذف',
  'error.assignmentDeleteMessage': 'تعذر حذف التعيين. يرجى المحاولة مرة أخرى.',
  // Employee contract errors
  'error.contractLoadTitle': 'فشل تحميل العقود',
  'error.contractLoadMessage': 'تعذر جلب العقود. يرجى المحاولة مرة أخرى.',
  'error.contractDeleteTitle': 'فشل الحذف',
  'error.contractDeleteMessage': 'تعذر حذف العقد. يرجى المحاولة مرة أخرى.',
  'error.contractBulkDeleteTitle': 'فشل الحذف',
  'error.contractBulkDeleteMessage': 'تعذر حذف العقود. يرجى المحاولة مرة أخرى.',
  // Employee calculation story
  'error.calcStoryLoadTitle': 'فشل تحميل سجل الاحتساب',
  'error.calcStoryLoadMessage': 'تعذر تحميل سجل الاحتساب. يرجى المحاولة مرة أخرى.',
  // Frontend-defined API errors (bilingual usage)
  'error.loadListTitle': 'فشل تحميل قائمة الموظفين',
  'error.loadListMessage': 'تعذر جلب بيانات الموظفين. يرجى المحاولة مرة أخرى.',
  'error.deleteBulkTitle': 'فشل الحذف',
  'error.deleteBulkMessage': 'فشل حذف السجلات.',
  'error.deleteSingleTitle': 'فشل الحذف',
  'error.deleteSingleMessage': 'فشل حذف السجل.',
  'error.saveTitle': 'تعذر حفظ الإعداد',
  'error.saveMessage': 'تعذر حفظ الإعداد. يرجى المحاولة مرة أخرى.',
  'error.duplicateLookup': 'مكرر: يوجد تعريف نشط بنفس الاسم أو الكود بالفعل.',
  'error.loadTitle': 'فشل تحميل الإعداد',
  'error.loadMessage': 'تعذر تحميل الإعداد. يرجى المحاولة مرة أخرى.',
  'error.deleteTitle': 'فشل الحذف',
  'error.deleteMessage': 'تعذر حذف السجل. يرجى المحاولة مرة أخرى.',
  // Generic API error-code messages
  'api.error.000.title': 'نجاح',
  'api.error.000.message': 'تم تنفيذ العملية بنجاح.',
  'api.error.400.title': 'خطأ في التحقق من البيانات',
  // Specific API error-code messages
  'api.error.103.message': 'لا يمكنك حذف طلب الإجازة أثناء انتظار الموافقة أو أثناء سير عملية الموافقة، أو قد لا تمتلك الصلاحية المطلوبة لحذفه',
  'api.error.103.remote.message':'لا يمكنك حذف طلب العمل عن بُعد طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لحذفه.',
  'api.error.103.permission.message':'لا يمكنك حذف طلب الإذن طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لحذفه.',
  'api.error.103.manual.message':'لا يمكنك حذف طلب الإدخال اليدوي طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لحذفه.',
  'api.error.103.update.message': 'لا يمكنك تعديل طلب الإجازة أثناء انتظار الموافقة أو أثناء سير عملية الموافقة، أو قد لا تمتلك الصلاحية المطلوبة لتعديله',
  'api.error.103.update.remote.message': 'لا يمكنك تعديل طلب العمل عن بُعد طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لتعديله.',
  'api.error.103.update.permission.message': 'لا يمكنك تعديل طلب الإذن طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لتعديله.',
  'api.error.103.update.manual.message': 'لا يمكنك تعديل طلب الإدخال اليدوي طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لتعديله.',
  'api.error.400.message': 'بعض البيانات التي أدخلتها غير صالحة. يرجى المراجعة والمحاولة مرة أخرى.',
  'api.error.401.title': 'غير مصرح',
  'api.error.401.message': 'غير مسموح لك بتنفيذ هذا الإجراء. يرجى تسجيل الدخول مرة أخرى أو الاتصال بالمسؤول.',
  'api.error.403.title': 'ممنوع',
  'api.error.403.message': 'ليس لديك صلاحية لتنفيذ هذا الإجراء.',
  'api.error.404.title': 'غير موجود',
  'api.error.404.message': 'العنصر المطلوب غير موجود.',
  'api.error.409.title': 'سجل مكرر',
  'api.error.409.message': 'يوجد بالفعل سجل يحتوي على نفس البيانات.',
  'api.error.410.title': 'فشل الحذف',
  'api.error.410.message': 'غير قادر على حذف العنصر المحدد لأنه يعتمد على {entity}.',
  'api.error.410.pageName': 'اسم الصفحة',
  'api.error.410.reference': 'المرجع',
  'api.error.422.title': 'لا يمكن الحذف',
  'api.error.422.message': 'لا يمكن حذف هذا السجل لأنه قيد الاستخدام أو في حالة غير صالحة.',
  'api.error.423.title': 'خطأ منطقي',
  'api.error.423.message': 'حدث خطأ منطقي أثناء معالجة طلبك. يرجى التحقق من المدخلات والمحاولة مرة أخرى.',
  'api.error.500.title': 'خطأ غير متوقع',
  'api.error.500.message': 'حدث خطأ غير متوقع في الخادم. يرجى المحاولة مرة أخرى لاحقاً.',
  'api.error.510.title': 'خطأ في قاعدة البيانات',
  'api.error.510.message': 'حدث خطأ في قاعدة البيانات أثناء معالجة الطلب. يرجى المحاولة مرة أخرى لاحقاً.',
  'error.mustBePositive': 'يجب أن تكون القيمة إيجابية',
  'error.coreTimeOutsideFlex': 'يجب أن يكون وقت الأساس ضمن وقت البداية المرنة ووقت النهاية المرنة',
  'error.invalidCoreRange': 'يجب أن يكون وقت بدء التشغيل الأساسي قبل وقت انتهاء التشغيل الأساسي',
  'error.mustBeGreaterThanZero': 'يجب أن يكون أكبر من الصفر',
  "error.coreStartLessThanFlexStart": "يجب أن يكون وقت بدء التشغيل الأساسي أكبر من أو يساوي وقت بدء التشغيل المرن",
  "error.coreEndGreaterThanFlexEnd": "يجب أن يكون وقت انتهاء Core أقل من أو يساوي وقت انتهاء Flex",
  "error.coreStartAfterCoreEnd": "يجب أن يكون وقت بدء التشغيل الأساسي أسبق من وقت انتهاء التشغيل الأساسي",
    "error.coreStartShouldBeGreaterThanOrEqualToFlexStart": "يجب أن يكون وقت بداية الأساس أكبر من أو يساوي وقت بداية المرونة",
    "error.coreStartShouldBeLessThanOrEqualToFlexEnd": "يجب أن يكون وقت بداية الأساس أقل من أو يساوي وقت نهاية المرونة",
    "error.coreEndShouldBeGreaterThanOrEqualToFlexStart": "يجب أن يكون وقت نهاية الأساس أكبر من أو يساوي وقت بداية المرونة",
    "error.coreEndShouldBeLessThanOrEqualToFlexEnd": "يجب أن يكون وقت نهاية الأساس أقل من أو يساوي وقت نهاية المرونة",
    "error.coreStartAfterCoreEnd": "يجب أن يكون وقت بداية الأساس قبل وقت نهاية الأساس",
  "error.duplicatePermissionType": "تمت إضافة نوع الإذن هذا بالفعل",
  "error.cannotModifyFinalStatus": "لا يمكن تعديل طلب تمت الموافقة عليه أو رفضه",
  'error.coreTimeOutsideFlex':
    'يجب أن يكون وقت الأساس ضمن وقت البداية المرنة ووقت النهاية المرنة',
  'error.invalidCoreRange':
    'يجب أن يكون وقت بدء التشغيل الأساسي قبل وقت انتهاء التشغيل الأساسي',
  'error.mustBeGreaterThanZero': 'يجب أن يكون أكبر من الصفر',
  'error.coreStartLessThanFlexStart':
    'يجب أن يكون وقت بدء التشغيل الأساسي أكبر من أو يساوي وقت بدء التشغيل المرن',
  'error.coreEndGreaterThanFlexEnd':
    'يجب أن يكون وقت انتهاء Core أقل من أو يساوي وقت انتهاء Flex',
  'error.coreStartAfterCoreEnd':
    'يجب أن يكون وقت بدء التشغيل الأساسي أسبق من وقت انتهاء التشغيل الأساسي',
  'error.coreStartShouldBeGreaterThanOrEqualToFlexStart':
    'يجب أن يكون وقت بداية الأساس أكبر من أو يساوي وقت بداية المرونة',
  'error.coreStartShouldBeLessThanOrEqualToFlexEnd':
    'يجب أن يكون وقت بداية الأساس أقل من أو يساوي وقت نهاية المرونة',
  'error.coreEndShouldBeGreaterThanOrEqualToFlexStart':
    'يجب أن يكون وقت نهاية الأساس أكبر من أو يساوي وقت بداية المرونة',
  'error.coreEndShouldBeLessThanOrEqualToFlexEnd':
    'يجب أن يكون وقت نهاية الأساس أقل من أو يساوي وقت نهاية المرونة',
  'error.coreStartAfterCoreEnd':
    'يجب أن يكون وقت بداية الأساس قبل وقت نهاية الأساس',

  'groups.groupName': 'اسم المجموعة',
  // TargetEmployeeType
  'TargetEmployeeType.NotSet': 'غير محدد',
  'TargetEmployeeType.Employee': 'الموظف',
  'TargetEmployeeType.Group': 'مجموعة',
  'TargetEmployeeType.Location': 'الموقع',
  'TargetEmployeeType.Entity': 'القسم',
  'TargetEmployeeType.Manager': 'المدير ',
  'TargetEmployeeType.Requester': 'الطالب',
  // Label Fields
  'labelFor.nameEn': 'الاسم (بالإنجليزية)',
  'labelFor.nameAr': 'الاسم (بالعربية)',
  'labelFor.assignType': 'نوع التعيين',
  'labelFor.assignTo': 'تعيين إلى',
  'labelFor.escalateAfterDay': 'تصعيد بعد (يوم)',
  'labelFor.stageOrder': 'ترتيب المرحلة',
  'labelFor.escalateAction': 'إجراء التصعيد',
  'labelFor.form': 'النموذج',
  'labelFor.workFlowFor': 'سير العمل ل',
  // Sidebar
  'sidebar.lineListingFiltersReport': 'تقرير تصفية القائمة التفصيلية',
  'sidebar.updateBulkEmployee': 'تعديل الموظفين',
  'sidebar.auditLog': 'سجل التدقيق',
  'sidebar.remoteWorkSetting': 'العمل عن بعد',
  'sidebar.missingGateTransaction': 'الحركات المفقودة',
  'sidebar.leaves': 'الاجازات',
  'sidebar.employeeLeaves': 'إجازات الموظفين',
  'sidebar.violations': 'المخالفات',

  // Employee Leave
  'employeeLeave.title': 'إجازة الموظف',
  'employeeLeave.review': 'مراجعة إجازة الموظف',
  'employeeLeave.allowedDays': 'الأيام المسموح بها',
  'employeeLeave.carryoverDays': 'الأيام المرحلة',
  'employeeLeave.reference': 'المرجع',
  'employeeLeave.allowedDayBalance': 'رصيد الأيام المسموح بها',
  'employeeLeave.carryOverBalance': 'رصيد الأيام المرحلة',
  'employeeLeave.totalRequestedBalance': 'إجمالي الرصيد المطلوب',
  'employeeLeave.balance': 'الرصيد',
  'employeeLeave.lastUpdatedDate': 'تاريخ آخر تحديث',
  'common.search': 'بحث',
  'sidebar.employeeReports': 'تقارير الموظفين',
  'sidebar.selfServices': 'الخدمات الذاتية',
  'sidebar.dashboard': 'لوحة التحكم',
  'sidebar.leave': 'الإجازات',
  'sidebar.permission': 'الأذونات',
  'sidebar.remoteWork': 'العمل عن بُعد',
  'sidebar.workSchedule': 'جدول العمل',
  'sidebar.defineSchedule': 'تحديد الجدول',
  'sidebar.assignSchedule': 'تعيين الجدول',
  'sidebar.breakDuration': 'مدة الاستراحة',
  'sidebar.breakManagement': 'إدارة الاستراحة',
  'sidebar.CardPrint':'طباعة البطاقات',
  'sidebar.attendanceDuration': 'الجدول الزمني',
  'sidebar.assignTemporarySchedule': 'تعيين جدول مؤقت',
  // 'sidebar.shiftWorkSchedule': 'تعيين جدول العمل',
  'sidebar.defineWorkSchedule': 'خطة التحول',
  'sidebar.scheduleAssignment': 'جدولة المهمة',
  'sidebar.ramadanPeriod': 'فترة رمضان',
  'sidebar.subordinateRequest': 'طلبات المرؤوسين',
  'sidebar.delegation': 'التفويض',
  'sidebar.policy': 'السياسة',
  'sidebar.definePolicy': 'تحديد السياسة',
  'sidebar.assignPolicy': 'تعيين السياسة',
  'sidebar.reports': 'التقارير',
  'sidebar.attendance': 'الحضور',
  'sidebar.violations': 'الانتهاكات',
  'sidebar.absentees': 'المتغيبون',
  'sidebar.requests': 'الطلبات',
  'sidebar.humanResources': 'الموارد البشرية',
  'sidebar.recalculateAttendance': 'إعادة حساب الحضور',
  'sidebar.exception': 'الاستثناءات',
  'sidebar.updateSupervisor': 'تحديث المشرف',
  'sidebar.request': 'طلب',
  'sidebar.approvalRequestsScreen': 'شاشة طلبات الموافقة',
  'sidebar.approvalRequestsStatus': 'حالة طلبات الموافقة',
  'sidebar.employees': 'الموظفون',
  'sidebar.groups': 'المجموعات',
  'sidebar.manualEntry': 'إدخال يدوي',
  'sidebar.holidays': 'العطل السنوية',
  'sidebar.lookups': 'البحث',
  'sidebar.applicationConfigration': 'تكوين التطبيق',
  'sidebar.builder': 'المنشئ',
  'sidebar.leaveConfirmation': 'تكوين الإجازة',
  'sidebar.remoteConfirmation': 'تكوين العمل عن بُعد',
  'sidebar.permissionConfirmation': 'تكوين الإذن',
  'sidebar.leaveSetting': 'إعدادات الإجازة',
  'sidebar.permissionType': 'نوع الإذن',
  'sidebar.workFlow': 'سير العمل',
  'sidebar.form': 'إعداد سير عمل النموذج',
  'sidebar.notification': 'الإشعارات',
  'sidebar.employeeWorkSchedule': 'جدول دوام الموظف',
  'sidebar.workFlowApplication': 'تطبيق تدفق العمل',

  'dashboard.lastOutTime': 'اخر خروج',
  'dashboard.dashboard': 'لوحة التحكم',
  'dashboard.clickAboveToCheckIn': 'يرجى الضغط لتسجيل وقت الدخول',
  'dashboard.clickAboveToCheckOut': 'يرجى الضغط لتسجيل وقت الخروج',
  'dashboard.flexibleInTime': 'وقت دخول مرن',
  'dashboard.flexibleOutTime': 'وقت خروج مرن',
  'dashboard.attendanceOverview.downloadTooltip': 'تحميل الرسم البياني بصيغة PDF',
  'dashboard.employeeInfo': 'معلومات الموظف',
  'dashboard.lineManager': 'المدير المباشر',
  'dashboard.absent': 'الغياب',
  'dashboard.violation': 'مخالفة',
  'dashboard.remPermissionHour': 'الساعات المتبقية للإذن',
  'dashboard.consumedHours': 'الساعات الشخصية المستهلكة المتبقية',
  // Manager Dashboard
  'dashboard.manager.employeesWithViolations': 'الموظفون لديهم مخالفات',
  'dashboard.manager.upcomingLeaves': 'الإجازات القادمة',
  'dashboard.manager.pendingApprovals': 'الموافقات المعلقة',
  'dashboard.manager.noPendingApprovals': 'لا توجد موافقات معلقة',
  'dashboard.manager.leaveRequests': 'طلبات الإجازة',
  'dashboard.manager.permissions': 'التصاريح',
  'dashboard.manager.remoteWork': 'العمل عن بُعد',
  'dashboard.manager.manualAdjustments': 'إدخال يدوي',
  'dashboard.manager.noViolationsRecorded': 'لا توجد مخالفات مسجلة',
  'dashboard.manager.noUpcomingLeaves': 'لا توجد إجازات قادمة',
  'dashboard.manager.employeeAttendanceCalendar': 'تقويم حضور الموظفين',
  'dashboard.manager.noEmployeeAttendanceData': 'لا توجد بيانات حضور للموظفين للنطاق الزمني المحدد',
  'dashboard.manager.quickActions': 'إجراءات سريعة',
  'dashboard.manager.addPermission': 'إضافة تصريح',
  'dashboard.manager.addLeave': 'إضافة إجازة',
  'dashboard.manager.addRemoteWork': 'إضافة عمل عن بُعد',
  'dashboard.manager.exportReport': 'تصدير تقرير',
  'dashboard.manager.attendancedistribution': 'توزيع الحضور',
  'dashboard.manager.leavetypes': 'أنواع الإجازات',
  'dashboard.manager.departmentattendance': 'حضور القسم',
  'dashboard.manager.attendancestatistics': 'إحصائيات الحضور',
  'dashboard.manager.title': 'لوحة المدير',
  'dashboard.manager.pendingRequest': 'طلب معلق',
  'employee.resetPassword': 'إعادة تعيين كلمة المرور',
  'employee.allowLogin': 'إرسال كلمة المرور عبر البريد الإلكتروني',
  'employee.allowedToLogin': 'مسموح له بتسجيل الدخول',
  'employee.deleteEmployee': 'حذف الموظف',
  'dashboard.pendingApproval': 'الموافقات المعلقة',
  'dashboard.leaveBalance': 'رصيد الإجازات',
  'dashboard.carryForwardLeave': 'الإجازات المُرحّلة',
  'dashboard.currentDayStatus': 'الحالة في ',
  'dashboard.officeInOut': 'دخول وخروج ',
  'dashboard.delay': 'تأخير',
  'dashboard.inOffice': 'في المكتب',
  'dashboard.hoursLeftInOffice': 'الساعات المتبقية',
  'dashboard.in': 'دخول',
  'dashboard.out': 'خروج',
  'dashboard.subOrdinate': 'المرؤوسون',
  'dashboard.Absent': 'الغياب',
  'dashboard.Violations': 'تفاصيل المخالفات  ',
  'dashboard.Personal Permission Requests': 'تفاصيل الاذونات ',
  'dashboard.Pending Approval': 'تفاصيل الموافقات المعلقة',
  'dashboard.Leave Balance': 'تفاصيل الاجازات',
  'dashboard.': 'dashboard.',
  // Attendance Violation & Transaction
  'attendanceViolation.applyRequest': 'تقديم طلب',
  'attendanceTransaction.readerTransaction': 'تحويل إلى حركة قارئ',

  // Leave Request
  'leaveRequest.Title': 'طلبات الإجازات',
  'leaveRequest.TitleHR': 'إدارة الأفراد: طلبات الإجازة',
  'leaveRequest.editLeaveRequest': 'تعديل طلب الاجازة',
  'leaveRequest.leaveTypeEn': 'نوع الإجازة (الإنجليزية)',
  'leaveRequest.fromDate': 'من تاريخ',
  'leaveRequest.toDate': 'إلى تاريخ',
  'leaveRequest.status': 'الحالة',
  'leaveRequest.nextActionBy': 'الإجراء التالي بواسطة',
  'leaveRequest.add': '+ إضافة',
  'leaveRequest.leaveType': 'نوع الإجازة',
  'leaveRequest.requestedLeaveCount': 'إجمالي الإجازات المطلوبة',
  'leaveRequest.carryForwardLeavesCount': 'إجمالي الإجازات المُرحّلة',
  'leaveRequest.allowedLeavesInYear': 'الإجازات المسموحة في العام',
  'leaveRequest.consumedLeavesCount': 'إجمالي الإجازات المستهلكة',
  'leaveRequest.remainingLeavesCount': 'إجمالي الإجازات المتبقية',
  'leaveRequest.newLeaveRequest': '  إضافة طلب اجازة',
  'leaveRequest.editLeaveRequest': 'تعديل طلب الإجازة',
  'leaveRequest.leaveSummary': 'ملخص الإجازات',
  'leaveRequest.leaveRequestLabel': 'طلب إجازة',
  'leaveRequest.leaveRequestSaved': 'تم تقديم طلب الإجازة بنجاح',
  'error.failedToSave':'فشل حفظ طلب الإجازة',
  'error.invalidEmployee': 'موظف غير صالح',
  
  // Leave Request Error Messages
  'leaveRequest.error.eligible': 'مؤهل / موافق',
  'leaveRequest.error.invalidDateRange': 'نوع إجازة غير صالح أو نطاق تاريخ (عدم تطابق سنة من/إلى)',
  'leaveRequest.error.alreadyInWorkflow': 'الطلب موجود بالفعل في سير العمل (لا يمكن التعديل)',
  'leaveRequest.error.overlappingRequest': 'يوجد طلب إجازة متداخل',
  'leaveRequest.error.afterTermination': 'لا يمكن أن تكون الإجازة بعد تاريخ إنهاء خدمة الموظف',
  'leaveRequest.error.noBalance': 'لا يوجد رصيد إجازة متاح لهذه الفترة',
  'leaveRequest.error.insufficientBalance': 'رصيد الإجازة غير كافٍ',
  'leaveRequest.error.beforeJoining': 'تواريخ الإجازة قبل تاريخ التحاق الموظف',
   'leaveRequest.error.workflow': 'لم يتم العثور على أي تكوين خاص بسير العمل',
  'leaveRequest.error.requestedCountZero': 'لا يمكن تقديم الطلب للفترة المحددة لعدم وجود جدول عمل أو لأنها توافق يوم راحة.',
  'leaveRequest.error.beforeafterholiday': 'لا يمكنك التقدم بطلب إجازة قبل عطلة رسمية أو بعدها.',
  'leaveRequest.error.beforeafterRestday': 'لا يمكنك التقدم بطلب إجازة قبل يوم الراحة أو بعده.',
  'leaveRequest.error.splitRequestsNotAllowed': 'لديك إجازة في آخر يوم عمل. يرجى تقديم جميع تواريخ الإجازة في طلب واحد. لا يُسمح بتقسيم الطلبات.',

  // Lookups
  'lookup.isSecurity': 'موظف الامن',
  'lookup.isDailyReport': 'تقرير يومي',
  'lookup.addDesignationCategory': 'إضافة مسمى وظيفي',
  'lookup.designationCategoryExpansion': 'فئات المسمى الوظيفي',
  'lookup.designationCategory': 'فئات المسمى الوظيفي',
  'lookup.isDefaultValue': 'افتراضي',
  'lookup.addNationality': 'إضافة جنسية',
  'lookup.nameAr': 'الاسم بالعربية',
  'lookup.nameEn': 'الاسم بالإنجليزية',
  'lookup.code': 'الكود',
  'lookup.gender': 'الجنس',
  'lookup.group': 'المجموعة',
  'lookup.userRole': 'دور المستخدم',
  'lookup.reason': 'السبب',
  'lookup.isDailyReport': 'تقرير يومي',
  'lookup.close': 'إغلاق',
  'lookup.save': 'حفظ',
  'lookup.isDefault': 'افتراضي',
  'lookup.isEmployee': 'موظف',
  'lookup.nationalityExpansion': 'عرض الجنسية',
  'lookup.nationality': 'الجنسية',
  'lookup.add': 'إضافة',
  'lookup.designation': 'المسمى الوظيفي',
  'lookup.designationExpansion': 'عرض المسمى الوظيفي',
  'lookup.addDesignation': 'إضافة مسمى وظيفي',
  'lookup.keyword': 'الكلمة المفتاحية',
  'lookup.newEmployeeCategory': 'فئة موظف جديدة',
  'lookup.employeeCategoryExpansion': 'عرض فئة الموظفين',
  'lookup.employeeCategory': 'فئة الموظفين',
  'lookup.qualificationType': 'نوع المؤهل',
  'lookup.qualification': 'المؤهل',
  'lookup.reason': 'السبب',
  'lookup.cardType': 'نوع البطاقة',
  'lookup.qualificationStatus': 'حالة المؤهل',
  'lookup.qualificationEquivalence': 'معادلة المؤهل',
  'lookup.appraisalFinalResult': 'النتيجة النهائية للتقييم',
  'lookup.country': 'الدولة',
  'lookup.notFoundLocation': 'الموقع غير موجود',
  'lookup.notFoundGroup': 'المجموعة غير موجودة',
  'lookup.employeeStatus': 'حالة الموظف',
  'lookup.addEmployeeStatus': 'إضافة حالة موظف',
  'lookup.employeeType': 'نوع الموظف',
  'lookup.addEmployeeType': 'إضافة نوع موظف',
  'lookup.entity': 'وحدة العمل',
  'lookup.level': 'المستوى',
  'lookup.parent': 'الأب',
  'lookup.entityLevel': 'مستوى وحدة العمل',
  'lookup.addEntityLevel': 'إضافة مستوى وحدة عمل',
  'lookup.addLeaveType': 'إضافة نوع إجازة',
  'lookup.isAnnualLeave': 'إجازة سنوية',
  'lookup.leaveType': 'نوع الإجازة',
  'lookup.userType': 'نوع المستخدم',
  'lookup.isManager': 'مدير',
  'lookup.isHr': 'موارد بشرية',
  'lookup.religion': 'الدين',
  'lookup.addReligion': 'إضافة دين',
  'lookup.workLocation': 'موقع العمل',
  'lookup.lat': 'خط العرض',
  'lookup.long': 'خط الطول',
  'lookup.mapUrl': 'رابط الخريطة',
  'lookup.radius': 'نصف القطر',
  'lookup.addWorkLocation': 'إضافة موقع عمل',
  'lookup.jobGrade': 'الدرجة الوظيفية',
  'lookup.addJobGrade': 'إضافة درجة وظيفية',
  'lookup.scheduleCategory': 'فئة الجدول',
  'lookup.addScheduleCategory': 'إضافة فئة جدول',
  'lookup.groupType': 'نوع المجموعة',
  'lookup.edit': 'تعديل',
  'lookup.export': 'تصدير',
  'lookup.delete': 'حذف',
  'lookup.copy': 'نسخ',
  'lookup.view': 'عرض',
  'lookup.usertypePrivileges': 'صلاحيات نوع المستخدم',
  'lookup.menuList': 'عناصر القائمة',
  'lookup.elementType': 'نوع العنصر',
  'lookup.employementStatus': 'حالة',
  'lookup.addUserType': 'إضافة نوع المستخدم',
  'lookup.addEntity': 'ََإضافة وحدة عمل',
  'lookup.promotionType': 'نوع التحفيز',
  'lookup.addPermissionType': 'إضافة نوع الإذن',
  'lookup.workschedule': 'جدول العمل',
  'lookup.policy': 'سياسة',
  'lookup.duplicateRecordMessage': 'يوجد سجل نشط بنفس الاسم العربي أو الاسم الإنجليزي أو الكود بالفعل.',
  'lookup.employmentcategory': 'فئة',
  'lookup.schedulecategory': 'فئة الجدول الزمني',
  'lookup.employmentType': 'يكتب',
  'lookup.department': 'القسم',
  'lookup.pleaseFixFollowingFields': 'يرجى تصحيح الحقول التالية',
  'lookup.pleaseFillRequiredFieldsInGeneralTab': 'يرجى تعبئة جميع الحقول المطلوبة في تبويب عام',
  'lookup.pleaseSelectAtLeastOnePermissionForUserRole': 'يرجى اختيار صلاحية واحدة على الأقل لهذا الدور',
  'lookup.selectedEmployees': 'الموظفون المحددون',
  'lookup.sortByNameArabic': 'فرز حسب الاسم (بالعربية)',
  'lookup.sortByNameEnglish': 'فرز حسب الاسم (بالإنجليزية)',
  'lookup.sortByEmployeeNo': 'فرز حسب رقم الموظف',
  'lookup.noEmployeeSelected': 'لم يتم تحديد أي موظف',
  'lookup.pleaseSelectAtLeastOneEmployeeForGroup': 'يرجى اختيار موظف واحد على الأقل لهذه المجموعة',
  'common.general': 'عام',
  'common.privileges': 'الصلاحيات',
  'lookup.selectPermissionsForThisUserRole': 'حدد الصلاحيات لهذا الدور',
  'lookup.noPermissionsMatchSearch': 'لا توجد صلاحيات تطابق البحث',
  'lookup.noPermissionsAvailable': 'لا توجد صلاحيات متاحة',
  'lookup.module': 'وحدة',
  'lookup.permissionSettingsFor': 'إعدادات الصلاحيات لـ {module}',
  'lookup.untitledSection': 'قسم بدون عنوان',
  'lookup.fullMenuAccess': 'وصول كامل للقائمة',
  'lookup.unnamedPermission': 'صلاحية بدون اسم',
  'lookup.metrics': 'المقاييس',
  'lookup.details': 'تفاصيل',
  'lookup.customReport': 'تقرير مخصص',
  'lookup.selectCustomReport': 'اختر تقرير مخصص',
  'lookup.loginConfigurationDescription': 'تكوين إعدادات تسجيل الدخول لطرق المصادقة',
  'lookup.loginType': 'نوع تسجيل الدخول',
  'lookup.usernameAndPassword': 'اسم المستخدم وكلمة المرور',
  'lookup.azureLogin': 'تسجيل الدخول عبر Azure',
  'lookup.both': 'كلاهما',
  'lookup.tenantId': 'معرف المستأجر',
  'lookup.enterTenantId': 'أدخل معرف المستأجر',
  'lookup.clientId': 'معرف العميل (معرف التطبيق)',
  'lookup.enterClientId': 'أدخل معرف العميل',
  'lookup.redirectUri': 'URI إعادة التوجيه',
  'lookup.enterRedirectUri': 'أدخل URI إعادة التوجيه',
  'lookup.issuerUrl': 'رابط المُصدر',
  'lookup.enterIssuerUrl': 'أدخل رابط المُصدر',
  'error.failedToSaveLoginConfiguration': 'فشل في حفظ تكوين تسجيل الدخول',
  'error.invalidUrlFormat': 'تنسيق URL غير صالح',
  'lookup.emailConfiguration': 'تكوين',
  'lookup.emailConfigurationDescription': 'تكوين إعدادات البريد الإلكتروني لإرسال الإشعارات والرسائل',
  'lookup.readers': 'القارئين',
  'lookup.readerType': 'نوع القارئ',
  'lookup.ipAddress': 'عنوان IP',
  'lookup.isActive': 'نشط',
  'lookup.providerType': 'نوع المزود',
  'lookup.host': 'المضيف',
  'lookup.enterHost': 'أدخل مضيف SMTP (مثال: smtp.gmail.com)',
  'lookup.port': 'المنفذ',
  'lookup.enterPort': 'أدخل رقم المنفذ (مثال: 587)',
  'lookup.username': 'اسم المستخدم',
  'lookup.enterUsername': 'أدخل اسم مستخدم البريد الإلكتروني',
  'lookup.password': 'كلمة المرور',
  'lookup.enterPassword': 'أدخل كلمة مرور البريد الإلكتروني',
  'lookup.apiKey': 'مفتاح API',
  'lookup.enterApiKey': 'أدخل مفتاح API (إذا كان ينطبق)',
  'lookup.fromEmail': 'بريد إلكتروني المرسل',
  'lookup.enterFromEmail': 'أدخل عنوان البريد الإلكتروني المرسل',
  'lookup.displayName': 'اسم العرض',
  'lookup.enterDisplayName': 'أدخل اسم العرض',
  'lookup.enableSSL': 'تفعيل SSL',
  'lookup.testEmail': 'اختبار البريد الإلكتروني',
  'lookup.sendTestMail': 'إرسال بريد تجريبي',
  'lookup.sendTestEmail': 'إرسال بريد إلكتروني تجريبي',
  'lookup.recipientEmail': 'بريد المستلم',
  'lookup.enterRecipientEmail': 'أدخل البريد الإلكتروني للمستلم',
  'lookup.subject': 'الموضوع',
  'lookup.enterEmailSubject': 'أدخل موضوع البريد الإلكتروني',
  'lookup.body': 'المحتوى',
  'lookup.enterEmailBody': 'أدخل محتوى البريد الإلكتروني',
  'lookup.sending': 'جاري الإرسال...',
  'lookup.send': 'إرسال',
  'lookup.cancel': 'إلغاء',
  'lookup.optional': 'اختياري',
  
  // Mobile Configuration
  'lookup.mobileConfiguration': 'تكوين الجوال',
  'lookup.mobileApplication': 'تطبيق الجوال',
  'lookup.mobileApplicationUsageAndRestrictions': 'استخدام تطبيق الجوال والقيود',
  'lookup.companyConfiguration': '1. إعدادات الشركة',
  'lookup.allowEmployeesMobileAccess': 'إعداد لجميع الشركة لتحديد إمكانية وصول الموظفين',
  'lookup.deviceBufferMinutes': 'زمن مخزن الجهاز (بالدقائق)',
  'lookup.locationAndGeoValidationConfigurations': '2. إعدادات الموقع والتحقق الجغرافي',
  'lookup.deviceAndSecurityConfigurations': '3. إعدادات الجهاز والأمان',
  'lookup.timeAndPunchingRules': '4. قواعد الوقت والتسجيل',
  'lookup.requiredGpsAccuracyMeters': 'دقة GPS المطلوبة (بالمتر)',
  'lookup.maxDistanceAllowedFromOfficeMeters': 'الحد الأقصى للمسافة المسموح بها من المكتب (بالمتر)',
  'lookup.enforceGeoFence': 'تفعيل السياج الجغرافي',
  'lookup.deviceBufferCheck': 'فحص مخزن الجهاز',
  'lookup.maxAllowedRegisteredDevicesPerEmployee': 'الحد الأقصى للأجهزة المسجلة لكل موظف',
  'lookup.allowEarlyPunchMinutesBeforeShift': 'السماح بالتسجيل المبكر (دقائق قبل ورديات العمل)',
  'lookup.allowLatePunchMinutesAfterShift': 'السماح بالتسجيل المتأخر (دقائق بعد ورديات العمل)',
  'lookup.limitPunchCountPerDay': 'تحديد عدد التسجيلات في اليوم',
  'lookup.minimumDifferenceBetweenTwoPunchesMinutes': 'الحد الأدنى للفارق بين تسجيلين (بالدقائق)',
  'lookup.examplePlaceholder': 'مثال: {value}',

  // Addon Configuration
  'lookup.addonConfiguration': 'تكوين الإضافات',
  'lookup.requestNameEnglish': 'اسم الطلب بالإنجليزية',
  'lookup.requestNameArabic': 'اسم الطلب بالعربية',
  'lookup.requestTypeId': 'معرف نوع الطلب',

  // Mobile Application
  'mobile.mobileApplication': 'تطبيق الجوال',
  'mobile.mobileConfiguration': 'تكوين الجوال',
  'mobile.allowMobileAccess': 'السماح بالوصول عبر الجوال',
  'mobile.allowMobileAccessDesc': 'يمكن للموظف تسجيل الدخول إلى تطبيق BOS Attendance.',
  'mobile.allowPunchInOutMobileApp': 'السماح بتسجيل الدخول/الخروج عبر تطبيق الجوال',
  'mobile.allowPunchInOutMobileAppDesc': 'تسجيل الحضور والانصراف من تطبيق الجوال.',
  'mobile.locationCheck': 'التحقق من الموقع',
  'mobile.locationCheckDesc': 'السماح بتسجيل الحضور فقط داخل',
  'mobile.deviceLimit': 'الحد الأقصى للأجهزة',
  'mobile.deviceLimitDesc': 'أقصى عدد أجهزة معتمدة يمكن لهذا الموظف استخدامها.',
  'mobile.registeredDevices': 'الأجهزة المسجلة',
  'mobile.devicesSeen': 'جهاز/أجهزة',
  'mobile.deviceID': 'معرف الجهاز',
  'mobile.registered': 'تاريخ التسجيل',
  'mobile.lastActive': 'آخر نشاط',
  'mobile.lastAction': 'آخر إجراء',
  'mobile.viewActivity': 'عرض السجل',
  'mobile.hideHistory': 'إخفاء السجل',
  'mobile.signOutAllDevices': 'تعطيل جميع الأجهزة',
  'mobile.block': 'تعطيل',
  'mobile.deactivateDeviceConfirm': 'هل أنت متأكد أنك تريد تعطيل هذا الجهاز؟',
  'mobile.deactivate': 'تعطيل',
  'mobile.activateDeviceConfirm': 'هل أنت متأكد أنك تريد تفعيل هذا الجهاز؟',
  'mobile.activate': 'تفعيل',
  'mobile.deactivateAllDevicesConfirm': 'هل أنت متأكد أنك تريد تعطيل جميع الأجهزة لهذا الموظف؟',
  'mobile.deactivateAllDevices': 'تعطيل جميع الأجهزة',
  // Mobile app device error messages
  'mobile.error.noDevicesToUpdate': 'لا يوجد ما يتم تحديثه: لا توجد أجهزة أو أن جميعها بالفعل في الحالة المطلوبة.',
  'mobile.error.deviceNotFound': 'معرف الجهاز غير موجود لهذه الشركة.',
  'mobile.error.deviceRegisteredToAnotherEmployee': 'هذا الجهاز مسجل بالفعل لموظف آخر في الشركة.',
  'mobile.error.maxDevicesReached': 'لدى هذا الموظف بالفعل الحد الأقصى من الأجهزة النشطة المسموح بها.',
  'mobile.error.deviceAlreadyActive': 'الجهاز نشط بالفعل.',
  'mobile.error.deviceAlreadyInactive': 'الجهاز معطل بالفعل.',
  'mobile.error.deviceDeactivated': 'تم تعطيل هذا الجهاز بواسطة المسؤول.',
  'mobile.error.appVersionNotSupported': 'إصدار التطبيق على هذا الجهاز غير مدعوم. يرجى تحديث التطبيق.',
  'mobile.error.mobileConfigurationNotFound': 'إعدادات الجوال غير موجودة لهذه الشركة، لذلك لا يمكن التحقق من حد الأجهزة.',
  'mobile.error.saveFailed': 'فشل حفظ إعدادات الجهاز. يرجى المحاولة مرة أخرى.',
  'mobile.unblock': 'إلغاء الحظر',
  'mobile.remove': 'إزالة',
  'mobile.setAsPrimary': 'تعيين كجهاز أساسي',
  'mobile.primary': 'أساسي',
  'mobile.blocked': 'محظور',
  'mobile.blockedBy': 'حظر بواسطة',
  'mobile.blockedOn': 'تاريخ الحظر',
  'mobile.reason': 'السبب',
  'mobile.mobileHistory': 'سجل الجوال',
  'mobile.eventID': 'معرف الحدث',
  'mobile.action': 'الإجراء',
  'mobile.dateTime': 'التاريخ والوقت',
  'mobile.fromDate': 'من التاريخ',
  'mobile.toDate': 'إلى التاريخ',

  'error.failedToLoadData': 'فشل في تحميل البيانات',
  'error.failedToLoadPermissions': 'فشل في تحميل الصلاحيات',
  'employee.editEmployee': 'تعديل موظف',
  'employee.selectEmployee': 'اختر موظف',
  'menu.lookupGroup.employee': 'الموظفين',
  'menu.lookupGroup.request': 'الطلبات',
  'menu.lookupGroup.rbac': 'صلاحيات الوصول',
  'menu.lookupGroup.general': 'عام',
  'recalculateAttendance.employeeAttendance': 'حضور الموظف',
  'recalculateAttendance.entityAttendance': 'حضور الكيان',
  'exception.entityException': 'استثناء القسم',

  //Permission

  'permission.permissionRequest': 'طلب إذن',
  'permission.permissionRequestHR':'طلب صلاحية إدارة الأفراد',
  'permission.addPermssionRequest': 'إضافة طلب إذن',
  'permission.editPermssionRequest': 'تعديل طلب الإذن',
  'permission.permissionSummary': 'ملخص الأذونات',
  'permission.requested': 'المطلوبة',
  'permission.consumed': 'المستهلكة',
  'permission.pending': 'المعلقة',
  'permission.remaining': 'المتبقية',
  'permission.allowed': 'المسموحة',
  'permission.loadingForm': 'جاري تحميل النموذج...',
  'permission.failedToLoadForm': 'فشل في تحميل النموذج.',
  'permission.allowedMaxDuration': 'أقصى مدة مسموح بالتقديم عليها هي',
  'permission.requiredMinimum': 'الحد الأدنى المطلوب',
  'permission.workingHoursToApply': 'ساعات العمل للتقديم',
  'permission.hours': 'ساعات',
  'permission.schedule': 'الجدول',
  'permission.flex': 'مرن',
  'permission.entityPermissionRequest': 'طلب إذن كيان',
  'permission.companyPermissionRequest': 'طلب إذن شركة',
  'permission.locationPermissionRequest': 'طلب إذن موقع',
  'permission.groupPermissionRequest': 'طلب إذن مجموعة',
  'permission.permissionSavedSuccessfully': 'تم تقديم طلب الإذن بنجاح',
  'permission.permissionRequestError': 'خطأ في طلب الإذن',
  'permissionRequest.error.invalidDateOrShiftPatternOrDuration': 'تاريخ غير صالح / نمط دوام غير صالح / مدة غير صالحة',
  'permissionRequest.error.allowedBeforeDaysExceeded': 'يجب تقديم هذا الطلب قبل {AllowedBefore} يوم/أيام على الأقل من تاريخ الإذن.',
  'permissionRequest.error.allowedAfterDaysExceeded': 'لا يمكن تقديم هذا الطلب قبل أكثر من {AllowedAfter} يوم/أيام من تاريخ الإذن.',
  'permissionRequest.error.overlapWithAnotherPermission': 'تداخل مع إذن آخر.',
  'permissionRequest.error.cannotUpdateWhilePendingApproval': 'لا يمكنك تعديل طلب الإذن طالما أنه بانتظار الموافقة أو قيد إجراءات الموافقة، أو قد لا تملك الصلاحية اللازمة لتعديله.',
  'permissionRequest.error.invalidDateRangeNull': 'نطاق التاريخ غير صالح: تاريخ البداية أو النهاية مفقود.',
  'permissionRequest.error.toDateEarlierThanFromDate': 'نطاق التاريخ غير صالح: تاريخ النهاية لا يمكن أن يكون قبل تاريخ البداية.',
  'permissionRequest.error.initialState': 'لم يبدأ التنفيذ بعد.',
  'permissionRequest.error.minMaxDurationNotDefined': 'إعدادات الحد الأدنى/الأقصى لمدة الإذن غير مُعرَّفة.',
  'permissionRequest.error.requestedDurationAboveMaximum': 'المدة المطلوبة تتجاوز الحد الأقصى المسموح.',
  'permissionRequest.error.requestedDurationBelowMinimum': 'المدة المطلوبة أقل من الحد الأدنى المسموح.',
  'permissionRequest.error.monthlyLimitExceeded': 'تم تجاوز الحد الشهري.',
  'permissionRequest.error.dailyLimitExceeded': 'تم تجاوز الحد اليومي.',
  'permissionRequest.error.notAllowedBeforeJoinDate': 'غير مسموح قبل تاريخ التحاق الموظف.',
  'permissionRequest.error.notAllowedAfterTerminationDate': 'غير مسموح بعد تاريخ إنهاء خدمة الموظف.',
  'permissionRequest.error.pendingActionTypeRecalNotFound': 'نوع الإجراء RECAL غير موجود في TimeManagementLookups.',
  'permissionRequest.error.workflowConfigurationMissing': 'لم يتم العثور على إعدادات المصادقة الخاصة بسير العمل.',
  'permissionRequest.error.configurationNotFoundInactive': 'لم يتم العثور على إعدادات طلب الإذن أو أنها غير فعالة/غير ملائمة.',
  'permissionRequest.error.fullDayNoValidScheduleOrRange': 'فشل إذن اليوم الكامل: لم يتم العثور على جدول عمل/نطاق زمني صالح.',
  'permissionRequest.error.invalidTimeRangeNullOrOrder': 'نطاق الوقت غير صالح: وقت البداية أو النهاية فارغ، أو وقت النهاية أقل/يساوي وقت البداية.',
  'permissionRequest.error.workflowDefinitionMissing': 'تعريف سير العمل مفقود لطلب إذن الموظف.',
  'permissionRequest.error.workflowSubmitActionNotFound': 'تعذر العثور على إجراء الإرسال في سير العمل.',
  'permissionRequest.error.requiredStatusNotFound': 'تعذر العثور على الحالة المطلوبة (الموافقة التلقائية، مطلوب، أو مُعتمد).',
  'permissionRequest.error.requestNotFoundOrDeleted': 'طلب الإذن غير موجود أو تم حذفه.',
  'permissionRequest.error.updateNoActiveRecord': 'فشل تحديث طلب الإذن لأنه لم يتم تحديث أي سجل نشط.',
  'permissionRequest.error.genericWorkflowFailure': 'فشل سير العمل في معالجة الطلب.',
  'permissionRequest.error.unexpectedSystemError': 'حدث خطأ غير متوقع في النظام/قاعدة البيانات. يرجى المحاولة لاحقًا أو التواصل مع المسؤول.',
  'permissionRequest.error.eligibilityFailed': 'فشل التحقق من أهلية الإذن.',
  'permissionRequest.error.workflowSpecificFailure': 'فشل تحقق/معالجة خاص بسير العمل.',
  'permission.noFormDefinitionFound': 'لم يتم العثور على تعريف للنموذج.',
  'permission.field': 'حقل',
  'permission.cannotModifyFinalStatus': 'لا يمكن تعديل طلب تمت الموافقة عليه أو رفضه',
  'permission.delete.error.-101': 'لم يتم العثور على الإذن أو تم حذفه بالفعل',
  'permission.delete.error.-102': 'نوع إجراء إعادة الحساب غير مُكوَّن',
  'permission.delete.error.-103': 'غير مُخوَّل أو حالة غير صالحة',
  'permission.delete.error.-500': 'خطأ غير متوقع في قاعدة البيانات/النظام',
  'permission.invalidResponseData': 'بيانات الاستجابة غير صالحة',
  'permission.noPermissionFound': 'لم يتم العثور على أذونات لهذا الموظف',
  'permission.formNoFields': 'لا يحتوي تعريف النموذج على حقول.',

  // Remote Work Delete Error Messages
  'remoteWork.delete.error.-101': 'لم يتم العثور على طلب العمل عن بُعد أو تم حذفه بالفعل',
  'remoteWork.delete.error.-102': 'نوع إجراء إعادة الحساب غير مُكوَّن',
  // -103 uses api.error.103.remote.message
  'remoteWork.delete.error.-500': 'خطأ غير متوقع في قاعدة البيانات/النظام',

  // Leave Delete Error Messages
  'leave.delete.error.-101': 'لم يتم العثور على طلب الإجازة أو تم حذفه بالفعل',
  'leave.delete.error.-102': 'نوع إجراء إعادة الحساب غير مُكوَّن',
  // -103 uses api.error.103.message
  'leave.delete.error.-500': 'خطأ غير متوقع في قاعدة البيانات/النظام',

  // Manual Entry Delete Error Messages
  'manualEntry.delete.error.-101': 'لم يتم العثور على الإدخال اليدوي أو تم حذفه بالفعل',
  'manualEntry.delete.error.-102': 'نوع إجراء إعادة الحساب غير مُكوَّن',
  // -103 uses api.error.103.manual.message
  'manualEntry.delete.error.-500': 'خطأ غير متوقع في قاعدة البيانات/النظام',
  'permission.noDataFound': 'لم يتم العثور على بيانات',
  'permission.failedToLoadData': 'فشل تحميل البيانات',
  'permission.requiredMinimum': 'الحد الأدنى المطلوب',
  'permission.loadingForm': 'جاري تحميل النموذج...',
  'permission.requestFailed': 'فشل في حفظ طلب الإذن',

  'error.isRequired': 'مطلوب',
  'common.verifiedSuccessfully': 'تم التحقق بنجاح',
  'error.invalidEmployee': 'موظف غير صالح',
  'error.toTimeMustBeGreaterThanFromTime': 'يجب أن يكون وقت الانتهاء بعد وقت البدء',
  'error.failedToLoadData': 'فشل تحميل البيانات',

  //remoteWork
  'remoteWork.remoteWorkRequests': 'طلبات العمل عن بعد',
  'remoteWork.newRemoteWorkRequest': 'إضافة طلب عمل عن بعد',
  'remoteWork.remoteValidData': 'يرجى اختيار بيانات صحيحة',
  'remoteWork.editRemoteWorkRequest': 'تعديل طلب العمل عن بعد',
  'remoteWork.remoteWorkSummary': 'ملخص العمل عن بعد',
  'remoteWork.remoteWorkRequest': 'طلب العمل عن بعد',
  'remoteWork.remoteWorkRequestHR':'طلب العمل عن بعد إدارة الأفراد',
  'remoteWork.allowedMaxDurationMonth': 'الحد الأقصى المسموح به في الشهر هو',
  'remoteWork.showDetails': 'إظهار التفاصيل',
  'remoteWork.days': 'أيام',
  'remoteWork.error.failedToFetchDetails': 'فشل في جلب تفاصيل طلب العمل عن بعد',
  'remoteWork.error.title': 'خطأ في طلب العمل عن بعد',
  'remoteWork.loadingForm': 'جاري تحميل النموذج...',
  'remoteWork.notEligibleForPeriod': 'أنت غير مؤهل للعمل عن بعد خلال هذه الفترة.',


  //Announcement
  'announcement.announcementReq' : 'إعلان',

  'announcement.newAnnouncement': 'إضافة إعلان',
  'announcement.editAnnouncement': 'تعديل إعلان',
  'announcement.headerEn': 'العنوان (إنجليزي)',
  'announcement.headerAr': 'العنوان (عربي)',
  'announcement.bodyEn': 'المحتوى (إنجليزي)',
  'announcement.bodyAr': 'المحتوى (عربي)',
  'announcement.announcementDate': 'تاريخ الإعلان',
  'announcement.attachment': 'مرفق',
  'announcement.announcementType': 'نوع الإعلان',
  'announcement.updated': 'تم تحديث الإعلان',
  'announcement.created': 'تم إنشاء الإعلان',

  //Delegation

  'delegation.delegation': 'تفويض',
  'delegation.addDelegation': 'إضافة تفويض',
  'delegation.enableEndDate': 'فعّال حتى تاريخ',
  'delegation.currentManager': 'المدير الحالي',
  'delegation.enabletoDate': 'تفعيل فترة محددة',

  //Work Schedule
  'workSchedule.workSchedule': 'جدول العمل',
  'workSchedule.workScheduleExpansion': 'عرض جدول العمل',
  'workSchedule.addWorkSchedule': 'غضافة جدول دوام',
  'workSchedule.normalSchedule': 'جدول عادي',
  'workSchedule.scheduleCategory': 'فئة جدول العمل',
  'workSchedule.ramadanSchedule': 'جدول رمضان',
  'workSchedule.shift1': 'الوردية 1',
  'workSchedule.flexDuration': 'المدة المرنة',
  'workSchedule.minRequired': 'الحد الأدنى المطلوب',
  'workSchedule.isOffDay': 'يوم راحة',
  'workSchedule.nameAr': 'اسم الجدول (العربية)',
  'workSchedule.nameEn': 'اسم الجدول (الإنجليزية)',
  'workSchedule.targetEmployees': 'الموظفون المعنيون',
  'workSchedule.updateWorkSchedule': 'تعديل جدول العمل',
  'workSchedule.sameDataEntryOfRamadan': 'الفترة الزمنية موجودة بالفعل',
  /// Schedule Assignment
  'assignWorkSchedule.scheduleAssignment': 'تعيين الوردية',
 'assignWorkSchedule.editScheduleAssignment': 'تعديل تعيين الوردية',
  'assignWorkSchedule.addScheduleAssignment': 'إضافة تعيين الوردية',
  'assignWorkSchedule.assignWorkSchedule': 'تعيين جدول العمل',
  'assignWorkSchedule.schedules': 'الجداول',
  'assignWorkSchedule.viewAssignedSchedules': 'عرض الجداول المعينة',
  'assignWorkSchedule.workScheduleExpansion': 'عرض جدول العمل',
  'assignWorkSchedule.emergencySchedule': 'جدول الطوارئ',
  'assignWorkSchedule.temporary': 'مؤقت',
  'assignWorkSchedule.assign': 'تعيين',
  'assignWorkSchedule.assignmentType': 'نوع التعيين',

  // User role assignment
  'userRoleAssignment.userRoleAssignment': 'تعيين دور المستخدم',
  'userRoleAssignment.userRoleAssignmentAdd': 'تعيين دور المستخدم',
  'userRoleAssignment.userRoleAssignmentEdit': 'تعديل تعيين دور المستخدم',
  'userRoleAssignment.updateSuccess': 'تم تحديث تعيين دور المستخدم بنجاح!',
  'userRoleAssignment.saveSuccess': 'تم حفظ تعيين دور المستخدم بنجاح!',
  'userRoleAssignment.addUserRole': 'إضافة دور مستخدم',
  'userRoleAssignment.createdByEmployee': 'تم الإنشاء بواسطة الموظف',
  'userRoleAssignment.createdDate': 'تاريخ الإنشاء',
  'userRoleAssignment.lastUpdatedByEmployee': 'آخر تحديث بواسطة الموظف',
  'userRoleAssignment.lastUpdatedDate': 'تاريخ آخر تحديث',
  'userRoleAssignment.blockedUserScreen': 'حظر شاشات المستخدم',
  'userRoleAssignment.addBlockedUserScreen': 'إضافة حظر شاشات المستخدم',
  'userRoleAssignment.editBlockedUserScreen': 'تعديل حظر شاشات المستخدم',
  'userRoleAssignment.targetName': 'الهدف',
  'userRoleAssignment.blockedScreens': 'الشاشات المحظورة',
  'userRoleAssignment.selectAtLeastOneScreen': 'يرجى اختيار شاشة واحدة على الأقل',

  // Workflow Builder
  'workflow.workflowBuilder': 'إعداد سير العمل',
  'workflow.nameEn': 'الاسم بالإنجليزية',
  'workflow.stageOrder': 'ترتيب المرحلة',
  'workflow.formName': 'اسم النموذج',
  'workflow.assignType': 'نوع التعيين',
  'workflow.escalatedAfter': 'تصعيد بعد',
  'workflow.escalateAction': 'إجراء التصعيد',
  'workflow.workflowFor': 'نوع سير العمل',
  'workflow.selectWorkflow': 'اختر سير العمل',
  'workflow.formId':'رقم النموذج',
  'workflow.assignTo':'تعيين',
  'workflow.actions':'إجراءات',
  'workflow.notificationType':'نوع الإشعار',
  'workflow.notification': 'إشعار',
  'workflow.escalateType':'نوع التصعيد',
  'workflow.escalateDays':'بعد أيام',
  'workflow.approvalStages': 'مراحل الموافقة على سير العمل',
  'workflow.actor': 'ممثل سير العمل',
  'workflow.actorType': 'نوع الممثل',
  'workflow.selectActorType': 'اختر نوع الممثل',
  'workflow.selectWorkflowActor': 'اختر ممثل سير العمل',
  'workflow.attachLinkForm': 'إرفاق/ربط نموذج',
  'workflow.requiredActions': 'الإجراءات المطلوبة',
  'workflow.rejectionReason': 'سبب الرفض مطلوب',
  'workflow.selectForm': 'اختر النموذج',
  'workflow.pleaseClickToSelectTheForm': 'الرجاء الضغط لاختيار النموذج',
  'workflow.formList': 'قائمة النماذج',
  'workflow.pleaseSelectFormBelow': 'الرجاء اختيار النموذج الموضح أدناه',
  'workflow.noFormsAvailable': 'لا توجد نماذج متاحة لنوع سير العمل هذا.',
  'workflow.createNewForm': 'إنشاء نموذج جديد',
  'workflow.createForm': 'إنشاء نموذج +',
  'workflow.untitledForm': 'نموذج بدون عنوان',
  'workflow.untitledField': 'حقل بدون عنوان',
  'workflow.enterDaysPlaceholder': 'أدخل عدد الأيام',
  'workflow.noFieldsInThisForm': 'لا توجد حقول في هذا النموذج',
  'workflow.enterPlaceholder': 'أدخل...',
  'workflow.selectPlaceholder': 'اختر...',
  'workflow.email': 'البريد الإلكتروني',
  'workflow.sms': 'رسالة نصية',
  'workflow.pushNotification': 'إشعار دفع',
  'workflow.all': 'الكل',
  'workflow.chooseAnyAction': 'مطلوب إجراء: يرجى اختيار إجراء',
  'workflow.enableAll': 'تمكين الكل',
  'workflow.submitted': 'تم الإرسال',
  'workflow.notificationConfiguration': 'إعدادات الإشعارات',
  'workflow.enableAction': 'تمكين الإجراء',
  'workflow.action': 'الإجراء',
  'workflow.enableNotification': 'تمكين الإشعار',

  // Form Builder
  'form.formBuilder': 'منشئ النماذج',
  'form.BacktoList': 'العودة إلى القائمة',
  'form.formType': 'نوع النموذج',
  'form.Code': 'شفرة',
  'form.FormNameEn': 'اسم النموذج (الإنجليزية)',
  'form.FormNameAr': 'اسم النموذج (العربية)',
  'form.saving': 'جاري الحفظ...',
  'form.Save': 'حفظ',
  'form.Update': 'تحديث',
  'form.components': 'المكونات',
  'form.search': 'بحث',
  'form.build': 'بناء',
  'form.preview': 'معاينة',
  'form.code': 'شفرة',
  'form.formConfiguration': 'تكوين النموذج',
  'form.copyToClipboard': 'نسخ إلى الحافظة',
  'form.fieldProperties': 'خصائص الحقل',
  'form.labelText': 'نص التسمية',
  'form.labelTextEn': 'نص التسمية (EN)',
  'form.labelTextAr': 'نص التسمية (AR)',
  'form.enterLabelPlaceholder': 'يرجى إدخال نص التسمية...',
  'form.enterLabelEnPlaceholder': 'يرجى إدخال نص التسمية بالإنجليزية...',
  'form.enterLabelArPlaceholder': 'يرجى إدخال نص التسمية بالعربية...',
  'form.tooltip': 'تلميح',
  'form.enterTooltipPlaceholder': 'يرجى إدخال نص التلميح هنا...',
  'form.hintValue': 'قيمة التلميح',
  'form.hintValueEn': 'قيمة التلميح (EN)',
  'form.hintValueAr': 'قيمة التلميح (AR)',
  'form.enterHintPlaceholder': 'يرجى إدخال قيمة التلميح هنا...',
  'form.enterHintEnPlaceholder': 'يرجى إدخال قيمة التلميح بالإنجليزية...',
  'form.enterHintArPlaceholder': 'يرجى إدخال قيمة التلميح بالعربية...',
  'form.dropdownType': 'نوع القائمة المنسدلة',
  'form.customOptions': 'خيارات مخصصة',
  'form.countryList': 'قائمة الدول',
  'form.numberRange': 'نطاق الأرقام',
  'form.predefinedData': 'بيانات محددة مسبقًا',
  'form.predefinedType': 'نوع البيانات المحددة مسبقًا',
  'form.selectType': 'اختر النوع...',
  'form.options': 'خيارات',
  'form.enterOption': 'أدخل الخيار...',
  'form.addOption': 'إضافة خيار',
  'form.min': 'الحد الأدنى',
  'form.max': 'الحد الأقصى',
  'form.fieldWidth': 'عرض الحقل',
  'form.fullWidth': 'العرض الكامل',
  'form.halfWidth': 'نصف العرض',
  'form.oneThird': 'ثلث العرض',
  'form.selectWidth': 'اختر العرض...',
  'form.mandatoryField': 'حقل إلزامي',
  'form.noFieldsAdded': 'لم يتم إضافة حقول نموذج بعد.',
  'form.noFieldsDescription': 'يبدو أنك لم تقم بإضافة أي حقول نموذج بعد. انقر على زر "إضافة حقل" لبدء بناء نموذجك.',
  'form.addField': 'إضافة حقل',
  'form.loadingFormDetails': 'جاري تحميل تفاصيل النموذج...',
  'form.dropHere': 'قم بالإسقاط هنا',
  'form.dragToMove': 'اسحب للتحريك',
  'form.duplicate': 'تكرار',
  'form.edit': 'تعديل',
  'form.delete': 'حذف',
  'form.addRow': 'إضافة صف',
  'form.gridSettings': 'إعدادات الشبكة',
  'form.deleteRow': 'حذف الصف',
  'form.on': 'تشغيل',
  'form.off': 'إيقاف',
  'form.from': 'من',
  'form.to': 'إلى',
  'form.loadingFormDetails': 'جاري تحميل تفاصيل النموذج...',
  'form.validation.required': 'هذا الحقل مطلوب.',
  'form.validation.validEmail': 'يرجى إدخال عنوان بريد إلكتروني صالح.',
  'form.validation.selectOption': 'يرجى اختيار خيار.',
  'form.validation.selectAtLeastOne': 'يرجى اختيار خيار واحد على الأقل.',
  'form.validation.mustBeChecked': 'يجب تحديد هذا الحقل.',
  'form.column.one': 'عمود واحد',
  'form.column.two': 'عمودان',
  'form.column.three': '3 أعمدة',
  'form.error.negativeNumbers': 'الأرقام السالبة غير مسموح بها.',
  'form.error.minMax': 'لا يمكن أن يكون الحد الأدنى أكبر من الحد الأقصى.',
  'form.error.duplicateRowLimit': 'لا يمكن تكرار الحقل: تم الوصول إلى حد الصف.',
  'form.error.fieldWidthLimit': 'عرض الحقل يتجاوز حد الصف.',
  'form.error.minRequired': 'الحد الأدنى مطلوب ويجب أن يكون رقماً',
  'form.error.maxRequired': 'الحد الأقصى مطلوب ويجب أن يكون رقماً',
  'form.error.fillRequired': 'يرجى ملء أسماء النماذج باللغتين الإنجليزية والعربية والرمز.',
  'form.error.columnLimitExceeded': 'عرض الحقل يتجاوز حد {count} {count, plural, one {عمود} other {أعمدة}} في الصف.',
  'form.error.noFields': 'يرجى إضافة حقل واحد على الأقل لحفظ النموذج.',
  'form.error.saveFailed': 'فشل في حفظ النموذج.',
  'form.error.updateFailed': 'فشل في تحديث النموذج.',
  'form.success.saved': 'تم حفظ النموذج بنجاح!',
  'form.success.updated': 'تم تحديث النموذج بنجاح!',
  'form.error.missingProperties': 'يرجى ملء الخصائص المفقودة',
  'form.noFieldsYet': 'لا توجد حقول حتى الآن',
  'form.startBuilding': 'قم بجر وإسقاط المكونات من الشريط الجانبي لبدء بناء نموذجك.',
  'form.placeholder.enterText': 'أدخل النص...',
  'form.placeholder.enterEmail': 'أدخل البريد الإلكتروني...',
  'form.placeholder.enterDescription': 'أدخل الوصف...',
  'form.placeholder.enterNumber': 'أدخل الرقم...',
  'form.placeholder.selectOption': 'اختر خياراً',
  'form.placeholder.selectMultiple': 'اختر خيارات متعددة',

  // Form Components
  'form.component.input': 'إدخال نص',
  'form.component.textarea': 'منطقة نص',
  'form.component.email': 'البريد الإلكتروني',
  'form.component.dropdown': 'قائمة منسدلة',
  'form.component.multiselect': 'اختيار متعدد',
  'form.component.radio': 'زر خيار',
  'form.component.checkbox': 'خانة اختيار',
  'form.component.number': 'رقم',
  'form.component.date': 'تاريخ',
  'form.component.time': 'وقت',
  'form.component.daterange': 'نطاق التاريخ',
  'form.component.switch': 'تبديل',
  'form.component.file': 'رفع ملف',
  'form.placeholder.uploadFile': 'قم برفع ملف PDF أو Word (الحد الأقصى 10 ميجابايت)',
  'form.validation.fileTooLarge': 'يتجاوز الملف الحد المسموح به 10 ميجابايت.',
  'form.validation.invalidFileType': 'يسمح فقط بملفات PDF أو Word (doc، docx).',

  // Form Categories
  'form.category.textInput': 'النص والإدخال',
  'form.category.selection': 'الاختيار',
  'form.category.numbersDates': 'الأرقام والتواريخ',
  'form.category.interactive': 'تفاعلي',

  // Common Buttons
  'button.add': '+ إضافة',
  'button.addApprovalLevel': 'إضافة مستوى الموافقة',
  'button.save': 'حفظ',
  'button.cancel': 'إلغاء الامر ',
  'button.clear': 'مسح',
  'button.addElement': 'إضافة عنصر',

  // Policy
  'policy.manualEntryWorkFlow': 'سير العمل الادخال اليدوي',
  'policy.TA Policy': 'سياسة الحضور ',
  'policy.policyExpansion': 'عرض السياسة',
  'policy.policy': 'السياسة',
  'policy.policyNameEn': 'اسم السياسة (الإنجليزية)',
  'policy.policyNameAr': 'اسم السياسة (العربية)',
  'policy.remoteWork': 'العمل عن بُعد',
  'policy.remoteWorkFlow': 'سير عمل العمل عن بُعد',
  'policy.addTaPolicy': 'إضافة سياسة',
  'policy.assignPolicy': 'تعيين سياسة',
  'policy.policyAssignment': 'تعيين السياسة',
  'policy.viewAssignedPolicies': 'عرض السياسات المعينة',
   'policy.policies': 'السياسات',
   'policy.assignmentType': 'نوع التعيين',

   // Notification Template
   'notificationTemplate.title': 'إعدادات الإشعارات',
   'notificationTemplate.lastUpdatedDate': 'تاريخ آخر تحديث',
   'notificationTemplate.createdDate': 'تاريخ الإنشاء',
   'notificationTemplate.interval': 'الفترة',
   'notificationTemplate.type': 'النوع',
   'notificationTemplate.operations': 'العمليات',
   'notificationTemplate.deleteConfirm': 'هل أنت متأكد أنك تريد حذف {name}؟',
   'notificationTemplate.recordDeleted': 'تم حذف السجل بنجاح!',
   'notificationTemplate.recordsDeleted': 'سجل(ات) تم حذفها بنجاح!',
   'notificationTemplate.failedToDelete': 'فشل حذف السجلات',
   'notificationTemplate.deleteError': 'حدث خطأ أثناء حذف السجل.',
   'notificationTemplate.exportPDF': 'تصدير PDF',
   'notificationTemplate.exportPDFMsg': 'سيتم تصدير جميع العناصر إلى PDF.',
   'notificationTemplate.exportExcel': 'تصدير إكسل',
   'notificationTemplate.exportExcelMsg': 'سيتم تصدير جميع العناصر إلى .csv',
   'notificationTemplate.importData': 'استيراد البيانات',
   'notificationTemplate.importDataMsg': 'سيتم استيراد جميع العناصر.',
   'notificationTemplate.downloadConfirm': 'تأكيد',
   'notificationTemplate.itemsWillBeDownloaded': 'عنصر(ات) سيتم تحميلها.',
  'policy.targetEmployees': 'الموظفون المعنيون',

  // Recalculate Attendance
  'recalculateAttendance.recalculateAttendance': 'إعادة حساب الحضور',
  'recalculateAttendance.recalculateSchedule': 'إعادة حساب الجدول',
  'recalculateAttendance.createRecalculation': 'إنشاء إعادة حساب',
  'recalculateAttendance.companyAttendance': 'حضور الشركة',
  'recalculateAttendance.entityAttendance': 'حضور الجهة',
  'recalculateAttendance.groupAttendance': 'حضور المجموعة',
  'recalculateAttendance.locationAttendance': 'حضور الموقع',
  'recalculateAttendance.addCompanyRecalculation': 'إضافة إعادة حساب للشركة',
  'recalculateAttendance.addEmployeeRecalculation': 'إضافة إعادة حساب للموظف',
  'recalculateAttendance.addEntityRecalculation': 'إضافة إعادة حساب للجهة',
  'recalculateAttendance.addLocationRecalculation': 'إضافة إعادة حساب للموقع',
  'recalculateAttendance.addGroupRecalculation': 'إضافة إعادة حساب للمجموعة',

  'recalculateAttendance.calculationStory': 'معلمات الاحتساب',
  'recalculateAttendance.shiftInfo': 'معلومات الوردية',
  'recalculateAttendance.inOuts': 'الدخول / الخروج',
  'recalculateAttendance.reasons': 'الأسباب',
  'recalculateAttendance.summary': 'الملخص',
  'recalculateAttendance.transactions': 'الحركات',
  'recalculateAttendance.gaps': 'الفجوات',
  'recalculateAttendance.stepOut': 'الخروجات',
  'recalculateAttendance.calculationStoryHeaders.EmployeeNo': 'رقم الموظف',
  'recalculateAttendance.calculationStoryHeaders.EmployeeID': 'معرف الموظف',
  'recalculateAttendance.calculationStoryHeaders.EmployeeName': 'اسم الموظف',
  'recalculateAttendance.calculationStoryHeaders.NameEn': 'الاسم (بالإنجليزية)',
  'recalculateAttendance.calculationStoryHeaders.NameAr': 'الاسم (بالعربية)',
  'recalculateAttendance.calculationStoryHeaders.Date': 'التاريخ',
  'recalculateAttendance.calculationStoryHeaders.FromTime': 'من الوقت',
  'recalculateAttendance.calculationStoryHeaders.ToTime': 'إلى الوقت',
  'recalculateAttendance.calculationStoryHeaders.StartTime': 'وقت البدء',
  'recalculateAttendance.calculationStoryHeaders.EndTime': 'وقت الانتهاء',
  'recalculateAttendance.calculationStoryHeaders.Duration': 'المدة',
  'recalculateAttendance.calculationStoryHeaders.Reason': 'السبب',
  'recalculateAttendance.calculationStoryHeaders.Remark': 'ملاحظات',
  'recalculateAttendance.calculationStoryHeaders.ReaderIn': 'قارئ الدخول',
  'recalculateAttendance.calculationStoryHeaders.ReaderOut': 'قارئ الخروج',
  'recalculateAttendance.calculationStoryHeaders.TransactionType': 'نوع الحركة',
  'recalculateAttendance.calculationStoryHeaders.DateTime': 'التاريخ/الوقت',
  'recalculateAttendance.calculationStoryHeaders.TransactionTime': 'وقت الحركة',
  'recalculateAttendance.calculationStoryHeaders.shiftDate': 'تاريخ الوردية',
  'recalculateAttendance.calculationStoryHeaders.calculatedFromTime': 'وقت البداية (المحتسب)',
  'recalculateAttendance.calculationStoryHeaders.calculatedToTime': 'وقت النهاية (المحتسب)',
  'recalculateAttendance.calculationStoryHeaders.actualFromTime': 'وقت البداية (الفعلي)',
  'recalculateAttendance.calculationStoryHeaders.actualToTime': 'وقت النهاية (الفعلي)',
  'recalculateAttendance.calculationStoryHeaders.typeName': 'نوع',
  'recalculateAttendance.calculationStoryHeaders.firstIn': 'أول دخول',
  'recalculateAttendance.calculationStoryHeaders.lastOut': 'آخر خروج',
  'recalculateAttendance.calculationStoryHeaders.delay': 'التأخر',
  'recalculateAttendance.calculationStoryHeaders.earlyOut': 'الخروج المبكر',
  'recalculateAttendance.calculationStoryHeaders.actualWorkDuration': 'مدة العمل الفعلية',
  'recalculateAttendance.calculationStoryHeaders.overTimeAfter': 'وقت إضافي بعد',
  'recalculateAttendance.calculationStoryHeaders.overTimeBefore': 'وقت إضافي قبل',
  'recalculateAttendance.calculationStoryHeaders.weeklyDuration': 'المدة الأسبوعية',
  'recalculateAttendance.calculationStoryHeaders.monthlyDuration': 'المدة الشهرية',
  'recalculateAttendance.calculationStoryHeaders.readerName': 'اسم القارئ',
  'recalculateAttendance.calculationStoryHeaders.gapFrom': 'الفجوة من',
  'recalculateAttendance.calculationStoryHeaders.gapTo': 'الفجوة إلى',
  'recalculateAttendance.calculationStoryHeaders.gapMinutes': 'دقائق الفجوة',
  'recalculateAttendance.scheduleTime': 'وقت الجدول',
  'recalculateAttendance.note': 'ملاحظة',
  'common.actionBy': 'تم بواسطة',
  'missingGateTransaction.addMissingGateTransaction':
    'عملية اضافة للحركات المفقودة',
  // Subordinates Requests
  'subordinatesRequests.lastUpdateBy': 'آخر تحديث بواسطة',
  'subordinatesRequests.currentStatus': 'الحالة الحالية',
  'subordinatesRequests.pendingRequests': 'الطلبات المعلقة',
  'subordinatesRequest.trackingRequest': 'تتبع الطلب',
  'subordinatesRequests.trackingRequest': 'تتبع الطلب',
  'subordinatesRequests.approveLeaveRequestQuestion': 'هل تريد الموافقة على طلب الإجازة؟',
  'subordinatesRequests.departmentHeadReviewDecision': 'يمكن لرئيس القسم مراجعة الطلب واتخاذ القرار.',
  'subordinatesRequests.requestDetails': 'تفاصيل الطلب',
  'common.stage': 'مرحلة',
  'common.workSchedule':'جدول العمل',
  'common.mandatory':'الحاجة',
  'workflow.employeeSubmission': 'تقديم الموظف',
  'workflow.managerApproval': 'موافقة المدير',
  'workflow.noRemarksProvided': 'لا توجد ملاحظات.',
  'workflow.rejectionRemark': 'سبب الرفض',
  'workflow.enterRejectionRemark': 'أدخل سبب الرفض',
  // Workflow action result codes
  'workflow.actionResult.0': 'لا توجد نتيجة بعد. يرجى المحاولة مرة أخرى.',
  'workflow.actionResult.1': 'تمت معالجة سير العمل بنجاح.',
  'workflow.actionResult.-1': 'خطأ غير متوقع في النظام.',
  'workflow.actionResult.-3': 'حقول مطلوبة مفقودة.',
  'workflow.actionResult.-6': 'إجراء غير صالح.',
  'workflow.actionResult.-44': 'تعذر العثور على تعريف سير العمل.',
  'workflow.actionResult.-105': 'مرحلة سير العمل غير صالحة.',
  'workflow.actionResult.defaultError': 'فشل في معالجة سير العمل.',
  'leave.leaveTypeAr': 'نوع الاجازة(بالعربية)',
  'leave.leaveTypeEn': 'نوع الاجازة',
  'leave.leaveType': 'نوع الإجازة',
  'leave.employeeCategory': 'فئة الموظف',
  'leave.carryOverBalance': 'عدد ايام الترحيل',
  'leave.Workflow': 'سياسة الموافقة',
  'leave.dayBalance': 'الرصيد',
  'leave.LeaveSettingExpansion': 'خصائص الاجازات',
  'leave.AllowedLeavesPerYear': 'عدد الايام المسموحة (السنة)',
  'leave.carryForwardLeaves': 'عدد الايام المسموح ترحيلها',
  'leave.includeOffDays': 'تضمين ايام العطل',
  'leave.NegativeDays': 'الحد الاعظمي للاجازات برصيد سالب',
  'leave.isProrateBasis': 'هو أساس Prorate',
  'leave.yourAccruedBalance': 'رصيدك المتراكم',

  // Reports
  'reports.probationList': ' الفترة التجريبية',
  'reports.qualificationTypeList': 'نوع المؤهل',
  'reports.export': 'تصدير القائمة',
  'reports.inTime': 'وقت الدخول',
  'reports.delay': 'التأخر',
  'reports.outTime': 'وقت الخروج',
  'reports.earlyOut': 'الخروج المبكر',
  'reports.durationIn': 'المدة',
  'reports.gateViolation': 'مخالفة البوابة',
  'reports.employeeType': 'نوع الموظف',
  'reports.category': 'الفئة',
  'reports.designation': 'المسمى الوظيفي',
  'reports.reportType': 'نوع التقرير',
  'reports.downloadPDF': 'تحميل (PDF)',
  'reports.downloadExcel': 'تحميل (Excel)',
  'reports.startTime': 'وقت البدء',
  'reports.endTime': 'وقت الانتهاء',
  'reports.consumedHours': 'الساعات المستهلكة',
  'reports.timeReq': 'المدة المطلوبة',
  'reports.permType': 'نوع الإذن',
  'reports.submissionDate': 'تاريخ التقديم',
  'reports.leaveDescription': 'الملاحظات',
  'reports.requestsSelectionType': 'تقرير الطلبات',
  'reports.workscheduleReport':'جدول العمل',
  'reports.requestsReport': 'تقرير الطلبات',
  'reports.addReportTemplate': 'إضافة نموذج تقرير',
  'reports.allReports': 'جميع النماذج',
  'reports.selectAtLeastOneCategory': 'يرجى تحديد فئة واحدة على الأقل لتحديث نموذج التقرير',
  'reports.selectCategoryForLeave': 'يرجى تحديد فئة الإجازة من القائمة الجانبية أولاً',
  'reports.selectCategoryForPermission': 'يرجى تحديد فئة الإذن من القائمة الجانبية أولاً',
  'reports.selectCategoryForRemoteWork': 'يرجى تحديد فئة العمل عن بعد من القائمة الجانبية أولاً',
  'reports.selectCategoryForWorkSchedule': 'يرجى تحديد فئة جدول العمل من القائمة الجانبية أولاً',
  'reports.noAssignments': 'لم يتم إضافة أي تعيينات',
  'reports.selectAssignType': 'يرجى تحديد نوع الأهلية',
  'reports.selectEligibleFor': 'يرجى تحديد المؤهلين لـ',
  'reports.absenteesReport': 'تقرير المتغيبين',
  'reports.violationsSelectionType': 'نوع اختيار المخالفين',
  'report.reportName': 'اسم التقرير',
  'reports.employeeReport': 'تقارير الموظفين',
  'reports.violations': 'تقرير المتغيبين',
  'reports.absentType': 'نوع الغياب',
  'reports.violationType': 'نوع المخالفة',
  'reports.missingWorkDuration': 'مدة المخالفات',
  'reports.attendanceReports': 'تقرير الحضور ',
  'reports.auditReport':'التدقيق',
  'reports.attendanceSelectionType': 'نوع التحديد',
  // Employee Personal Information
  'employee.employeeNotExistWithNo':
    'هذا الموظف غير موجود, يرجى اختيار رقم اخر',
  'employee.addEmployeeNo': 'يرجى ادخال رقم الموظف',
  'employee.personalInformation': 'المعلومات شخصية',
  'employee.emailAddress': 'البريد الإلكتروني',
  'employee.employeeNumber': 'رقم الموظف',
  'employee.employeeName': 'اسم الموظف',
  'employee.virtualLocations': 'المواقع الافتراضية',
  'employee.virtualLocation': 'الموقع الافتراضي',
  'employee.fromDate': 'من التاريخ',
  'employee.toDate': 'إلى التاريخ',
  'employee.virtualLocationFieldsRequired': 'الموقع الافتراضي، من التاريخ، وإلى التاريخ هي حقول مطلوبة',
  'employee.addVirtualLocation': 'إضافة موقع افتراضي',
  'employee.editVirtualLocation': 'تعديل موقع افتراضي',
  'employee.virtualLocationPlaceholder': 'مثال: عن بُعد - دبي',
  'employee.virtualLocationRemarksPlaceholder': 'ملاحظات اختيارية',
  'employee.virtualLocationCreateSuccess': 'تم إنشاء الموقع الافتراضي بنجاح',
  'employee.virtualLocationCreateFailed': 'فشل إنشاء الموقع الافتراضي',
  'employee.virtualLocationDeleteSuccess': 'تم حذف الموقع الافتراضي بنجاح',
  'employee.virtualLocationBulkDeleteSuccess': 'تم حذف المواقع الافتراضية المحددة بنجاح',
  'common.pleaseSelectValueForEnabledFields': 'يرجى تحديد قيمة للحقول الممكنة',
  'pleaseSelectValueForEnabledFields': 'يرجى تحديد قيمة للحقول الممكنة',
  'common.updateFailed': 'فشل التحديث',
  'common.actionBy':'العمل بواسطة',
  'common.toDateCannotBeLessThanFromDate': 'لا يمكن أن يكون تاريخ الانتهاء أقل من تاريخ البدء',
  'common.deleted': 'محذوف',
  'common.modified': 'معدل',
  'common.added': 'مضاف',
  'employee.deleteVirtualLocationConfirm': 'هل أنت متأكد من حذف هذا الموقع الافتراضي؟',
  'employee.deleteVirtualLocationBulkConfirm': 'هل أنت متأكد من حذف المواقع الافتراضية المحددة؟',
  'common.recordSavedSuccessfully': 'تم حفظ السجل بنجاح',
  'employee.employeeRole': 'دور الموظف',
  'common.allRequests':'كل الطلب',

  'employee.employeeAddress': 'عنوان الموظف',
  'employee.employeeWorkExperience': 'خبرات العمل للموظف',
  'employee.employeeAppraisal': 'تقييم الموظف',
  'employee.employeeExtraFields': 'حقول إضافية للموظف',
  'employee.loginInformation': 'معلومات تسجيل الدخول',
  'employee.employeeGroups': 'مجموعات الموظف',
  'employee.employmentInformation': 'معلومات التوظيف',
  'employee.contact': 'معلومات الاتصال',
  'employee.selectLanguage': 'اختر لغة',
  'employee.name': 'اسم الموظف',
  'employee.employeeNo': 'رقم الموظف',
  'employee.empNo': 'رقم الموظف',
  'employee.organizationHierarchy': 'التسلسل الهرمي للمنظمة',
  'employee.addRecord': 'إضافة سجل',
  'employee.year': 'السنة',
  'employee.finalResult': 'النتيجة النهائية',
  'employee.supervisor': 'المشرف',
  'employee.addExtraFields': 'إضافة حقول إضافية',
  'employee.basicSalary': 'الراتب الأساسي',
  'employee.promotionDate': 'تاريخ الترقية',
  'employee.threeMEvaluation': 'تقييم الثلاثة أشهر',
  'employee.sixMEvaluation': 'تقييم الستة أشهر',
  'employee.certificate': 'الشهادة',
  'employee.otherInformation': 'معلومات أخرى',
  'employee.addEmployeeQualification': 'إضافة مؤهل للموظف',
  'employee.qualificationType': 'نوع المؤهل',
  'employee.startDate': 'تاريخ البدء',
  'employee.endDate': 'تاريخ الانتهاء',
  'employee.title': 'العنوان',
  'employee.status': 'حالة',
  'employee.gpa': 'المعدل التراكمي',
  'employee.establishment': 'المؤسسة',
  'employee.equivalence': 'المعادلة',
  'employee.country': 'البلد',
  'employee.active': 'نشط',
  'employee.addEmployeeWorkExperience': 'إضافة خبرة عمل للموظف',
  'employee.employer': 'صاحب العمل',
  'employee.type': 'النوع',
  'employee.jobTitle': 'المسمى الوظيفي',
  'employee.addEmployee': 'إضافة موظف',
  'employee.grade': 'الدرجة',
  'employee.major': 'الرئيسية',
  'employee.addCertificate': 'إضافة شهادة',
  'employee.attachment': 'المرفقات',
  'employee.department': 'القسم',
  'employee.selectDepartment': 'اختر قسماً',
  'employee.designation': 'التسمية الوظيفية',
  'employee.selectDesignation': 'اختر التسمية الوظيفية',
  'employee.jobGrade': 'الدرجة الوظيفية',
  'employee.selectJobGrade': 'اختر الدرجة الوظيفية',
  'employee.employmentType': 'نوع التوظيف',
  'employee.selectEmploymentType': 'اختر نوع التوظيف',
  'employee.joinDate': 'تاريخ المباشرة',
  'employee.selectStatus': 'اختر حالة',
  'employee.manager': 'المدير',
  'employee.selectManager': 'اختر مديراً',
  'employee.managerStartDate': 'تاريخ بدء',
  'employee.workLocation': 'مكان العمل',
  'employee.selectWorkLocation': 'اختر مكان العمل',
  'employee.annualLeaveBalance': 'رصيد الإجازة السنوية',
  'employee.upcomingHoliday': 'العطلات القادمة',
  'employee.leaveBalance': 'رصيد الإجازات',
  'employee.leaveSummary': 'ملخص الإجازات',
  'employee.excludeAbsentViolation': 'استثناء مخالفة الغياب',
  'employee.excludeAllViolation': 'استثناء جميع المخالفات',
  'employee.userName': 'اسم المستخدم',
  'employee.selectUserType': 'اختر نوع المستخدم',
  'employee.password': 'كلمة المرور',
  'employee.confirmPassword': 'تأكيد كلمة المرور',
  'employee.userType': 'نوع المستخدم',
  'employee.familyBookNo': 'رقم دفتر العائلة',
  'employee.familyNo': 'رقم العائلة',
  'employee.familyTownNo': 'رقم بلدة العائلة',
  'employee.unifiedNo': 'الرقم الموحد',
  'employee.passportNo': 'رقم جواز السفر',
  'employee.cardNo': 'رقم البطاقة',
  'employee.nameEn': 'اسم الموظف بالإنجليزية',
  'employee.nameAr': 'اسم الموظف بالعربية',
  'employee.shortNameEn': 'الاسم المختصر بالإنجليزية',
  'employee.shortNameAr': 'الاسم المختصر بالعربية',
  'employee.level1': 'المستوى-1',
  'employee.gender': 'الجنس',
  'employee.userRole': 'دور المستخدم',
  'employee.nationality': 'الجنسية',
  'employee.religion': 'الديانة',
  'employee.dateOfBirth': 'تاريخ الميلاد',
  'employee.email': 'البريد الإلكتروني',
  'employee.language': 'اللغة',
  'employee.phone': 'الهاتف',
  'employee.mobile': 'الجوال',
  'employee.emiratesID': 'الهوية الإماراتية',
  'employee.ID': 'المعرف',
  'employee.cardExpiryDate': 'تاريخ انتهاء البطاقة',
  'employee.maritalStatus': 'الحالة الاجتماعية',
  'employee.employeeCategory': 'فئة الموظف',
  'employee.reason': 'السبب',
  'employee.terminateDate': 'تاريخ الإنهاء',
  'employee.cardType': 'نوع البطاقة',
  'employee.remarks': 'ملاحظات',
  'employee.update': 'تحديث',
  'employee.placeOfBirth': 'مكان الميلاد',
  'employee.profile': 'الملف الشخصي',
  'employee.list': 'قائمة الموظفين',
  'employee.grid': 'شبكة الموظفين',
  'employee.page':' موظف',
  'employee.upload': 'رفع',
  'employee.productManager': 'مدير المنتج',
  'employee.productDepartment': 'قسم المنتج',
  'employee.dragDropUpload': 'انقر لتحميل الصورة',
  'employee.entityLevelLabel': 'المستوى ',
  'employee.terminatedDate': 'تاريخ الإقالة',
  'employee.exportEmployeeData': 'تصدير بيانات الموظف',
  'employee.user': 'المستخدم',
  'employee.propertyName': 'اسم الخاصية',
  'employee.oldValue': 'القيمة القديمة',
  'employee.newValue': 'القيمة الجديدة',
  'employee.time': 'الوقت',
  'employee.userDetails': 'تفاصيل المستخدم',
  'employee.employeeDetails': 'تفاصيل الموظف',
  'employee.workDetails': 'تفاصيل العمل',
  'employee.employeeContract': 'العقد',
  'employee.contractNo': 'رقم العقد',
  'employee.contractStatus': 'حالة العقد',
  'employee.isTaskeen': 'مكلف',
  'employee.hasProbationalPeriod': 'في الفترة التجريبية',
  'employee.probationalPeriodEndDate': 'تاريخ نهاية الفترة التجريبية',
  'employee.organizationName': 'اسم الشركة',
  'employee.organization': 'الشركة',
  'employee.profile': 'ملف الموظف',
  'employee.profileTable': 'جدول ملف الموظف',
  'employee.deleteEntryConfirmMsg':
    'لحفظ التعديلات بشكل نهائي,يرجى الضغط على حفظ?',
  'employee.selectCountry': 'الرجاء الاختيار',
  'employee.sameDataEntryOfWorkExperience':
    'المدة المختارة مع صاحب العمل موجود مسبقا, الرجاء اختيار بيانات صحيحة',
  'employee.sameDataEntryOfQualification': 'المؤهل موجود بالفعل',
  'employee.dofjoinDate': 'DOF تاريخ التعيين',
  'employee.promotionType': ' نوع التحفيز',
  'common.employeeList': 'قائمة الموظفين',
  'common.downloadConfirmMsg': 'هل تريد تنزيل قائمة الموظفين؟',
  'common.selectedEmployeeList': 'قائمة الموظفين المختارة',
  'common.total': 'المجموع',
  'dashboard.checkIn': 'وقت الدخول',
  'dashboard.checkOut': 'وقت الخروج',
  //Exception
  'exception.addExceptions': 'إضافة استثناء',
  'exception.employeeException': 'الاستثناءات',
  'exception.exceptionFor': 'استثناء ل',
  'exception.title': 'الاستثناءات',

  'delegation.title': 'تفويضات الموظفين',
  'common.reason': 'السبب',
  'common.note': 'الملاحظة',
  //holiday
  'holiday.holidays': 'العطلات الرسمية',
  'holiday.updateHolidayPeriod': 'تعديل العطلة الرسمية',
  'holiday.newHolidayPeriod': 'إضافة عطلة رسمية',

  //Manual Entry
  'manualEntry.AddManualEntry': 'إدخال يدوي جديد',
  'manualEntry.EditManualEntry': 'تحرير الإدخال اليدوي',
  'manualEntry.transactionType': 'نوع الحركة',
  'manualEntry.entryType': 'نوع الدخول',
  'manualEntry.manualEntry': 'إدخال يدوي',
  'manualEntry.manualEntryHR': 'إدارة الأفراد: إدخال يدوي',
  'manualEntry.in': 'دخول',
  'manualEntry.out': 'خروج',
  'manualEntry.pleaseSelect': '---- الرجاء الاختيار ----',

  // Form
  'form.formNameEn': 'الاسم',
  'form.formNameAr': 'الاسم(بالعربي)',
  'form.elementType': 'نوع العنصر',
  'form.formBuilder': 'بناء النماذج',

  // Update Supervisor
  'supervisor.assignmentType': 'نوع المهمة',
  'supervisor.title': 'تحديث المشرف',
  'supervisor.supervisor': 'المشرف',
  'supervisor.searchEmployeeList': 'بحث في قائمة الموظفين',
  'supervisor.selectEntity': 'تحديد القسم',
  'supervisor.selectDesignation': 'تحديد المسمى الوظيفي',

  //Permission Type
  'lookup.permissionType': 'نوع الاذن',
  'lookup.addPermissionType': 'إضافة نوع إذن جديد',
  'lookup.metricsRequired': 'حقل القياسات مطلوب',
  'lookup.selectAtLeastOneMetric': 'يرجى تحديد قياس واحد على الأقل.',
  'lookup.selectAtLeastOneDetail': 'يرجى تحديد تفصيل واحد على الأقل.',
  'lookup.notificationDetailTooltip': 'سيتم إرسال هذا البريد الإلكتروني في اليوم الأول من الشهر.',
  'lookup.unnamedModule': 'وحدة غير مسمى',
  'lookup.unnamedSection': 'قسم غير مسمى',
  'lookup.unnamedPermission': 'إذن غير مسمى',
  'lookup.saveErrorTitle': 'تعذر حفظ {lookup}',
  'lookup.saveErrorMessage': 'تعذر حفظ {lookup}. يرجى المحاولة مرة أخرى.',
  'lookup.required': 'مطلوب',
  'lookup.pleaseFixFollowingFields': 'يرجى إصلاح الحقول التالية',
  'lookup.pleaseFillRequiredFields': 'يرجى ملء جميع الحقول المطلوبة',
  'lookup.pleaseFillRequiredFieldsInGeneralTab': 'يرجى ملء الحقول المطلوبة في علامة تبويب عام',
  'lookup.pleaseSelectAtLeastOnePermissionForUserRole': 'يرجى تحديد صلاحية واحدة على الأقل لهذا الدور',
  'lookup.pleaseSelectAtLeastOneEmployeeForGroup': 'يرجى تحديد موظف واحد على الأقل لهذه المجموعة',
  'lookup.userRole.error.defaultAlreadyExists': 'يوجد دور مستخدم افتراضي بالفعل',
  'lookup.module': 'وحدة',
  'lookup.untitledSection': 'قسم بدون عنوان',
  'lookup.permissionSettingsFor': 'إعدادات الأذونات لـ {module}',
  'lookup.fullMenuAccess': 'وصول كامل للقائمة',

  'permissionType.montlyLimitHH': 'الحد الشهري (بالساعة)',
  'permissionType.montlyLimitMM': 'الحد الشهري (بالدقيقة)',
  'permissionType.permissionSetting': 'خصائص الاذونات',
  'permissionType.minDuration': 'اصغر مدة',
  'permissionType.maxDuration': 'اكبر  مدة',
  'permissionType.dailyLimit': 'الحدود اليومية',
  'permissionType.minDuration_Ramadan': 'اصغر قيمة(رمضان)',
  'permissionType.maxDuration_Ramadan': 'اكبر قيمة(رمضان)',
  'permissionType.minWorkingPerDay_Ramadan': '(رمضان)اصغر مدة للعمل اليومي',
  'permissionType.permissionType': 'نوع الإذن',
  'permissionType.workFlow': 'سير العمل',
  'permissionType.minDuration': 'المدة الدنيا (بالدقائق)',
  'permissionType.maxDuration': 'المدة القصوى (بالدقائق)',
  'permissionType.allowedBeforeDays': 'مسموح قبل الأيام',
  'permissionType.allowedAfterDays': 'مسموح بعد الأيام',
  'permissionType.dailyLimit': 'الحد اليومي (بالدقائق)',
  'permissionType.monthlyLimit': 'الحد الشهري (بالدقائق)',
  'permissionType.minWorking': 'الحد الأدنى للعمل يومياً (بالساعات)',
  'permissionType.grace': 'فترة السماح (بالدقائق)',
  'permissionType.considerInWork': 'اعتباره ضمن العمل',
  'permissionType.selfService': 'إظهار  في بطاقات الخدمة الذاتية',
  'permissionType.showHr': '  إظهار للموارد البشرية فقط',
  'lookup.nameEn': 'الاسم بالانكليزية',
  'permissionType.enableDate': 'تفعيل لفترة زمنية',

  // Group Builder
  'group.employeeGroupType': 'نوع مجموعة الموظفين',
  'group.groupName': 'اسم المجموعة',
  'group.groupArabicName': 'الاسم العربي للمجموعة',
  'group.groupType': 'نوع المجموعة',
  'group.selectGroupType': 'اختر نوع المجموعة',
  'group.parentGroup': 'المجموعة الرئيسية',
  'group.selectParentGroup': 'اختر المجموعة الرئيسية',
  'group.selectDesignation': 'اختر المسمى الوظيفي',
  'group.selectEntity': 'اختر الكيان',
  'remoteWork.onlinePunchInOut': 'تفعيل تسجيل الدخول والخروج اليدوي',
  'remoteWork.checkScheduleTiming': 'تفعيل الدخول والخروج في جدول العمل',
  'remoteWork.RemoteWorkSettingExpansion': 'خصائص العمل عن بعد',
  'remoteWork.AllowedDayPerYear': 'عدد الايام(بالشهر)',
  'remoteWork.AllowedDayPerMonth': 'عدد الايام(بالسنة)',
  // Ramadan
  'ramadan.ramadanPeriod': 'فترة رمضان',
  'ramadan.newRamadanPeriod': 'فترة رمضان جديدة',
  'ramadan.updateRamadanPeriod': 'تحديث فترة رمضان',

  //break duration
  'breakDuration.breakDurationDetails': 'تفاصيل مدة الاستراحة',
  'breakDuration.editBreakDuration': 'تحرير مدة الاستراحة',
  'breakDuration.addBreakDuration': 'أضف مدة الاستراحة',

  'breakDefinition.breakDefinitionDetails': 'تفاصيل إدارة الاستراحة',
  'breakDefinition.editBreakDefinition': 'تحرير إدارة الاستراحة',
  'breakDefinition.addBreakDefinition': 'إضافة إدارة الاستراحة',

  'breakDuration.nameEn': 'الاسمEn',
  'breakDuration.nameAr': 'الاسم Ar',
  'breakDuration.code': 'شفرة',
  'breakDuration.duration': 'مدة',
  'breakDuration.startTime': 'وقت البدء',
  'breakDuration.endTime': 'وقت الانتهاء',

  'breakDefinition.createdSuccessfully':'تم إنشاء الفاصل بنجاح',
  'breakDefinition.updatedSuccessfully':'تم تحديث الاستراحة بنجاح',

  //attendance duration
  'attendanceDuration.attendanceDurationDetails': 'نمط التحول',
  'attendanceDuration.editAttendanceDuration': 'تعديل نمط التحول',
  'attendanceDuration.addAttendanceDuration': 'إضافة نمط التحول',

  //temporary schedule
  'temporarySchedule.assignTemporarySchedule': 'تعيين وردية مؤقتة',
  'temporarySchedule.editAssignTemporarySchedule': 'تعديل المناوبة المؤقتة',
  'temporarySchedule.addAssignTemporarySchedule': 'تعيين نوبة عمل مؤقتة',
  'temporarySchedule.selectionRequired':"الاختيار مطلوب",
  'temporarySchedule.selectEmployeeAndShiftMsg':"الرجاء اختيار الموظف ونمط المناوبة",
  'temporarySchedule.selectEmployeeMsg':"الرجاء اختيار الموظف",
  'temporarySchedule.selectShiftPatternMsg':"الرجاء اختيار نمط المناوبة",

  // define work schedule
  'shiftWorkSchedule.editShift': 'تحرير خطة التحول',
  'shiftWorkSchedule.addShift': 'إضافة خطة التحول',
  // 'shiftWorkSchedule.shiftNameEn': 'اسم التحول En',
  // 'shiftWorkSchedule.shiftNameAr': 'اسم التحول ع',
  // 'shiftWorkSchedule.cycle': 'دورة',
  'shiftWorkSchedule.genSettings': 'نمط التحول',
  'shiftWorkSchedule.confirmTabSwitch': 'تأكيد تبديل الخطة',
  'shiftWorkSchedule.confirmTabSwitchMessage': 'هل أنت متأكد أنك تريد تبديل الخطة؟ سيتم مسح جميع الورديات غير المحفوظة في الجدول الحالي.',

  // Notification
  'notification.addNotification': 'إضافة الإخطار',
  'notification.editNotification': 'تحرير الإخطار',
  'notification.permissionScheduleValidData':
    'اختيار الوقت غير صالح: يرجى اختيار وقت بدء وانتهاء يقع ضمن جدول عملك',
  'notification.notificationKind': 'نوع الاشعار',
  'notification.name': 'الاسم',
  'notification.nameEn': 'اسم الانجليزية',
  'notification.nameAr': 'الاسم عربي',
  'notification.code': 'شفرة',
  'notification.notificationType': 'نوع الإشعار',
  'notification.notificationFor': 'الإشعار لـ',
  'notification.templateType': 'نوع القالب',
  'notification.notificationSchedule': 'جدول الإشعارات',
  'notification.ccAssignType': 'نوع تعيين CC',
  'notification.ccTargetGroup': 'المجموعة المعنية لـ CC',
  'notification.notificationParameters': 'معلمات الإشعار',
  'notification.templateSubject': 'موضوع القالب',
  'notification.notificationSubject': 'موضوع الإخطار',
  'notification.notificationSubjectEn': 'موضوع الإشعار باللغة الإنجليزية',
  'notification.notificationSubjectAr': 'موضوع الإشعار باللغة العربية',
  'notification.preview': 'معاينة',
  'notification.subjectEnLabel': 'الموضوع (إنجليزي)',
  'notification.subjectArLabel': 'الموضوع (عربي)',
  'notification.systemNotificationEnLabel': 'إشعار النظام (إنجليزي)',
  'notification.systemNotificationArLabel': 'إشعار النظام (عربي)',
  'notification.bodyEnLabel': 'المحتوى (إنجليزي)',
  'notification.bodyArLabel': 'المحتوى (عربي)',
  'notification.templateBody': 'محتوى القالب',
  'notification.notificationBuilder': 'منشئ الإشعارات',
  'notification.assignType': 'نوع التعيين',
  'notification.targetGroup': 'المجموعة المعنية',
  'notification.notificationInterval': 'الفترة الزمنية للإشعار',
  'notification.periodType': 'نوع الفترة',
  'notification.parameter': 'المعامل',
  'notification.selectedParameters': 'المعاملات المختارة',
  'notification.noParameterSelected': 'لم يتم اختيار أي معامل.',
  'notification.periodTypeRequired': 'يرجى اختيار نوع الفترة',
  'notification.metrics': 'المقاييس',
  'notification.details': 'التفاصيل',
  'notification.days': 'الأيام',
  'notification.detectContinuousAbsence': 'كشف الغياب المستمر ≥',
  'notification.reportType': 'نوع التقرير',
  'notification.selectReport': 'اختر التقرير',
  'notification.attendance': 'الحضور',
  'notification.violations': 'المخالفات',
  'notification.employeeRequests': 'طلبات الموظفين',
  'notification.continuousAbsence': 'الغياب المستمر',
  'notification.customReport': 'تقرير مخصص',
  'notification.attachmentFormat': 'تنسيق المرفق',
  'notification.attachmentFormat.none': 'لا يوجد',
  'notification.attachmentFormat.excel': 'إكسل',
  'notification.attachmentFormat.html': 'HTML',
  'notification.attachmentFormat.htmlInBody': 'HTML في نص الرسالة',
  'notification.attachmentFormat.excelHtml': 'إكسل + HTML',
  'notification.attachmentFormat.excelHtmlInBody': 'إكسل + HTML في نص الرسالة',
  'notification.attachmentFormat.htmlHtmlInBody': 'HTML + HTML في نص الرسالة',
  'notification.attachmentFormat.all': 'الكل',
  'notification.notificationScope': 'نطاق الإشعار',
  'notification.scope.none': 'لا يوجد',
  'notification.notificationTypeSubjectEn': 'نوع الإشعار الموضوع الإنجليزية',
  'notification.notificationTypeSubjectAr': 'نوع الإشعار الموضوع العربية',
  'notification.notificationTypeBodyEn': 'نوع الإشعار نص باللغة الإنجليزية',
  'notification.notificationTypeBodyAr': 'نوع الإشعار النص العربي',
  'notification.success': 'تم بنجاح',
  'notification.created': 'تم الإنشاء',
  'notification.badRequest': 'طلب غير صالح',
  'notification.unauthorized': 'غير مصرح',
  'notification.internalServerError': 'خطأ في الخادم الداخلي',
  'notification.requiredFields': 'يرجى ملء جميع الحقول المطلوبة',
  'notification.templateBodyEn': ' En',
  'notification.templateBodyAr': 'Template Body Ar',
  'notification.notificationBodyEn': 'نص الإشعارات باللغة الإنجليزية',
  'notification.notificationBodyAr': 'هيئة الإخطار العربية',
  'notification.parametersList': 'معلمات الإشعار ',
  'notification.employeeWorkScheduleReports': 'Employee Work Schedule Reports',
  'notification.employeeWorkScheduleSelectionType':
    'Employee Work Schedule Selection Type',
  'notification.templateBodyEn': 'نص القالب باللغة الإنجليزية',
  'notification.templateBodyAr': 'نص القالب باللغة العربية',
  'notification.employeeWorkScheduleReports': 'تقارير جدول عمل الموظف',
  'notification.employeeWorkScheduleSelectionType':
    'نوع اختيار جدول عمل الموظف',
  'notification.emptyExport': 'يرجى اختيار عنصر واحد على الاقل ',
  'notification.addStage':
    'يرجى التاكد من ادخال رقم المرحلة فريد والتاكد من  إدخال جميع الحقول المطلوبة',
  'notification.objectivesForms': 'نماذج الأهداف',
  'notification.objectivesEmail': 'بريد الأهداف الإلكتروني',
  'notification.objectivesMessage': 'رسالة الأهداف',
  'notification.editorInstructions': 'يرجى البدء بإدخال المحتوى في المحرر، والتأكد من إضافة معلمة الإشعار بعد ذلك.',
  'notification.triggerFirstDayOfMonth': 'سيتم إرسال هذا البريد الإلكتروني في اليوم الأول من الشهر.',
  'notification.subjectEnLabel': 'الموضوع (الإنجليزية)',
  'notification.subjectArLabel': 'الموضوع (العربية)',
  'notification.systemNotificationEnLabel': 'إشعار النظام (الإنجليزية)',
  'notification.systemNotificationArLabel': 'إشعار النظام (العربية)',
  'notification.bodyEnLabel': 'المحتوى (الإنجليزية)',
  'notification.bodyArLabel': 'المحتوى (العربية)',
  'common.workDays': 'أيام العمل',
  'common.richText': 'نص منسق',
  'common.rawHtml': 'HTML خام',
  'common.validation': 'التحقق',
  'common.updateFailed': 'فشل التحديث',
  'common.saveFailed': 'فشل الحفظ',
  'common.updateOperationFailed': 'فشلت عملية التحديث',
  'common.saveOperationFailed': 'فشلت عملية الحفظ',
  'notification.saveOperationFailed': 'فشلت عملية الحفظ',
  'notification.specificEmployee': 'موظف محدد',
  'notification.group': 'مجموعة',
  'notification.directManager': 'المدير المباشر',
  'notification.requester': 'المُقدم',


  'employee.totalExperienceYear': 'مجموع الخبرات (السنة)',
  'employee.totalExperienceMonth': 'مجموع الخبرات (الشهر)',

  'notification.leaveValidDataDifferentYear':
    'يرجى اختيار من تاريخ و الى تاريخ في نفس السنة',

  'error.parametersList': 'الرجاء تحديد معلمة واحدة على الأقل',
  'error.bodyEn': 'الرجاء إدخال حرفين على الأقل',
  'error.bodyAr': 'الرجاء إدخال حرفين على الأقل',
  approvalRequiredFields:
    'يرجى إضافة مستويات الإعتماد وملء جميع الحقول المطلوبة',
  leaveBalanceCheck: 'الإجازات المطلوبة أكبر من الرصيد المتاح',
  permissionValidData: 'يرجى إدخال بيانات صالحة',
  approvalExistsRequest: 'لا يمكن حذف الطلب لأن حالته قد تم تحديثها بالفعل.',
  permissionSameYear: 'تاريخ البدء وتاريخ الانتهاء ليسا في نفس السنة',
  leaveValidData: 'يرجى إدخال بيانات صالحة',
  emailValidation: 'يرجى إدخال بريد إلكتروني صالح',
  employeeNoCardCheck:
    'إما رقم الموظف, رقم البطاقة  , الايميل , اسم المستخدم مستخدم بالفعل. يرجى التأكد من أن كلاهما فريد قبل المتابعة.',
  exportFinished:
    'تم التصدير بنجاح، يرجى التحقق من مجلد التنزيل للعثور على القائمة المصدرة.',
  200: 'تم بنجاح',
  201: 'تم الإنشاء',
  400: 'طلب غير صالح',
  401: 'غير مصرح',
  500: 'خطأ في الخادم الداخلي',
  600: 'يرجى ملء جميع الحقول المطلوبة',
  555: 'يجب أن يكون الاسم (بالعربية) والاسم (بالإنجليزية) والرمز عناصر فريدة. يرجى إدخال قيم مختلفة',
  409: 'هذا العنصر مستعمل بالفعل',
  '-1': 'يرجى إضافة مستويات ألإعتماد وملء جميع الحقول المطلوبة',
  '-99': 'الإجازات المطلوبة أكبر من الرصيد المتاح',
  overlapWorkSchedule:
    'لديك تقاطعات في الاسناد لجدول العمل يرجى التاكد من البيانات المدخلة',
  overlapException: 'يوجد نفس الاستثاء في الفترة المحددة',
  lessDuration: 'المدة المطلوبة أقل من الحد الأدنى المسموح به.',
  greatDuration: 'المدة المطلوبة تتجاوز الحد الأقصى المسموح به.',
  exceedDailyLimit: 'المدة المطلوبة تتجاوز الحد اليومي.',
  exceedAllowedAfterDays:
    'الطلب يتجاوز الحد المسموح به لعدد الأيام في المستقبل.',
  exceedAllowedBeforeDays:
    'الطلب يتجاوز الحد المسموح به لعدد الأيام في الماضي.',
  exceedMonthlyLimit: 'الطلب يتجاوز الحد الشهري لاستخدام الإذن.',
  generalError: 'يرجى التحقق من بيانات طلب الإذن',
  overlapPermissionType: 'لديك تداخل بين الإذونات، يرجى التحقق من مدخلاتك',
  exceedMonthlyLimitPermissionRequest: 'لقد تجازوت الحد الشهري المسموح به ',
  'error.forThisPermission': 'لهذا الاذن',
  // Login
  'login.signIn': 'تسجيل الدخول',
  'login.activeDirectory': 'الدليل النشط',
  'login.userName': 'اسم المستخدم',
  'login.password': 'كلمة المرور',
  'login.login': 'تسجيل الدخول',
  'login.text': 'أدخل بريدك الإلكتروني وكلمة المرور لتسجيل الدخول!',
  'login.error': 'اسم المستخدم أو كلمة المرور غير صحيح',
  'login.tooManyAttempts': 'محاولات تسجيل دخول كثيرة. يرجى الانتظار دقيقة ثم المحاولة مرة أخرى.',

  //logout
  'logout.header': 'لقد تم تسجيل خروجك.',
  'logout.body_part_1': 'يرجى الضغط',
  'logout.body_part_2': 'هنا',
  'logout.body_part_3': 'إذا كنت تريد تسجيل الدخول مرة أخرى.',
  leaveBalanceCheck: 'الاجازة المقدمة اكبر من عدد الايام المتاح',
  '-99': 'الاجازة المقدمة اكبر من عدد الايام المتاح',
  overlapLeaveSetting:
    'الاجازة المقدمة تتقاطع مع اجازات سابقة يرجى التاكد من البيانات المدخلة',
  overlapRemoteWork: 'يوجد تقاطعات في العمل عن بعد',

  'sidebar.permissionSetting': 'تعريف الاذونات',
  'leave.includeHoliday': 'تضمين العطل الرسمية',
  updateLeaseApprovalStarted:
    'أنت تحاول تحديث  الاجازة وقد بدأت عملية الموافقة بالفعل.',
  requestAfterTerminationDate: 'انت تحاول اضافة طلب اجازة بعد الاقالة.',
  overlapWithOldLeaveRequest: 'يوجد لديك طلبات مسبقة بنفس الفترة الزمنية.',
  exceedLimitForRequest: 'انت تجازوت الحد المسموح به.',
  fromTimeNotGreaterThanToTime: 'من الوقت لا يجب ان يكون الى الوقت',
  overlapRemoteWork: 'لديك تداخل بين العمل عن بعد',
  'error.atLeast2Character': '2 محرف على الاقل',
  notApplyLeaveBeforeJoinDate: 'لا يمكنك طلب الإجازة قبل تاريخ الانضمام',
  notEligibleToTakeRemoteWork:
    'أنت لست مؤهلاً لتولي العمل عن بعد في  المدة المحددة',

  allowedDayPerMonthIsLessThanAllowedDayPerYear:
    'الايام المسموحة بالشهر يجب ان تكون اكبر من الايام بالسنة',
  allowedDayPerMonthIsGraterThanZero:
    'الايام المسموحة بالشهر يجب ان تكون اكبر من 0',
  allowedDayPerYearIsGraterThanZero: 'الايام المسموحة بالسنة اكبر من 0',
  overlapRemoteWorkSetting: 'يوجد لديك تقاطعات مع العمل عن بعد',
  AlreadyHaveOnePemissionInSameRange:
    'يرجى العلم ان لديك اذن مسبقا يتداخل مع الاذن الحالي...',
  fromAndToDateNotSameYear: 'من تاريخ وإلى تاريخ ليسا في نفس السنة',
  fromDateToDateNotInSameYear: 'من تاريخ وإلى تاريخ ليسا في نفس السنة',
  overlappingRemoteWorkRequest:
    'يوجد طلب عمل عن بُعد متداخل ضمن نطاق التاريخ المحدد',
  overlappingLeaveRequest: 'يوجد طلب إجازة متداخل ضمن نطاق التاريخ المحدد',
  yearlyLimitExceeded: 'تجاوز الحد السنوي',
  monthlyLimitExceeded: 'تم تجاوز الحد الشهري للشهر (أو الأشهر) المحددة',
  overlappingWithRemoteWork: 'لديك تداخل مع عمل عن بُعد',
  overlapMissingGateTransaction:
    'لديك تداخل في حركات البوابة المفقودة، يرجى التحقق من الإدخال الخاص بك',
  allowedDayPerMonthIsLessThanAllowedDayPerYear:
    'الايام المسموحة بالسنة يجب ان تكون اكبر من الايام بالشهر',
  overlappingWithRemoteWork: 'لديك تقاطعات مع طلبات العمل عن بعد',
  noActiveRemoteWorkSetting: 'لا يوجد خصائص العمل عن بعد لهذا الموظف',
  pleaseSelectAtleaseOneEmployee: 'يرجى اختيار موظف على الاقل',
  employeeNotExist:
    'يرجى العلم لقد تم اختيار موظفين غير موجودين في النظام الرجاء التاكد من البيانات المدخلة',
  confirmUpdateBulEmployee: 'هل انت متاكد من تعديل بيانت الموظفون المختارون .',
  directEmployee: 'الموظف المباشر',
  overlapHoliday: 'لديك تقاطع مع اوقات عطل اخرى',
  employeeEntitiesPrivilege: 'قائمة صلاحيات الوحدات الوظيفية',
  enitityList: 'قائمة الكيانات',
  January: 'يناير',
  February: 'فبراير',
  March: 'مارس',
  April: 'أبريل',
  May: 'مايو',
  June: 'يونيو',
  July: 'يوليو',
  August: 'أغسطس',
  September: 'سبتمبر',
  October: 'أكتوبر',
  November: 'نوفمبر',
  December: 'ديسمبر',
  leaveWithinContactDate:
    ' يرجى التأكد من أن الإجازة ضمن التواريخ السارية في العقد',
  leaveExceedsMaxNumberDays:
    ' هذه الإجازة تتجاوز الحد الأقصى لعدد الأيام المسموح بها في عقدك',
  employeeContractInUsed:
    'لا يمكنك تنفيذ هذا الإجراء، عقد الموظف قيد الاستخدام.',
  contractNo: 'رقم العقد',
  contractList: 'قائمة العقود',
  employeeContact: 'عقد الموظف',
  overlapContract: 'يوجد تداخل بين العقود، يرجى التحقق من البيانات المدخلة',
  toDateLessThanMonthFromDate:
    'تاريخ الانتهاء لا يمكن أن يكون مساويًا أو أقل من شهر من تاريخ البدء',
  contractFromDate: 'تاريخ بدء العقد',
  contractToDate: 'تاريخ انتهاء العقد',
  notValidContract: 'لا يوجد عقد صالح في نطاق التاريخ المحدد',
  ensureLeaveWithIn: 'يرجى التأكد من أن الإجازة ضمن',
  selectValidDateRemoteWorkRange:
    'أنت غير مؤهل للعمل عن بُعد في النطاق الزمني المحدد.',
  selectValidDatePermissionRange:
    'أنت غير مؤهل للحصول على إذن في النطاق الزمني المحدد.',
  remoteWorkNotPermitted:
    'العمل عن بُعد غير مسموح به للموظف المحدد ضمن النطاق الزمني المحدد.',
  permissionNotPermitted:
    'الإذن غير مسموح به للموظف المحدد ضمن النطاق الزمني المحدد.',
  'lookup.isContractEmployee': 'موظف بعقد',
  'leave.isCalLeavBalOnCon': 'هل يتم احتساب رصيد الإجازات بناءً على العقد',
  'common.all': 'الكل',
  'common.pending': 'قيد الانتظار',

  // dashboard pin
  
  'dashboard.pinatDashboard': 'دبوس في لوحة القيادة',
  'dashboard.unpinFromDashboard': 'إلغاء التثبيت من لوحة المعلومات',
  'common.directEmployee': 'موظف مباشر',
  'common.January': 'يناير',
  'common.February': 'فبراير',
  'common.March': 'مارس',
  'common.April': 'أبريل',
  'common.May': 'مايو',
  'common.June': 'يونيو',
  'common.July': 'يوليو',
  'common.August': 'أغسطس',
  'common.September': 'سبتمبر',
  'common.October': 'أكتوبر',
  'common.November': 'نوفمبر',
  'common.December': 'ديسمبر',
  'reports.violations': 'تقارير المخالفات',
  'reports.violationsSelectionType': 'نوع اختيار المخالفات',
  'reports.absentType': 'نوع الغياب',
  'reports.violationType': 'نوع المخالفة',
  'reports.missingWorkDuration': 'مدة العمل المفقودة',
  'reports.inTime': 'وقت الدخول',
  'reports.outTime': 'وقت الخروج',
  'reports.delay': 'التأخير',
  'reports.earlyOut': 'الخروج المبكر',
  'reports.durationIn': 'مدة الدخول',
  'reports.eGate': 'البوابة الإلكترونية',
  'reports.shiftPlanName': 'خطة الدوام',
  'reports.planTime': 'وقت الدوام',
  'reports.stepOut': 'الخروج المؤقت',
  'reports.outReason': 'سبب الخروج',
  'reports.permissionCount': 'عدد الأذونات',
  'reports.permissionDuration': 'مدة الإذن',
  'reports.totalDuration': 'إجمالي المدة',
  'reports.downloadPDF': 'تحميل PDF',
  'reports.downloadExcel': 'تحميل Excel',
  'reports.noDataFound': 'لم يتم العثور على بيانات. اضبط الفلاتر',
  'reports.errorFound': 'لم يتم العثور على بيانات',
  'reports.pleaseSelectCategory': 'يرجى اختيار فئة',
  'reports.noSelectionFound': 'لم يتم العثور على اختيار',
  'reports.pleaseSelectCriteria': 'يرجى اختيار {criteria} في معايير الاختيار (من تاريخ / إلى تاريخ)',
  'reports.selectAtLeastOneColumn': 'اختر عموداً واحداً على الأقل من الفئة',
  'reports.selectCategory': 'اختر الفئة',
  'reports.searchByKeyword': 'البحث بالكلمة المفتاحية',
  'reports.reportType': 'نوع التقرير',
  'reports.untitledReport': 'تقرير بدون عنوان',
  'reports.pinFailed': 'فشل تحديث التثبيت',
  'reports.deleteConfirm': 'حذف',
  'reports.deleteSuccess': 'تم حذف التقرير بنجاح',
  'reports.deleteFailed': 'فشل حذف التقرير',
  'reports.nameEnRequired': 'مطلوب',
  'reports.nameArRequired': 'مطلوب',
  'reports.codeRequired': 'مطلوب',
  'reports.reportSaved': 'التقرير',
  'reports.savedSuffix': 'تم الحفظ',
  'reports.saveFailed': 'فشل حفظ التقرير',
  'reports.builderReset': 'إعادة تعيين المنشئ',
  'reports.pin': 'تثبيت',
  'reports.edit': 'تعديل',
  'reports.editing': 'جاري التعديل',
  'reports.saveAs': 'حفظ باسم',
  'reports.savedReports': 'التقارير المحفوظة',
  'reports.searchReports': 'البحث في التقارير...',
  'reports.newReport': 'تقرير جديد',
  'reports.pinned': 'المثبتة',
  'reports.noPinned': 'لا توجد تقارير مثبتة',
  'reports.recentlyOpened': 'تم فتحها مؤخراً',
  'reports.nothingOpened': 'لم يتم فتح أي شيء بعد',
  'reports.allReports': 'جميع النماذج',
  'reports.noReports': 'لا توجد تقارير',
  'reports.editReport': 'تعديل نموذج التقرير',
  'reports.saveReportAs': 'إضافة نموذج تقرير',
  'reports.saveReport': 'إضافة نموذج تقرير',
  'reports.reportNameEn': 'اسم التقرير (بالإنجليزية)',
  'reports.reportNameAr': 'اسم التقرير (بالعربية)',
  'reports.assignType': 'نوع التعيين',
  'reports.eligibleType': 'النوع المؤهل',
  'reports.submit': 'إرسال',
  'reports.eligibleFor': 'المؤهلون لـ',
  'reports.publicReport': 'تقرير عام',
  'reports.sendNotification': 'إرسال إشعار',
  'reports.notificationTarget': 'جهة الإشعار',
  'reports.notificationTargetRequired': 'يرجى اختيار موظف واحد على الأقل',
  'reports.template': 'القالب',
  'reports.dateRangeLabel': 'نطاق التاريخ',
  'reports.fromFormula': 'من الصيغة',
  'reports.toFormula': 'إلى الصيغة',
  'reports.supportedKeywords': 'الكلمات المفتاحية المدعومة:',
  'sidebar.lineListingFiltersReport': 'تقارير فلاتر قائمة الأسطر',
  'common.leave': 'إجازة',
  'common.workschedule': 'جدول العمل',
  'common.remotework': 'العمل عن بُعد',
  'common.mandatory': 'إلزامي',
  'common.general': 'عام',
  'common.employee': 'الموظف',
  'common.permission': 'إذن',
  'common.personalinformation': 'معلومات شخصية',
  'common.workinformation': 'معلومات العمل',
  'common.workdetails': 'تفاصيل العمل',
  'common.maritalstatus': 'الحالة الاجتماعية',
  'common.jobgrade': 'الدرجة الوظيفية',
  'common.groupinformation': 'معلومات المجموعة',
  'common.closepanel': 'إغلاق اللوحة',
  'common.attendancesummary': 'ملخص الحضور',
  'common.leavefromdate': 'تاريخ بدء الإجازة',
  'common.leavetodate': 'تاريخ انتهاء الإجازة',
  'common.leavecount': 'عدد أيام الإجازة',
  'common.leavetype': 'نوع الإجازة',
  'common.leavetypearb': 'نوع الإجازة (بالعربي)',
  'common.leaveremark': 'ملاحظة الإجازة',
  'common.leaveyear': 'سنة الإجازة',
  'common.leavequarter': 'ربع سنة الإجازة',
  'common.leavemonth': 'شهر الإجازة',
  'common.leavemonthname': 'اسم شهر الإجازة',
  'common.leavestatusarb': 'حالة الإجازة (بالعربي)',
  'common.permissiontype': 'نوع الإذن',
  'common.permissiontypearb': 'نوع الإذن (بالعربي)',
  'common.permissiondate': 'تاريخ الإذن',
  'common.permissionfromtime': 'من وقت الإذن',
  'common.permissiontotime': 'إلى وقت الإذن',
  'common.permissionremark': 'ملاحظة الإذن',
  'common.remoteworkfromdate': 'تاريخ بدء العمل عن بعد',
  'common.remoteworktodate': 'تاريخ انتهاء العمل عن بعد',
  'common.remoteworkdayscount': 'عدد أيام العمل عن بعد',
  'common.workeddays': 'أيام العمل',
  'common.absentdays': 'أيام الغياب',
  'common.leavedays': 'أيام الإجازة',
  'common.holidaydays': 'أيام العطلة',
  'common.weekenddays': 'أيام عطلة نهاية الأسبوع',
  'common.latein': 'تأخير الدخول',
  'common.earlyout': 'خروج مبكر',
  'common.stepout': 'خروج مؤقت',
  'common.overtime': 'عمل إضافي',
  'common.totalworkduration': 'إجمالي مدة العمل',
  'common.missingpunch': 'بصمة مفقودة',
  'common.intime': 'وقت الدخول',
  'common.outtime': 'وقت الخروج',
  'common.duration': 'المدة',
  'common.violation': 'مخالفة',
  'common.remark': 'ملاحظة',
  'common.sn': 'م.',
  'common.date': 'التاريخ',
  'common.status': 'الحالة',
  'common.employeeno': 'رقم الموظف',
  'common.name': 'الاسم',
  'common.namearb': 'الاسم (بالعربي)',
  'common.nameen': 'الاسم (بالإنجليزي)',
  'common.mobileno': 'رقم الجوال',
  'common.email': 'البريد الإلكتروني',
  'common.dateofbirth': 'تاريخ الميلاد',
  'common.age': 'العمر',
  'common.nationalityarb': 'الجنسية (بالعربي)',
  'common.gender': 'الجنس',
  'common.maritialstatus': 'الحالة الاجتماعية',
  'common.religion': 'الديانة',
  'common.bloodgroup': 'فصيلة الدم',
  'common.joiningdate': 'تاريخ الانضمام',
  'common.employeeid': 'معرف الموظف',
  'common.department': 'الإدارة',
  'common.delay': 'تأخير',
  'common.missingworkduration': 'مدة العمل المفقودة',
  'common.categoryarb': 'الفئة (بالعربية)',
  'common.category': 'الفئة',
  'common.violationtype': 'نوع المخالفة',
  'common.remarks': 'ملاحظات',
  'common.designation': 'المسمى الوظيفي',
  'common.company': 'الشركة',
  'common.entity': 'وحدة العمل',
  'common.group': 'المجموعة',
  'common.grade': 'الدرجة الوظيفية',
  'common.worklocation': 'موقع العمل',
  'common.supervisor': 'المشرف',
  'common.status': 'الحالة',
  'common.employee': 'الموظف',
  'common.leave': 'إجازة',
  'common.permission': 'إذن',
  'common.remotework': 'العمل عن بُعد',
  'common.workschedule': 'جدول العمل',
  'common.leavestatus': 'حالة الإجازة',
  'common.leavecreatedby': 'تم إنشاء الإجازة بواسطة',
  'common.leavecreatedbyarb': 'تم إنشاء الإجازة بواسطة (بالعربي)',
  'common.leavelastactionby': 'آخر إجراء للإجازة بواسطة',
  'common.leavelastactionbyarb': 'آخر إجراء للإجازة بواسطة (بالعربي)',
  'common.managername': 'اسم المدير',
  'common.managernamearb': 'اسم المدير (بالعربي)',
  'common.designationarb': 'المسمى الوظيفي (بالعربي)',
  'common.employeestatus': 'حالة الموظف',
  'common.employeestatusarb': 'حالة الموظف (بالعربي)',
  'common.worklocationarb': 'موقع العمل (بالعربي)',
  'common.genderarb': 'الجنس (بالعربي)',
  'common.gradearb': 'الدرجة الوظيفية (بالعربي)',
  'common.religionarb': 'الديانة (بالعربي)',
  'common.joindate': 'تاريخ الانضمام',
  'common.cardno': 'رقم البطاقة',
  'common.terminationdate': 'تاريخ انتهاء الخدمة',
  'common.managerno': 'رقم المدير',
  'common.ismanager': 'هل هو مدير؟',
  'common.username': 'اسم المستخدم',
  'common.terminationreason': 'سبب انتهاء الخدمة',
  'common.terminationreasonarb': 'سبب انتهاء الخدمة (بالعربي)',
  'lookup.export': 'تصدير',

  // settings
  'setting.permissionRequest': 'طلب إذن',
  'setting.addPermssionRequest': 'إضافة طلب إذن',
  'setting.editPermssionRequest': 'تحرير طلب الإذن',
  'setting.leaveTypeAr': 'نوع الاجازة(بالعربية)',
  'setting.leaveTypeEn': 'نوع الاجازة',
  'setting.employeeCategory': 'فئة الموظف',
  'setting.carryOverBalance': 'عدد ايام الترحيل',
  'setting.Workflow': 'سياسة الموافقة',
  'setting.dayBalance': 'الرصيد',
  'setting.LeaveSettingExpansion': 'خصائص الاجازات',
  'setting.AllowedLeavesPerYear': 'عدد الايام المسموحة (السنة)',
  'setting.carryForwardLeaves': 'عدد الايام المسموح ترحيلها',
  'setting.includeOffDays': 'تضمين ايام العطل',
  'setting.NegativeDays': 'الحد الاعظمي للاجازات برصيد سالب',
  'setting.proratebasis': 'هو أساس Prorate',
  'setting.remoteWorkRequests': 'طلبات العمل عن بعد',
  'setting.newRemoteWorkRequest': 'إضافة طلب عمل عن بعد',
  'setting.remoteValidData': 'يرجى اختيار بيانات صحيحة',
  'setting.editRemoteWorkRequest': 'تعديل طلب العمل عن بعد',
  'setting.leave-builder': 'ترك الإعداد',
  'setting.remot-work-builder': 'إعدادات العمل عن بُعد',
  'setting.permission-type': 'إعداد الأذونات',
  'setting.manualentrybuilder': 'إعداد الإدخال اليدوي',
  'setting.manualentry-builder': 'إعداد الإدخال اليدوي',
  'setting.permissionTypeID': 'نوع الإذن',
  'setting.montlylimithh': 'الحد الشهري (بالساعة)',
  'setting.montlylimitmm': 'الحد الشهري (بالدقيقة)',
  'setting.alloweddayperyear': 'عدد الايام(بالشهر)',
  'setting.Aalloweddaypermonth': 'عدد الايام(بالسنة)',
  'setting.calculatebasedoncontract': 'هل يتم احتساب رصيد الإجازات بناءً على العقد',
  'setting.fromYear': 'من العام',
  'setting.toYear': 'إلى العام',

  // form builder
  'form.formBuilder':'منشئ النموذج',
  'form.BacktoList':'العودة للقائمة',
  'form.formType':'نوع النموذج',
  'form.Code':'شفرة',
  'form.FormNameEn':'اسم النموذج (الإنجليزية)',
  'form.FormNameAr':'اسم النموذج (العربية)',
  'form.saving':'جاري الحفظ...',
  'form.Save':'حفظ',
  'form.Update':'تحديث',
  'form.requestKind.permissions': 'صلاحيات',
  'form.requestKind.leaves': 'الإجازات',
  'form.requestKind.remoteWork': 'العمل عن بُعد',
  'form.requestKind.manualEntry': 'الإدخال اليدوي',
  'form.requestKind.allRequests': 'جميع الطلبات',
  'employee.createEmployeeFirst': 'يرجى إنشاء الموظف أولاً للوصول إلى العقود.',

  // General Alert Confirmation
  'general.submit-alert-confirmation': 'تأكيد',
  'general.cancel-alert-confirmation': 'إلغاء',

  'success.requestSubmitted':'تم إرسال الطلب بنجاح',
  'error.fillAllMandatoryFields':'يرجى ملء جميع الحقول المطلوبة.',

  // Remote Work Error Messages
  'remoteWork.success.eligible': 'الطلب مؤهل',
  'remoteWork.error.noConfiguration': 'لم يتم العثور على إعدادات العمل عن بعد لهذا الموظف. يرجى الاتصال بالمسؤول.',
  'remoteWork.error.invalidDateRange': 'نطاق تاريخ غير صالح. يرجى التأكد من أن تاريخ البداية قبل تاريخ النهاية وأن كلا التاريخين في نفس السنة.',
  'remoteWork.error.monthlyLimitExceeded': 'تم تجاوز الحد الشهري للعمل عن بعد.',
  'remoteWork.error.yearlyLimitExceeded': 'تم تجاوز الحد السنوي للعمل عن بعد.',
  'remoteWork.error.weeklyLimitExceeded': 'تم تجاوز الحد الأسبوعي للعمل عن بعد.',
  'remoteWork.error.beforeJoinDate': 'يبدأ الطلب قبل تاريخ التحاق الموظف.',
  'remoteWork.error.afterTerminationDate': 'ينتهي الطلب بعد تاريخ إنهاء خدمة الموظف.',
  'remoteWork.error.leaveExists': 'يوجد طلب إجازة ضمن فترة العمل عن بعد المطلوبة.',
  'remoteWork.error.configurationMissing': 'إعدادات العمل عن بُعد غير متوفرة. يرجى التواصل مع المسؤول.',
  'remoteWork.error.remoteExists': 'يوجد طلب عمل عن بُعد ضمن الفترة المحددة.',
  'remoteWork.error.requestedCountZero': 'عدد الأيام المطلوبة يساوي 0',

  // App Layout
  'appLayout.configuration': 'الإعدادات',
  'appLayout.darkMode': 'الوضع الليلي',
  'appLayout.userRole': 'دور المستخدم',
  'appLayout.selectUserRole': 'اختر دور المستخدم',
  'appLayout.employeeDashboard': 'لوحة الموظف',
  'appLayout.hrDashboard': 'لوحة الموارد البشرية',
  'appLayout.customizeLayout': 'تخصيص التخطيط',
  'appLayout.palette': 'لوحة الألوان',
  'appLayout.color.blue': 'أزرق',
  'appLayout.color.orange': 'برتقالي',
  'appLayout.color.green': 'أخضر',
  'appLayout.color.yellow': 'أصفر',
  'appLayout.color.red': 'أحمر',
  'appLayout.language': 'اللغة',
  'appLayout.languageEnglish': 'الإنجليزية',
  'appLayout.languageArabic': 'العربية',
  'appLayout.pagination': 'حجم الصفحة',
  'appLayout.leftMenu': 'القائمة الجانبية',
  'appLayout.leftMenu.fixed': 'ثابت',
  'appLayout.leftMenu.fluid': 'مرن',
  'appLayout.resetTheme': 'إعادة ضبط السمة',
  'appLayout.selectEmployeePlaceholder': 'ابحث عن موظف',
  'appLayout.empShort': 'موظف',
  'appLayout.signOut': 'تسجيل الخروج',
  'appLayout.viewProfile': 'عرض ملفي',
  'appLayout.myProfile': 'ملفي الشخصي',
  'appLayout.changeCurrentRole': 'تغيير الدور الحالي',
  'appLayout.loading': 'جاري التحميل...',
  'appLayout.companyName': 'سمارت ڤجن',
  'appLayout.configSaveSuccess': 'تم حفظ الإعدادات بنجاح',
  'appLayout.configSaveFailed': 'فشل في حفظ الإعدادات',
  'appLayout.configCloseWarningTitle': 'تغييرات غير محفوظة',
  'appLayout.configCloseWarningMessage': 'سيتم فقدان التغييرات التي أجريتها. هل تريد إغلاق لوحة الإعدادات؟',
  'appLayout.accessDenied': 'تم رفض الوصول',
  'appLayout.noAccessibleRoutes': 'الدور الحالي لا يملك صلاحية الوصول لأي صفحة.',
  'appLayout.roleCompanyMismatch': 'الدور المحدد لا ينتمي إلى شركتك.',
  'appLayout.dashboardNotAvailable': 'لوحة التحكم غير متاحة',
  'appLayout.roleCompanyMismatchDashboard': 'لا يمكنك عرض لوحة التحكم لأن دورك المحدد ينتمي إلى شركة مختلفة. يرجى استخدام الشريط الجانبي للتنقل إلى الصفحات المسموح بها أو تغيير دورك.',
  'common.noPermission': 'ليست لديك صلاحية لعرض هذه الصفحة',
  'appLayout.profileUpdateSuccess': 'تم تحديث الملف الشخصي بنجاح',
  'appLayout.connectivity.noInternetTitle': 'لا يوجد اتصال بالإنترنت',
  'appLayout.connectivity.noInternetMessage': 'لا يوجد اتصال بالإنترنت. يرجى التحقق من الاتصال والمحاولة مرة أخرى.',
  'appLayout.connectivity.serverUnreachableTitle': 'الخدمة غير متوفرة',
  'appLayout.connectivity.serverUnreachableMessage': 'نواجه مشكلة أثناء معالجة طلبك. يرجى المحاولة مرة أخرى بعد قليل.',
  'appLayout.connectivity.serverErrorTitle': 'خطأ في الخادم',
  'appLayout.connectivity.serverErrorMessage': 'حدث خطأ داخلي في الخادم.',
  'appLayout.connectivity.serverUnavailableTitle': 'الخدمة غير متوفرة',
  'appLayout.connectivity.serverUnavailableMessage': 'الخادم غير متاح مؤقتاً. يرجى المحاولة مرة أخرى بعد قليل.',

  // Break Definition
  'sidebar.breakManagement': 'إدارة الاستراحة',
  'breakDefinition.showSelectedFirst': 'عرض المحدد أولاً',
  'breakDefinition.exportPdfTitle': 'تصدير PDF',
  'breakDefinition.exportPdfBody': 'سيتم تصدير جميع العناصر إلى PDF.',
  'breakDefinition.exportExcelTitle': 'تصدير Excel',
  'breakDefinition.exportExcelBody': 'سيتم تصدير جميع العناصر إلى ملف .csv',
  'breakDefinition.importDataTitle': 'استيراد البيانات',
  'breakDefinition.importDataBody': 'سيتم استيراد جميع العناصر.',
  'breakDefinition.itemsWillBeDownloaded': 'سيتم تنزيل {count} عنصر.',
  'breakDefinition.minutes': 'دقائق',

  // Attendance Duration
  'attendanceDuration.attendanceDurationDetails': 'نمط التحول',
  'attendanceDuration.exportPdfTitle': 'تصدير PDF',
  'attendanceDuration.exportPdfBody': 'سيتم تصدير جميع العناصر إلى PDF.',
  'attendanceDuration.exportExcelTitle': 'تصدير Excel',
  'attendanceDuration.exportExcelBody': 'سيتم تصدير جميع العناصر إلى ملف .csv',
  'attendanceDuration.importDataTitle': 'استيراد البيانات',
  'attendanceDuration.importDataBody': 'سيتم استيراد جميع العناصر.',

  'attendanceDuration.workScheduleType': 'نوع الجدول الزمني للعمل',
  'attendanceDuration.withTime': 'مع الوقت',
  'attendanceDuration.withoutTime': 'بدون وقت',
  'attendanceDuration.fixedSchedule': 'جدول ثابت',
  'attendanceDuration.flexStartTime': 'وقت بدء مرن',
  'attendanceDuration.flexEndTime': 'وقت انتهاء مرن',
  'attendanceDuration.coreStartTime': 'وقت بدء أساسي',
  'attendanceDuration.coreEndTime': 'وقت انتهاء أساسي',
  'attendanceDuration.invalidTimeValues': 'قيم وقت غير صحيحة',
  'attendanceDuration.invalidTimeValuesMsg': 'بعض قيم الوقت ليست ضمن نطاق وقت الإعدادات الأساسية. يرجى تصحيح الحقول المميزة قبل الإرسال.',
  'attendanceDuration.unsavedChanges': 'تغييرات غير محفوظة',
  'attendanceDuration.unsavedChangesMsg': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها؟',
  'attendanceDuration.addAttendanceDuration': 'إضافة مدة الحضور',
  'attendanceDuration.editAttendanceDuration': 'تعديل مدة الحضور',
  'attendanceDuration.durationMustBePositive': 'يجب أن تكون المدة أكبر من 0 دقيقة',
  'attendanceDuration.stepOutTimeError': 'يجب أن يكون وقت الخروج خلال الوقت الأساسي',
  'attendanceDuration.bufferAfterEndError': 'يجب ألا يكون وقت التخزين المؤقت بعد الانتهاء أكبر من وقت التخزين المؤقت قبل البدء',
  'attendanceDuration.bufferLimitError': 'الوقت الاحتياطي بعد وقت الانتهاء محدود بحد أقصى 50٪ من إجمالي ساعات العمل.',
  'attendanceDuration.workingHoursThresholdError': 'ساعات العمل ليست أكثر من ساعة العمل',
  'attendanceDuration.firstPunchAfterError': 'البصمة الأولى بعد ليست أكثر من ساعة العمل',
  'attendanceDuration.lastPunchBeforeError': 'البصمة الأخيرة قبل ليست أكثر من ساعة العمل',
  'attendanceDuration.fromTimeInError': 'يجب ألا يكون وقت البدء أكبر من وقت الانتهاء',
  'attendanceDuration.toTimeError': 'يجب أن يكون وقت الانتهاء أكبر من وقت البدء',
  'attendanceDuration.saveSuccess': 'تم حفظ نمط المناوبة بنجاح!',
  'attendanceDuration.updateSuccess': 'تم تحديث نمط المناوبة بنجاح!',
  'attendanceDuration.graceInError': 'وقت السماح بالدخول ليس أكثر من ساعة العمل',
  'attendanceDuration.graceOutError': 'وقت السماح بالخروج ليس أكثر من ساعة العمل',
  'attendanceDuration.graceOutCompareError': 'يجب أن يكون وقت السماح بالخروج أكبر من وقت السماح بالدخول',
  'attendanceDuration.bufferCompareError': 'يجب ألا يكون الوقت الاحتياطي قبل البدء أكبر من الوقت الاحتياطي بعد الانتهاء',
  'attendanceDuration.bufferStartLimitError': 'الوقت الاحتياطي قبل وقت البدء محدود بحد أقصى 50٪ من إجمالي ساعات العمل.',
  'attendanceDuration.fromToTimeError': 'يجب ألا يكون وقت البدء أكبر من وقت الانتهاء',
  'attendanceDuration.stepOut': 'خروج مؤقت',
  'attendanceDuration.break': 'استراحة',
  'attendanceDuration.bufferBeforeTooltip': 'أي معاملة يتم تسجيلها ضمن هذه الفترة الاحتياطية المحددة، قبل وقت البدء المقرر، سيتم التعامل معها كمعاملة صالحة.',
  'attendanceDuration.bufferAfterTooltip': 'أي معاملة يتم تسجيلها ضمن المدة الاحتياطية المحددة بعد وقت انتهاء الجدول الزمني سيتم اعتبارها معاملة صالحة.',
  'attendanceDuration.graceInTooltip': 'فترة السماح المسموح بها لتسجيل الدخول. سيتم اعتبار المعاملات خلال هذا الوقت صالحة.',
  'attendanceDuration.graceOutTooltip': 'فترة السماح المسموح بها لتسجيل الخروج. سيتم اعتبار المعاملات خلال هذا الوقت صالحة.',
  'attendanceDuration.hhmmFormatError': '{0} يجب أن يكون بتنسيق HH:MM',
  'attendanceDuration.minDurationApplyError': 'الحد الأدنى للمدة للتطبيق ليس أكثر من ساعة العمل',
  'attendanceDuration.maxDurationApplyError': 'الحد الأقصى للمدة للتطبيق ليس أكثر من ساعة العمل',
  'attendanceDuration.minWorkingHoursApplyError': 'الحد الأدنى لساعات العمل ليس أكثر من ساعة العمل',
  'attendanceDuration.flexIn': 'دخول مرن',
  'attendanceDuration.flexOut': 'نهاية المرن',
  'attendanceDuration.coreStart': 'بداية الوقت الأساسي',
  'attendanceDuration.coreEnd': 'نهاية الوقت الأساسي',
  'attendanceDuration.core': 'الأساسي',
  'attendanceDuration.total': 'الإجمالي',
  'attendanceDuration.h': 'س',
  'attendanceDuration.m': 'د',
  'attendanceDuration.nightShift': 'دوام ليلي',
  'attendanceDuration.attendanceDurationDetails': 'تفاصيل مدة الحضور',
  'attendanceDuration.exportPdfTitle': 'تصدير PDF',
  'attendanceDuration.exportPdfBody': 'هل أنت متأكد أنك تريد تصدير البيانات إلى PDF؟',
  'attendanceDuration.exportExcelTitle': 'تصدير Excel',
  'attendanceDuration.exportExcelBody': 'هل أنت متأكد أنك تريد تصدير البيانات إلى Excel؟',
  'attendanceDuration.importDataTitle': 'استيراد البيانات',
  'attendanceDuration.importDataBody': 'قم بتحميل ملف البيانات لاستيراد مدد الحضور.',
  'attendanceDuration.shift': 'الوردية',
  'attendanceDuration.minutes': 'دقيقة',
  "attendanceDuration.shiftpattern":'نمط الورديات',
   'attendanceDuration.editshiftpattern':'تعديل نمط الورديات',
  'attendanceDuration.addshiftpattern':'إضافة نمط مناوبات',
  'attendanceDuration.automaticPermissionPolicyType': 'نوع سياسة الإذن التلقائي',
  'attendanceDuration.minAutoApprovalDuration': 'الحد الأدنى لمدة الموافقة التلقائية',
  'attendanceDuration.maxAutoApprovalDuration': 'الحد الأقصى لمدة الموافقة التلقائية',

  // Days
  'days.monday': 'الإثنين',
  'days.tuesday': 'الثلاثاء',
  'days.wednesday': 'الأربعاء',
  'days.thursday': 'الخميس',
  'days.friday': 'الجمعة',
  'days.saturday': 'السبت',
  'days.sunday': 'الأحد',

  // Assign Work Schedule
  // 'assignWorkSchedule.scheduleAssignment': 'تعيين الجدول الزمني',
  'assignWorkSchedule.loadingDetails': 'جاري تحميل تفاصيل الجدول...',
  'assignWorkSchedule.noDetails': 'لا توجد تفاصيل للجدول الزمني متاحة.',
  'assignWorkSchedule.employeeDetails': 'تفاصيل الموظف',
  'assignWorkSchedule.allEmployees': 'جميع الموظفين',
  'assignWorkSchedule.shifts': 'ورديات',
  'assignWorkSchedule.targetNameEn': 'اسم الهدف',
  'assignWorkSchedule.targetNameAr': 'اسم الهدف (بالعربية)',
  'assignWorkSchedule.shiftName': 'اسم الوردية',
  'assignWorkSchedule.coreTime': 'الوقت الأساسي',
  'assignWorkSchedule.flexTime': 'الوقت المرن',
  'assignWorkSchedule.deleteConfirmMessage': 'هل أنت متأكد أنك تريد حذف {name}؟',

  // Shift Management
  // 'sidebar.defineWorkSchedule': 'تعريف جدول العمل',
  'shiftManagement.shiftManagementDetails': 'إدارة الورديات',
  'shiftManagement.exportPdfTitle': 'تصدير PDF',
  'shiftManagement.exportPdfBody': 'هل أنت متأكد أنك تريد تصدير البيانات إلى PDF؟',
  'shiftManagement.exportExcelTitle': 'تصدير Excel',
  'shiftManagement.exportExcelBody': 'هل أنت متأكد أنك تريد تصدير البيانات إلى Excel؟',
  'shiftManagement.importDataTitle': 'استيراد البيانات',
  'shiftManagement.importDataBody': 'قم بتحميل ملف البيانات لاستيراد تعريفات الورديات.',
  'shiftManagement.deleteFailed': 'فشل الحذف',
  'shiftManagement.deleteFailedMsg': 'فشل حذف السجلات المختارة. يرجى المحاولة مرة أخرى.',
  'shiftManagement.itemsWillBeDownloaded': 'سيتم تحميل {count} من العناصر.',
  'assignWorkSchedule.recordDeletedSuccessfully': 'تم حذف السجل بنجاح!',
  'assignWorkSchedule.bulkDeleteSuccess': 'تم حذف {count} سجلات بنجاح!',
  'assignWorkSchedule.noScheduleIdFound': 'تعذر عرض الجدول: لم يتم العثور على معرف الجدول.',
  'assignWorkSchedule.exportNotImplemented': 'لقد اخترت {count} سجل (سجلات). التصدير غير مفعل حاليا.',
  'assignWorkSchedule.addScheduleAssignment': 'إضافة تعيين جدول زمني',
  'assignWorkSchedule.editScheduleAssignment': 'تحديث تعيين الجدول الزمني',
  'assignWorkSchedule.addButtonText': 'تعيين',
  'assignWorkSchedule.noEmployeeFound': 'لا يوجد موظفون مطابقون',
  'assignWorkSchedule.addMoreEmployees': 'إضافة موظفين آخرين',
  'assignWorkSchedule.tabEmployees': 'الموظفون',
  'assignWorkSchedule.tabDepartments': 'الأقسام',
  'assignWorkSchedule.tabGroups': 'المجموعات',
  'assignWorkSchedule.searchByNameOrId': 'ابحث عن موظف بالاسم أو الرقم...',
  'assignWorkSchedule.searchInDepartment': 'ابحث عن موظف في هذا القسم...',
  'assignWorkSchedule.searchInGroup': 'ابحث عن موظف في هذه المجموعة...',
  'assignWorkSchedule.filterBy': 'تصفية حسب',
  'assignWorkSchedule.selectedLabel': 'محدد',
  'assignWorkSchedule.selectTheEmployee': 'اختر الموظف',
  'assignWorkSchedule.selectTheGroup': 'اختر المجموعة',
  'assignWorkSchedule.selectTheGrade': 'اختر الدرجة',
  'assignWorkSchedule.selectTheDesignation': 'اختر المسمى الوظيفي',
  'assignWorkSchedule.assignedEmployee': 'الموظف المعين',
  'assignWorkSchedule.employee': 'موظف',
  'assignWorkSchedule.dateRangeCompareError': 'يجب ألا يكون تاريخ البدء أكبر من تاريخ الانتهاء.',
  'assignWorkSchedule.dateRangeCompareErrorTo': 'يجب أن يكون تاريخ الانتهاء أكبر من تاريخ البدء.',
  'assignWorkSchedule.recordAlreadyExist': 'السجل موجود بالفعل',
  'assignWorkSchedule.unableToUpdate': 'تعذر تحديث تعيين الوردية',
  'assignWorkSchedule.unableToCreate': 'تعذر إنشاء تعيين الوردية',
  'assignWorkSchedule.saveSuccess': 'تم حفظ تعيين الوردية بنجاح!',
  'assignWorkSchedule.updateSuccess': 'تم تحديث تعيين الوردية بنجاح!',
  'assignWorkSchedule.saveError': 'حدث خطأ ما أثناء حفظ النموذج.',
  'assignWorkSchedule.selectDepartment': 'يرجى اختيار القسم',
  'assignWorkSchedule.selectGroup': 'يرجى اختيار مجموعة',
  'assignWorkSchedule.pleaseSelectEmployee': 'يرجى اختيار موظف',
  'assignWorkSchedule.selectLocation': 'يرجى اختيار الموقع',
  'assignWorkSchedule.noEmployeesToShow': 'لا يوجد موظفون',
  'assignWorkSchedule.selectGrade': 'يرجى اختيار درجة',
  'assignWorkSchedule.selectDesignation': 'يرجى اختيار مسمى وظيفي',
  'assignWorkSchedule.selectAtLeastOneEmployee': 'يرجى اختيار موظف واحد على الأقل',
  'assignWorkSchedule.unsavedChanges': 'تغييرات غير محفوظة',
  'assignWorkSchedule.unsavedChangesMsg': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها؟',
  'assignWorkSchedule.showingCountOfTotal': 'عرض {showingCount} من {totalCount}',

  // Temporary Schedule
  'temporarySchedule.assignTemporarySchedule': 'تعيين وردية مؤقتة',
  'temporarySchedule.shiftName': 'اسم الجدول الزمني',
  'temporarySchedule.employeeName': 'اسم الموظف',
  'temporarySchedule.workDate': 'تاريخ العمل',
  'temporarySchedule.createdDate': 'تاريخ الإنشاء',
  'temporarySchedule.lastUpdatedDate': 'تاريخ آخر تحديث',

  'temporarySchedule.addAssignTemporarySchedule': 'إضافة تعيين وردية مؤقتة',
  'temporarySchedule.editAssignTemporarySchedule': 'تحديث تعيين وردية مؤقتة',
  'temporarySchedule.selectionRequired': 'الاختيار مطلوب',
  'temporarySchedule.selectEmployeeAndShiftMsg': 'يرجى اختيار الموظف ونمط الوردية',
  'temporarySchedule.selectEmployeeMsg': 'يرجى اختيار الموظف',
  'temporarySchedule.selectShiftPatternMsg': 'يرجى اختيار نمط الوردية',
  'temporarySchedule.exportPDF': 'تصدير PDF',
  'temporarySchedule.exportExcel': 'تصدير اكسل',
  'temporarySchedule.importData': 'استيراد البيانات',
  'temporarySchedule.exportPDFBody': 'سيتم تصدير كافة العناصر إلى PDF.',
  'temporarySchedule.exportExcelBody': 'سيتم تصدير كافة العناصر إلى .csv',
  'temporarySchedule.importDataBody': 'سيتم استيراد كافة العناصر.',
  'temporarySchedule.confirmation': 'تأكيد',
  'temporarySchedule.itemsWillBeDownloaded': 'سيتم تنزيل {count} من العناصر.',
  'temporarySchedule.deleteSuccess': 'تم حذف السجل بنجاح!',
  'temporarySchedule.bulkDeleteSuccess': 'تم حذف {count} سجلات بنجاح!',
  'temporarySchedule.deleteFailed': 'فشل حذف السجلات',
  'temporarySchedule.deleteFailedMsg': 'حدث خطأ أثناء حذف السجل.',
  'temporarySchedule.saveSuccess': 'تم تعيين الوردية المؤقتة بنجاح!',
  'temporarySchedule.updateSuccess': 'تم تحديث الوردية المؤقتة بنجاح!',
  'temporarySchedule.assignRecalcQueued': 'تم حفظ التعيين بنجاح. إعادة الاحتساب قيد المعالجة وسيتم تحديث الجدول قريباً',
  'temporarySchedule.saveFailed': 'فشل الحفظ',
  'temporarySchedule.updateFailed': 'فشل التحديث',
  'temporarySchedule.unsavedChanges': 'تغييرات غير محفوظة',
  'temporarySchedule.unsavedChangesMsg': 'لديك تعديلات غير محفوظة. هل تريد تجاهلها؟',
  'temporarySchedule.timelineMultipleSelectedTitle': 'تم اختيار عدة موظفين',
  'temporarySchedule.timelineMultipleSelectedMessage': 'لقد قمت باختيار {count} موظفًا{namesSuffix}. إذا أردت عرض الجدول الزمني الحالي، يرجى اختيار موظفًا واحدًا فقط.',

  'common.monday': 'الإثنين',
  'common.tuesday': 'الثلاثاء',
  'common.wednesday': 'الأربعاء',
  'common.thursday': 'الخميس',
  'common.friday': 'الجمعة',
  'common.saturday': 'السبت',
  'common.sunday': 'الأحد',

  'common.january': 'يناير',
  'common.february': 'فبراير',
  'common.march': 'مارس',
  'common.april': 'أبريل',
  'common.may': 'مايو',
  'common.june': 'يونيو',
  'common.july': 'يوليو',
  'common.august': 'أغسطس',
  'common.september': 'سبتمبر',
  'common.october': 'أكتوبر',
  'common.november': 'نوفمبر',
  'common.december': 'ديسمبر',

  // Timetable Dropdown
  'common.shiftPattern': 'نمط الوردية',
  'common.selectShiftPattern': 'حدد نمط الوردية',
  'common.restDay': 'يوم الراحة',
  'common.startTime': 'وقت البدء',
  'common.endTime': 'وقت الانتهاء',
  'common.flexStartTime': 'وقت البدء المرن',
  'common.flexEndTime': 'وقت الانتهاء المرن',
  'common.colorCode': 'رمز اللون',
  'common.selected': 'محدد',
  'common.lang': 'ar',
  'common.restDaySelectedMsg': 'هذا التاريخ محدد يوم راحة. يرجى إزالته أولاً لتعيين جدول زمني.',
  'common.halfCalendar': 'عرض نصف التقويم',
  'common.fullCalendar': 'عرض التقويم الكامل',
  'common.searchEmployee': 'البحث عن موظف...',
  'temporarySchedule.timetableNameEn': 'اسم الجدول الزمني',
  'temporarySchedule.shiftNameEn': 'اسم الجدول الزمني',
  'temporarySchedule.employeeNameEn': 'اسم الموظف',
  'temporarySchedule.employeeNo': 'رقم الموظف',
  'temporarySchedule.workDate': 'تاريخ العمل',
  'temporarySchedule.createdDate': 'تاريخ الإنشاء',
  'temporarySchedule.lastUpdatedDate': 'تاريخ آخر تحديث',
  'temporarySchedule.exportPDF': 'تصدير إلى PDF',
  'temporarySchedule.exportPDFBody': 'هل أنت متأكد من أنك تريد تصدير البيانات إلى PDF؟',
  'temporarySchedule.exportExcel': 'تصدير إلى Excel',
  'temporarySchedule.exportExcelBody': 'هل أنت متأكد من أنك تريد تصدير البيانات إلى Excel؟',
  'temporarySchedule.importData': 'استيراد البيانات',
  'temporarySchedule.importDataBody': 'هل أنت متأكد من أنك تريد استيراد البيانات؟',
  'temporarySchedule.itemsWillBeDownloaded': 'سيتم تحميل {count} عنصر.',
  'temporarySchedule.importSummary': 'ملخص الاستيراد',
  'temporarySchedule.totalRows': 'إجمالي الصفوف',
  'temporarySchedule.success': 'ناجحة',
  'temporarySchedule.failed': 'فاشلة',
  'temporarySchedule.templateMismatch': 'البيانات غير متطابقة مع القالب المتوقع. يرجى تنزيل القالب والمحاولة مرة أخرى.',
  'temporarySchedule.unexpectedColumns': 'أعمدة غير متوقعة',
  'temporarySchedule.requiredMissing': 'بعض الحقول المطلوبة مفقودة (رقم الموظف، رمز نمط الوردية، تاريخ العمل). يرجى تصحيح الملف والمحاولة مرة أخرى.',
  'temporarySchedule.verificationResult': 'نتيجة التحقق',
  'temporarySchedule.failedRecords': 'السجلات الفاشلة',
  'temporarySchedule.verifyingFile': 'جارٍ التحقق من الملف...',
  'temporarySchedule.verifyingPleaseWait': 'يرجى الانتظار بينما نقوم بالتحقق من بياناتك.',
  'temporarySchedule.onlyFirstNShown': 'يتم عرض أول {n} سجلات فقط.',
  'temporarySchedule.downloadErrorFile': 'تحميل ملف الأخطاء',
  'temporarySchedule.reuploadFile': 'إعادة رفع الملف',
  'temporarySchedule.fixAndReupload': 'يرجى إصلاح السجلات الفاشلة ورفع الملف مرة أخرى.',
  'temporarySchedule.verifyAgain': 'تحقق مرة أخرى',
  'temporarySchedule.allRecordsReady': 'جميع السجلات صالحة وجاهزة للاستيراد.',
  'temporarySchedule.youCanNowConfirm': 'يمكنك الآن التأكيد واستيراد البيانات.',

  // Manual Entry
  'manualEntry.importManualEntry': 'استيراد الدخول اليدوي',

  'common.filterBy': 'تصفية حسب',
  'common.unnamed': 'غير مسمى',
    'shiftManagement.rotateShift': 'تكرار المناوبة',
  'shiftManagement.timetableNotAdded': 'لم يتم إضافة وردية جدول الوقت الخاص بك',
  'shiftManagement.selectTimetableFirst': 'يجب عليك أولاً اختيار وردية جدول الوقت، ثم يمكنك المتابعة',
  'shiftManagement.saveSuccessTitle': 'تم حفظ جدول العمل بنجاح',
  'shiftManagement.saveSuccessMsg': 'تم حفظ جدول العمل الخاص بك بنجاح.',
  'shiftManagement.updateSuccessTitle': 'تم تحديث جدول العمل بنجاح',
  'shiftManagement.updateSuccessMsg': 'تم تحديث جدول العمل الخاص بك.',
  'shiftManagement.saveFailedTitle': 'فشل الحفظ',
  'shiftManagement.noShift': 'لا توجد وردية',
  'shiftManagement.cycle': 'اليوم',
  'shiftManagement.halfCalendarView': 'عرض نصف التقويم',
  'shiftManagement.fullCalendarView': 'عرض كامل التقويم',
  'shiftManagement.dailySchedule': 'الجدول اليومي',
  'shiftManagement.weeklySchedule': 'الجدول الأسبوعي',
  'shiftManagement.monthlySchedule': 'الجدول الشهري',
  'shiftManagement.weekly': 'أسبوعي',
  'shiftManagement.monthly': 'شهري',
  'shiftManagement.daily': 'يومي',
  'shiftWorkSchedule.confirmTabSwitch': 'تأكيد تغيير التبويب',
  'shiftWorkSchedule.confirmTabSwitchMessage': 'هل أنت متأكد أنك تريد تبديل الخطة؟ سيتم مسح جميع الورديات غير المحفوظة في الجدول الحالي.',
  'shiftWorkSchedule.selectShiftFirst': 'يرجى اختيار وردية أولاً.',
  'temporarySchedule.lastUpdatedDate': 'تاريخ آخر تحديث',
  'temporarySchedule.createdDate': 'تاريخ الإنشاء',
  'temporarySchedule.workDate': 'تاريخ العمل',
  'temporarySchedule.employeeName': 'اسم الموظف',
  'temporarySchedule.timetableName': 'اسم الجدول الزمني',

  'manualEntry.manualEntry': 'إدخال يدوي',
  'manualEntry.AddManualEntry': 'إدخال يدوي جديد +',
  'manualEntry.EditManualEntry': 'تعديل إدخال يدوي',
  'manualEntry.transactionType': 'نوع الحركة',
  'manualEntry.deleteFailed': 'فشل حذف طلب الإدخال اليدوي',
  'manualEntry.deleteSuccess': 'تم حذف السجل',
  'manualEntry.bulkDeleteSuccess': 'تم حذف {count} سجل(ات) بنجاح',
  'manualEntry.error.fetchFailed': 'فشل جلب تفاصيل طلب الإدخال اليدوي',
  'manualEntry.error.saveFailed': 'فشل حفظ طلب الإدخال اليدوي',
  'manualEntry.error.title': 'خطأ طلب الإدخال اليدوي',
  'manualEntry.error.noConfiguration': 'إعدادات الإدخال اليدوي غير موجودة',
  'manualEntry.error.exactTimeWindow': 'يجب أن يكون وقت الإدخال ضمن ±2 دقيقة من وقت الشركة الحالي',
  'manualEntry.error.pastDatesNotAllowed': 'التواريخ السابقة غير مسموحة',
  'manualEntry.error.futureDatesNotAllowed': 'التواريخ المستقبلية غير مسموحة',
  'manualEntry.error.cannotUpdateAfterApproval': 'لا يمكنك تعديل طلب الإدخال اليدوي بعد الموافقة عليه',
  'manualEntry.error.unexpectedError': 'حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى أو الاتصال بالدعم إذا استمرت المشكلة.',
  'manualEntry.error.unexpectedSqlError': 'خطأ SQL غير متوقع',
  'manualEntry.loadingForm': 'جاري تحميل النموذج...',
  'manualEntry.loading': 'جاري التحميل...',
  'manualEntry.showDetails': 'عرض التفاصيل',

  // Report Builder
  'reportBuilder.pageTitle': 'تقارير قوائم التصفية',
  'reportBuilder.pinDashboard': 'تثبيت هنا على لوحة التحكم',
  'reportBuilder.addFilter': 'إضافة تصفية',
  'reportBuilder.selection': 'التحديد',
  'reportBuilder.saveReport': 'حفظ التقرير',
  'reportBuilder.exportAs': 'تصدير كـ:',
  'reportBuilder.reportType': 'نوع التقرير:',
  'reportBuilder.searchByKeyword': 'بحث بكلمة مفتاحية',
  'reportBuilder.noDataFound': 'لا توجد بيانات',
  'reportBuilder.sort': 'ترتيب',
  'reportBuilder.sortAscending': '(تصاعدي)',
  'reportBuilder.sortDescending': '(تنازلي)',
  'reportBuilder.saveAsExcel': 'حفظ كـ Excel',
  'reportBuilder.saveAsPDF': 'حفظ كـ PDF',
  'reportBuilder.charts': 'رسوم بيانية',
  'reportBuilder.tables': 'جداول',
  'reportBuilder.between': 'بين',
  'reportBuilder.currentYear': 'السنة الحالية',
  'reportBuilder.currentMonth': 'الشهر الحالي',
  'reportBuilder.equal': 'يساوي',
  'reportBuilder.notEqual': 'لا يساوي',
  'reportBuilder.greaterThan': 'أكبر من',
  'reportBuilder.lessThan': 'أصغر من',
  'reportBuilder.contains': 'يحتوي على',
  'reportBuilder.notContains': 'لا يحتوي على',
  'reportBuilder.value': 'القيمة',
  'reportBuilder.enterNumber': 'أدخل رقماً',
  'reportBuilder.startDate': 'تاريخ البدء',
  'reportBuilder.endDate': 'تاريخ الانتهاء',
  'reportBuilder.employees': 'الموظفون',
  'reportBuilder.chartValueLabel': 'القيمة',
  'reportBuilder.noChartDataMsg': 'يرجى تحديد فئة واحدة على الأقل تحتوي على بيانات رقمية لعرض الرسم البياني',
  'reportBuilder.previous': 'السابق',
  'reportBuilder.next': 'التالي',
  'reportBuilder.totalRecords': 'إجمالي {count} سجل',
  'reportBuilder.page': 'صفحة',
  'reportBuilder.confirm': 'تأكيد',
  'reportBuilder.cancel': 'إلغاء',
  'reportBuilder.filtration': 'التصفية',
  'reportBuilder.pleaseSelectForm': 'يرجى تحديد النموذج أدناه',
  'reportBuilder.filterList': 'قائمة التصفية {id}',
  'reportBuilder.selectCategory': 'اختر فئة',
  'reportBuilder.selectSubCategory': 'اختر فئة فرعية',
  'reportBuilder.selectOperator': 'اختر المشغّل',
  'reportBuilder.customiseFilter': 'تخصيص التصفية',
  'reportBuilder.addMore': 'إضافة المزيد',
  'reportBuilder.submit': 'إرسال',
  'reportBuilder.saveReportTitle': 'حفظ التقرير',
  'reportBuilder.nameEn': 'الاسم الإنجليزي',
  'reportBuilder.nameAr': 'الاسم العربي',
  'reportBuilder.nameEnRequired': 'الاسم الإنجليزي مطلوب',
  'reportBuilder.nameArRequired': 'الاسم العربي مطلوب',
  'reportBuilder.expressionCalculator': 'حاسبة التعبيرات',
  // Categories
  'reportBuilder.category.employee': 'الموظف',
  'reportBuilder.category.leaves': 'الإجازات',
  'reportBuilder.category.permissions': 'الأذونات',
  // Subcategories
  'reportBuilder.sub.employeeNumber': 'رقم الموظف',
  'reportBuilder.sub.oldEmployeeNumber': 'رقم الموظف القديم',
  'reportBuilder.sub.employeeName': 'اسم الموظف',
  'reportBuilder.sub.employeeNameARB': 'اسم الموظف (عربي)',
  'reportBuilder.sub.sickLeave': 'إجازة مرضية',
  'reportBuilder.sub.annualLeave': 'إجازة سنوية',
  'reportBuilder.sub.fromDataLeave': 'تاريخ بدء الإجازة',
  'reportBuilder.sub.startDateToEndDate': 'من تاريخ إلى تاريخ',
  'reportBuilder.sub.startDatetoEndDate': 'من تاريخ إلى تاريخ',
  'reportBuilder.sub.startDatePermission': 'تاريخ بدء الإذن',
  'reportBuilder.sub.endDatePermission': 'تاريخ انتهاء الإذن',
  'reportBuilder.sub.employeeLeave': 'إجازة الموظف',
  'reportBuilder.sub.employeeLeaveARB': 'إجازة الموظف (عربي)',

  // Workflow Builder
  'workflow.workflowBuilder': 'منشئ سير العمل',
  'workflow.approvalStages': 'مراحل الموافقة',
  'workflow.workflowFor': 'سير العمل لـ',
  'workflow.selectWorkflow': 'اختر سير العمل',
  'workflow.enterPlaceholder': 'أدخل النص البديل',
  'workflow.selectPlaceholder': 'اختر النص البديل',
  'workflow.untitledForm': 'نموذج بدون عنوان',
  'workflow.untitledField': 'حقل بدون عنوان',
  'workflow.noFormsAvailable': 'لا توجد نماذج متاحة',
  'workflow.createNewForm': 'إنشاء نموذج جديد',
  'workflow.pleaseSelectFormBelow': 'يرجى اختيار النموذج أدناه',
  'workflow.pleaseClickToSelectTheForm': 'يرجى النقر لاختيار النموذج',
  'workflow.selectForm': 'اختيار النموذج',
  'workflow.formList': 'قائمة النماذج',
  'workflow.email': 'البريد الإلكتروني',
  'workflow.sms': 'رسالة نصية (SMS)',
  'workflow.pushNotification': 'تنبيه دفع',
  'workflow.all': 'الكل',
  'workflow.requiredActions': 'الإجراءات المطلوبة',
  'workflow.attachLinkForm': 'إرفاق/ربط نموذج',
  'workflow.actor': 'المعتمد',
  'workflow.selectWorkflowActor': 'اختر المعتمد',
  'workflow.actorType': 'نوع المعتمد',
  'workflow.selectActorType': 'اختر نوع المعتمد',
  'workflow.rejectionReason': 'سبب الرفض',
  'workflow.enterDaysPlaceholder': 'أدخل الأيام',
  'workflow.noFieldsInThisForm': 'لا توجد حقول في هذا النموذج',
  'workflow.loadingForm': 'جاري تحميل النموذج...',
  'workflow.comingSoon': 'قريباً',

  // Error/Common updates
  'error.textValidation': 'مسموح فقط بالحروف والأرقام والمساحات وعلامات الترقيم الأساسية',
  'common.plus': '+',
  'common.workflowBuilder': 'منشئ سير العمل',
  'common.form': 'نموذج',
  'common.actions': 'إجراءات',
  'common.notificationType': 'نوع التنبيه',
  'common.escalateType': 'نوع التصعيد',
  'error.validPositiveNumber': 'يرجى إدخال رقم موجب صحيح',

  // Employee Calendar & Status
  'employee.upcomingHoliday': 'عطلة قادمة',
  'employee.leaveBalance': 'رصيد الإجازات',
  'employee.permissionBalance': 'رصيد التصاريح',
  'common.busy': 'مشغول',
  'common.appearAway': 'يظهر بعيداً',
  'common.offline': 'غير متصل',
  'common.outOfOffice': 'خارج المكتب',
  'employee.deleteContractConfirm': 'هل أنت متأكد أنك تريد حذف العقد {no}؟',
  'employee.lastGroupAssignmentDeleteConfirm': 'هل أنت متأكد أنك تريد حذف هذا الموظف؟ ستتم إزالة {name} من مجموعة {group} ونقله إلى آخر مجموعة تم تعيينها.',
  'workflow.untitledField': 'حقل بدون عنوان',
  'workflow.enterPlaceholder': 'أدخل النص البديل',
  'workflow.textInput': 'مدخل نص',
  'workflow.enterText': '...أدخل النص',
  'workflow.workflowBuilder': 'منشئ سير العمل',
  'workflow.workflowFor': 'سير العمل لـ',
  'workflow.selectWorkflow': '-- اختر سير العمل --',
  'workflow.approvalStages': 'مراحل الموافقة',
  'workflow.rejectionReason': 'سبب الرفض مطلوب',
  'workflow.actorType': 'نوع المعتمد',
  'workflow.selectActorType': '-- اختر نوع المعتمد --',
  'workflow.actor': 'المعتمد',
  'workflow.selectWorkflowActor': '-- اختر المعتمد --',
  'workflow.attachLinkForm': 'إرفاق/ربط نموذج',
  'workflow.requiredActions': 'الإجراءات المطلوبة',
  'workflow.noFieldsInThisForm': 'لا توجد حقول في هذا النموذج',
  'workflow.untitledForm': 'نموذج بدون عنوان',
  'workflow.selectForm': 'اختيار نموذج',
  'workflow.pleaseClickToSelectTheForm': 'يرجى النقر لاختيار النموذج',
  'workflow.formList': 'قائمة النماذج',
  'workflow.pleaseSelectFormBelow': 'يرجى اختيار نموذج أدناه',
  'workflow.noFormsAvailable': 'لا توجد نماذج متاحة',
  'workflow.createNewForm': 'إنشاء نموذج جديد',
  'workflow.email': 'البريد الإلكتروني',
  'workflow.sms': 'رسالة نصية',
  'workflow.pushNotification': 'إشعار',
  'workflow.all': 'الكل',
  'common.loading': 'جارٍ التحميل...',
  'common.areYouSure': 'هل أنت متأكد؟',
  'common.delete': 'حذف',
  'common.cancel': 'إلغاء',

  // Notification Template Table
  'notificationTemplate.title': 'إعدادات الإشعارات',
  'notificationTemplate.lastUpdatedDate': 'تاريخ آخر تحديث',
  'notificationTemplate.createdDate': 'تاريخ الإنشاء',
  'notificationTemplate.interval': 'الفترة',
  'notificationTemplate.type': 'النوع',
  'notificationTemplate.operations': 'العمليات',
  'notificationTemplate.deleteConfirm': 'هل أنت متأكد من حذف {name}؟',
  'notificationTemplate.recordDeleted': 'تم حذف السجل بنجاح!',
  'notificationTemplate.recordsDeleted': 'سجل(ات) تم حذفها بنجاح!',
  'notificationTemplate.failedToDelete': 'فشل حذف السجلات',
  'notificationTemplate.deleteError': 'حدث خطأ أثناء حذف السجل.',
  'notificationTemplate.exportPDF': 'تصدير PDF',
  'notificationTemplate.exportPDFMsg': 'سيتم تصدير كافة العناصر إلى PDF.',
  'notificationTemplate.exportExcel': 'تصدير Excel',
  'notificationTemplate.exportExcelMsg': 'سيتم تصدير كافة العناصر إلى .csv',
  'notificationTemplate.importData': 'استيراد البيانات',
  'notificationTemplate.importDataMsg': 'سيتم استيراد كافة العناصر.',
  'notificationTemplate.downloadConfirm': 'تأكيد',
  'notificationTemplate.itemsWillBeDownloaded': 'سيتم تحميل العناصر.',
  'notificationTemplate.durationTooltip': 'المدة بالدقائق: تحدد مدة الانتظار بعد بداية الفترة المختارة قبل الإرسال.',

  // Notification Modal
  'notification.addNotification': 'إضافة إشعار',
  'notification.editNotification': 'تعديل الإشعار',
  'notification.objectivesForms': 'الإعدادات العامة',
  'notification.objectivesEmail': 'إعدادات البريد الإلكتروني',
  'notification.objectivesMessage': 'إعدادات الرسائل',
  'notification.triggerFirstDayOfMonth': 'التفعيل في أول يوم من الشهر',
  'notification.objectivesEmail': 'قالب البريد الإلكتروني',
  'notification.objectivesMessage': 'قالب الرسالة',
  'notification.editorInstructions': 'استخدم المحرر أدناه لإنشاء الإشعار الخاص بك.',
  'notification.ccAssignType': 'نوع التعيين (نسخة)',
  'notification.ccTargetGroup': 'المجموعة المستهدفة/الموظف (نسخة)',
  'notification.notificationParameters': 'معايير الإشعار',
  'notification.subjectEnLabel': 'الموضوع (إنجليزي)',
  'notification.subjectArLabel': 'الموضوع (عربي)',
  'notification.systemNotificationEnLabel': 'إشعار النظام (إنجليزي)',
  'notification.systemNotificationArLabel': 'إشعار النظام (عربي)',
  'notification.bodyEnLabel': 'المحتوى (إنجليزي)',
  'notification.bodyArLabel': 'المحتوى (عربي)',
  'notification.preview': 'معاينة',
  'notification.templateBody': 'محتوى القالب',
  'sidbar.notificationTracking':'تتبع الإخطار',
  'common.resendNotification':'إعادة الإرسال',
  'dashboard.actions.applyAction': 'تطبيق إجراء',
  'dashboard.actions.applyRemoteWork': 'تقديم طلب عمل عن بعد',
  'dashboard.actions.applyLeave': 'تقديم طلب إجازة',
  'dashboard.actions.applyPermission': 'تقديم طلب استئذان',
  'dashboard.details.date': 'التاريخ',
  'dashboard.details.type': 'النوع',
  'dashboard.details.leaveType': 'نوع الإجازة',
  'dashboard.details.from': 'من',
  'dashboard.details.to': 'إلى',
  'dashboard.details.minutes': 'الدقائق',
  'dashboard.details.status': 'الحالة',
  'dashboard.details.action': 'إجراء',
  'dashboard.details.noData': 'لم يتم العثور على بيانات',
  'dashboard.details.loading': 'جاري التحميل...',
  'dashboard.units.days': 'أيام',
  'dashboard.units.hours': 'ساعات',
  'dashboard.units.times': 'مرات',
  'dashboard.modal.earlyOut': 'خروج مبكر',
  'dashboard.modal.violations': 'المخالفات',
  'dashboard.modal.absent': 'غياب',
  
  // Integration Builder
  'integrationBuilder.title': 'منشئ التكامل',
  'integrationBuilder.description': 'مصمم تكامل SOAP/REST موحد مع تحميل WSDL، معاملات ديناميكية، موفري الرموز، منطق الحلقات، التحكم في السرعة، ومعاينة كاملة للطلب.',
  'integrationBuilder.loadExisting': 'تحميل تكامل موجود',
  'integrationBuilder.safeMode': 'الوضع الآمن: لا حذف تلقائي',
  'integrationBuilder.reloadConfig': 'إعادة تحميل أي تكوين تكامل محفوظ مسبقًا.',
  'integrationBuilder.selectIntegration': 'اختر التكامل',
  'integrationBuilder.loadIntegration': 'تحميل التكامل',
  'integrationBuilder.actionDetails': 'تفاصيل الإجراء',
  'integrationBuilder.metadata': 'البيانات الوصفية',
  'integrationBuilder.actionName': 'اسم الإجراء',
  'integrationBuilder.actionCode': 'رمز الإجراء',
  'integrationBuilder.description': 'الوصف',
  'integrationBuilder.apiTypeAuth': 'نوع API والمصادقة',
  'integrationBuilder.requestTarget': 'هدف الطلب',
  'integrationBuilder.apiType': 'نوع API',
  'integrationBuilder.httpMethod': 'طريقة HTTP',
  'integrationBuilder.authentication': 'المصادقة',
  'integrationBuilder.endpointUrl': 'رابط نقطة النهاية',
  'integrationBuilder.basicAuth': 'مصادقة أساسية',
  'integrationBuilder.username': 'اسم المستخدم',
  'integrationBuilder.password': 'كلمة المرور',
  'integrationBuilder.bearerToken': 'رمز الحامل',
  'integrationBuilder.tokenValue': 'قيمة الرمز',
  'integrationBuilder.headerName': 'اسم الرأس',
  'integrationBuilder.tokenProvider': 'موفر الرمز',
  'integrationBuilder.apiKey': 'مفتاح API',
  'integrationBuilder.keyLocation': 'موقع المفتاح',
  'integrationBuilder.keyName': 'اسم المفتاح',
  'integrationBuilder.keyValue': 'قيمة المفتاح',
  'integrationBuilder.tokenProviders': 'موفرو الرموز (انقر على الرموز للتكوين)',
  'integrationBuilder.defineTokenFetch': 'حدد كيفية جلب الرموز من API محدد. أي {{tokenNAME}} مستخدم في الرؤوس/الجسم سيظهر هنا.',
  'integrationBuilder.detectedReferences': 'مراجع الرموز المكتشفة (انقر للفتح)',
  'integrationBuilder.noTokensDetected': 'لم يتم اكتشاف رموز',
  'integrationBuilder.addTokenProvider': 'إضافة موفر رمز',
  'integrationBuilder.refreshDropdown': 'تحديث قائمة الموفرين',
  'integrationBuilder.enable': 'تفعيل',
  'integrationBuilder.tokenName': 'اسم الرمز',
  'integrationBuilder.tokenEndpoint': 'نقطة نهاية الرمز',
  'integrationBuilder.credentialType': 'نوع بيانات الاعتماد',
  'integrationBuilder.credentialRule': 'بيانات الاعتماد / القاعدة',
  'integrationBuilder.extractFrom': 'استخراج من',
  'integrationBuilder.cacheMin': 'التخزين المؤقت (دقيقة)',
  'integrationBuilder.customHeaders': 'رؤوس مخصصة',
  'integrationBuilder.addHeader': 'إضافة رأس',
  'integrationBuilder.headerKey': 'مفتاح الرأس',
  'integrationBuilder.headerValue': 'قيمة الرأس',
  'integrationBuilder.wsdlLoader': 'محمل WSDL',
  'integrationBuilder.wsdlUrl': 'رابط WSDL',
  'integrationBuilder.loadWsdl': 'تحميل WSDL',
  'integrationBuilder.operation': 'العملية',
  'integrationBuilder.soapAction': 'إجراء SOAP',
  'integrationBuilder.bodyTemplate': 'قالب الجسم',
  'integrationBuilder.requestPayload': 'حمولة الطلب',
  'integrationBuilder.parameters': 'المعاملات',
  'integrationBuilder.detectParameters': 'اكتشاف المعاملات من الطلب',
  'integrationBuilder.parameterName': 'اسم المعامل',
  'integrationBuilder.sourceType': 'نوع المصدر',
  'integrationBuilder.valueOrRule': 'القيمة أو القاعدة',
  'integrationBuilder.listParameters': 'معاملات القائمة',
  'integrationBuilder.addListParam': 'إضافة معامل قائمة',
  'integrationBuilder.loopModeThrottling': 'وضع الحلقة والتحكم في السرعة',
  'integrationBuilder.enhanced': 'محسّن',
  'integrationBuilder.loopDescription': 'يمكن تشغيل الحلقة بواسطة: (أ) قائمة ثابتة، (ب) نطاق التاريخ، (ج) رموز محددة مسبقًا، أو (د) API يعيد قائمة.',
  'integrationBuilder.enableLoop': 'تفعيل تنفيذ الحلقة',
  'integrationBuilder.loopType': 'نوع الحلقة',
  'integrationBuilder.loopVariable': 'متغير الحلقة البديل',
  'integrationBuilder.injectInto': 'حقن في',
  'integrationBuilder.loopSource': 'مصدر الحلقة',
  'integrationBuilder.rangeFrom': 'النطاق من',
  'integrationBuilder.rangeTo': 'النطاق إلى',
  'integrationBuilder.rangeNotes': 'ملاحظات النطاق',
  'integrationBuilder.idList': 'قائمة المعرفات',
  'integrationBuilder.idListName': 'اسم قائمة المعرفات',
  'integrationBuilder.codes': 'الرموز',
  'integrationBuilder.codesType': 'نوع الرموز',
  'integrationBuilder.dateFrom': 'التاريخ من',
  'integrationBuilder.dateTo': 'التاريخ إلى',
  'integrationBuilder.dateStep': 'خطوة التاريخ',
  'integrationBuilder.listApiUrl': 'رابط API القائمة',
  'integrationBuilder.responseListPath': 'مسار قائمة الاستجابة',
  'integrationBuilder.loopValueField': 'حقل قيمة الحلقة',
  'integrationBuilder.maxItems': 'الحد الأقصى للعناصر (للأمان)',
  'integrationBuilder.listApiBody': 'قالب جسم API القائمة (اختياري)',
  'integrationBuilder.notes': 'ملاحظات',
  'integrationBuilder.delayBetweenCalls': 'التأخير بين المكالمات (ميلي ثانية)',
  'integrationBuilder.maxRequestsPerMinute': 'الحد الأقصى للطلبات في الدقيقة',
  'integrationBuilder.exampleNotes': 'ملاحظات مثال',
  'integrationBuilder.finalPreview': 'المعاينة النهائية (كل شيء)',
  'integrationBuilder.live': 'مباشر',
  'integrationBuilder.print': 'طباعة',
  'integrationBuilder.generateSend': 'إنشاء وإرسال',
  'dashboard.modal.absent': 'غياب',

  //attendance duration
  'attendanceDuration.attendanceDurationDetails': 'تفاصيل مدة الحضور',
  'attendanceDuration.editAttendanceDuration': 'تعديل مدة الحضور',
  'attendanceDuration.addAttendanceDuration': 'إضافة مدة الحضور',
  'attendanceDuration.minutes': 'دقائق',
  'attendanceDuration.saveSuccess': 'تم حفظ نمط المناوبة بنجاح',
  'attendanceDuration.updateSuccess': 'تم تحديث نمط المناوبة بنجاح',
  'attendanceDuration.invalidTimeValues': 'قيم وقت غير صالحة',
  'attendanceDuration.invalidTimeValuesMsg': 'يرجى تصحيح أخطاء التحقق من الوقت قبل الحفظ.',
  'attendanceDuration.unsavedChanges': 'تغييرات غير محفوظة',
  'attendanceDuration.unsavedChangesMsg': 'لديك تغييرات غير محفوظة. هل أنت متأكد أنك تريد تجاهلها؟',
  'attendanceDuration.workScheduleTypeChanged': 'تغير نوع جدول العمل',
  'attendanceDuration.workScheduleTypeChangedMsg': 'أنت تقوم بتغيير نوع جدول العمل. سيتم فقدان بياناتك.',
  'attendanceDuration.flexStartTime': 'وقت البدء المرن',
  'attendanceDuration.flexEndTime': 'وقت الانتهاء المرن',
  'attendanceDuration.coreStartTime': 'وقت البدء الأساسي',
  'attendanceDuration.coreEndTime': 'وقت الانتهاء الأساسي',
  'employee.page': 'الموظف',
  'employee.deleteSuccess': 'تم حذف السجل بنجاح.',
  'employee.bulkDeleteSuccess': 'تم حذف {count} سجلات بنجاح.',
  'error.deleteBulkTitle': 'فشل الحذف',
  'error.deleteBulkMessage': 'فشل حذف السجلات.',
  'error.deleteSingleTitle': 'فشل الحذف',
  'error.deleteSingleMessage': 'فشل حذف السجل.',
  'filter.contains': 'يحتوي على',
  'filter.startsWith': 'يبدأ بـ',
  'filter.endsWith': 'ينتهي بـ',
  'filter.equals': 'يساوي',
  'filter.notEquals': 'لا يساوي',
  'filter.isNull': 'قيمة فارغة',
  'filter.isNotNull': 'ليس قيمة فارغة',
  'filter.before': 'قبل',
  'filter.after': 'بعد',
  'filter.between': 'بين',
  'filter.greaterThan': 'أكبر من',
  'filter.greaterThanOrEqual': 'أكبر من أو يساوي',
  'filter.lessThan': 'أقل من',
  'filter.lessThanOrEqual': 'أقل من أو يساوي',
  'dashboard.modal.absent': 'غياب',
  // Unified Login
  'unifiedLogin.english': "English",
  'unifiedLogin.arabic': "العربية",
  'unifiedLogin.heroTitle': "الحضور، الورديات، والموافقات. ",
  'unifiedLogin.heroTitleHighlight': "موحّد",
  'unifiedLogin.heroLead': "منصة واحدة لفريقي الموارد البشرية والعمليات لتتبع الوقت في الوقت الفعلي، وتخطيط الورديات المعقدة، وتنفيذ الموافقات من خلال سير عمل ديناميكية — بدون جداول بيانات، وبدون مطاردة.",
  'unifiedLogin.tenantPlaceholder': "أدخل كود الشركة",
  'unifiedLogin.tenantError': "أدخل كود شركتك للمتابعة.",
  'unifiedLogin.signInMicrosoft': "تسجيل الدخول عبر مايكروسوفت",
  'unifiedLogin.signInUsername': "تسجيل الدخول باسم المستخدم وكلمة المرور",
  'unifiedLogin.backToSignIn': "→ الرجوع لخيارات تسجيل الدخول",
  'unifiedLogin.usernamePlaceholder': "اسم المستخدم",
  'unifiedLogin.passwordPlaceholder': "كلمة المرور",
  'unifiedLogin.signIn': "تسجيل الدخول",
  'unifiedLogin.signingIn': "جارٍ تسجيل الدخول…",
  'unifiedLogin.tenantExample1': "مثال: ACME2024",
  'unifiedLogin.tenantExample2': "مثال: NORTH-99",
  'unifiedLogin.tenantExample3': "مثال: GLOBALTECH",
  'unifiedLogin.missingCredentials': "يرجى إدخال اسم المستخدم وكلمة المرور",
  'unifiedLogin.loginFailed': "فشل تسجيل الدخول",
  'unifiedLogin.ideaLeaveTitle': "الإجازات",
  'unifiedLogin.ideaLeaveDesc': "اطلب إجازتك، تابع رصيدك، واحصل على الموافقة بضغطات بسيطة.",
  'unifiedLogin.ideaRemoteTitle': "العمل عن بُعد",
  'unifiedLogin.ideaRemoteDesc': "قدّم واعتمد طلبات العمل عن بُعد من دون أي أوراق.",
  'unifiedLogin.ideaPermissionTitle': "الاستئذان",
  'unifiedLogin.ideaPermissionDesc': "استئذان أو خروج مبكر، يُرسل مباشرة لمديرك للموافقة.",
  'unifiedLogin.ideaPoliciesTitle': "السياسات",
  'unifiedLogin.ideaPoliciesDesc': "قوانين الشركة وسياسات الحضور، متاحة دائمًا بضغطة واحدة.",
  'unifiedLogin.ideaScheduleTitle': "جدول العمل",
  'unifiedLogin.ideaScheduleDesc': "الورديات والتناوب والتغطية — مخطّنة ومشتركة في مكان واحد.",
  'unifiedLogin.ideaClockTitle': "تسجيل الحضور والانصراف",
  'unifiedLogin.ideaClockDesc': "عبر الويب أو الموبايل أو الكشك. لمسة واحدة ويُسجَّل حضورك.",
  'unifiedLogin.ideaCalendarTitle': "التقويم",
  'unifiedLogin.ideaCalendarDesc': "عرض شهري كامل للحضور والإجازات وأيام الراحة بنظرة واحدة.",
  'unifiedLogin.ideaDashboardsTitle': "لوحات المتابعة",
  'unifiedLogin.ideaDashboardsDesc': "لوحات مباشرة للحضور والغياب وتكلفة العمالة.",
  'unifiedLogin.greetingMorning': "صباح الخير.",
  'unifiedLogin.greetingAfternoon': "مساء الخير.",
  'unifiedLogin.greetingEvening': "مساء الخير.",
  'unifiedLogin.weekdayFull.sun': "الأحد",
  'unifiedLogin.weekdayFull.mon': "الإثنين",
  'unifiedLogin.weekdayFull.tue': "الثلاثاء",
  'unifiedLogin.weekdayFull.wed': "الأربعاء",
  'unifiedLogin.weekdayFull.thu': "الخميس",
  'unifiedLogin.weekdayFull.fri': "الجمعة",
  'unifiedLogin.weekdayFull.sat': "السبت",
  'unifiedLogin.monthFull.jan': "يناير",
  'unifiedLogin.monthFull.feb': "فبراير",
  'unifiedLogin.monthFull.mar': "مارس",
  'unifiedLogin.monthFull.apr': "أبريل",
  'unifiedLogin.monthFull.may': "مايو",
  'unifiedLogin.monthFull.jun': "يونيو",
  'unifiedLogin.monthFull.jul': "يوليو",
  'unifiedLogin.monthFull.aug': "أغسطس",
  'unifiedLogin.monthFull.sep': "سبتمبر",
  'unifiedLogin.monthFull.oct': "أكتوبر",
  'unifiedLogin.monthFull.nov': "نوفمبر",
  'unifiedLogin.monthFull.dec': "ديسمبر",
  'unifiedLogin.liveWorkspaceTime': "وقت العمل الحالي",
  'unifiedLogin.welcomeBack': "مرحبًا بعودتك",
  'unifiedLogin.signInToWorkspace': "سجّل الدخول إلى مساحة عملك",
  'unifiedLogin.accessDescription': "ادخل إلى الحضور والجدول والموافقات.",
  'unifiedLogin.enterCredentials': "أدخل بيانات الدخول",
  'unifiedLogin.usernameLabel': "اسم المستخدم",
  'unifiedLogin.passwordLabel': "كلمة المرور",
  'unifiedLogin.orContinueWith': "أو تابع باستخدام",
  'unifiedLogin.reenterTenantCode': "إعادة إدخال كود الشركة",
  'unifiedLogin.companyCodeLabel': "كود الشركة",
  'unifiedLogin.reentryCode': "إعادة إدخال الكود",
  'notification.reportTemplate':'نموذج تقرير',
  'notification.selectReportTemplate':'اختر قالب التقرير',
  'assistant.title': 'المساعد',
  'assistant.open': 'فتح المساعد',
  'assistant.close': 'إغلاق',
  'assistant.newChat': 'محادثة جديدة',
  'assistant.confirm': 'تأكيد',
  'assistant.cancel': 'إلغاء',
  'assistant.thinking': 'جارٍ التفكير…',
  'assistant.send': 'إرسال',
  'assistant.placeholder': 'اسأل عن الإجازات، الأذونات، أو ساعات العمل…',
  'assistant.greeting': 'مرحباً! اسألني عن إجازاتك، أذوناتك، أو ساعات عملك.',
  'dashboard.superAdmin.eyebrow':'المشرف العام · ذكاء بيانات المستأجرين',
  'dashboard.superAdmin.title':'مركز قيادة القوى العاملة',
  'dashboard.superAdmin.subtitle':'انظر إلى المنظمة أولاً. قم بتوسيع ما تريد فقط.',
  'dashboard.superAdmin.hero.eyebrow':'فار · جميع الشركات · 01 أغسطس — 17 أغسطس',
  'dashboard.superAdmin.hero.title':'تعمل القوى العاملة بنسبة 94.6% من طاقتها.',
  'dashboard.superAdmin.hero.subtitle':'5 شركات · 14,208 موظفاً',
  'dashboard.superAdmin.hero.deltaPositive':'1.2 نقطة مئوية مقارنة بالفترة السابقة',
  'dashboard.superAdmin.filters.tenant': 'المستأجر',
  'dashboard.superAdmin.filters.company': 'الشركة',
  'dashboard.superAdmin.filters.period': 'الفترة',
  'dashboard.superAdmin.metrics.employees.label': 'الموظفون',
  'dashboard.superAdmin.metrics.employees.sub': '{count} شركات',
  'dashboard.superAdmin.metrics.attendance.label': 'الحضور',
  'dashboard.superAdmin.metrics.attendance.trend': '↑ {delta} نقطة مئوية · مقابل هدف {target}٪',
  'dashboard.superAdmin.metrics.absent.label': 'الغياب',
  'dashboard.superAdmin.metrics.absent.sub': '{percent}% من القوة العاملة',
  'dashboard.superAdmin.metrics.late.label': 'التأخر',
  'dashboard.superAdmin.metrics.late.sub': '{percent}% من القوة العاملة',
  'dashboard.superAdmin.metrics.violations.label': 'المخالفات',
  'dashboard.superAdmin.metrics.violations.sub': 'مفتوحة عبر المستأجر',
  'dashboard.superAdmin.metrics.compliance.label': 'الامتثال',
  'dashboard.superAdmin.metrics.compliance.trend': '{status}',
  'dashboard.superAdmin.companyHealth.title': 'صحة الشركة',
  'dashboard.superAdmin.companyHealth.tagline': 'الحضور · التواجد · الغياب · المخالفات',
  'dashboard.superAdmin.companyHealth.entity': 'الجهة',
  'dashboard.superAdmin.companyHealth.employees': 'الموظفون',
  'dashboard.superAdmin.companyHealth.present': 'الحاضرون',
  'dashboard.superAdmin.companyHealth.attendance': 'نسبة الحضور',
  'dashboard.superAdmin.companyHealth.absent': 'الغياب',
  'dashboard.superAdmin.companyHealth.violations': 'المخالفات',
  'dashboard.superAdmin.companyHealth.pending': 'قيد الانتظار',
  'dashboard.superAdmin.companyHealth.status': 'الحالة',
  'dashboard.superAdmin.companyHealth.viewCompany': 'عرض الشركة',
  'dashboard.superAdmin.orgTree.title': 'خريطة صحة الشركة · شجرة المنظمة',
  'dashboard.superAdmin.orgTree.tag': 'انقر فقط على أيقونة ⌄ الصغيرة لعرض الفروع',
  'dashboard.superAdmin.status.healthy': 'صحي',
  'dashboard.superAdmin.status.watch': 'مراقبة',
  'dashboard.superAdmin.status.needsAttention': 'بحاجة إلى انتباه'
  , 'dashboard.superAdmin.charts.attendanceTrend.title': 'اتجاه الحضور'
  , 'dashboard.superAdmin.charts.attendanceTrend.period6m': '6 أشهر'
  , 'dashboard.superAdmin.charts.workforceDistribution.title': 'توزيع القوى العاملة'
  , 'dashboard.superAdmin.charts.workforceDistribution.selectedPeriod': 'الفترة المحددة'
  , 'dashboard.superAdmin.charts.absenceByCompany.title': 'الغياب حسب الشركة'
  , 'dashboard.superAdmin.charts.absenceByCompany.subtitle': 'الموظفون الغائبون خلال الفترة المحددة'
  , 'dashboard.superAdmin.charts.lateByCompany.title': 'التأخر حسب الشركة'
  , 'dashboard.superAdmin.charts.lateByCompany.subtitle': 'الموظفون المتأخرون خلال الفترة المحددة'
  , 'common.other': 'أخرى'

  , 'dashboard.superAdmin.opTrends.title': 'الاتجاهات التشغيلية'
  , 'dashboard.superAdmin.opTrends.subtitle': 'تحليلات خطية إضافية'
  , 'dashboard.superAdmin.charts.attendanceRate.title': 'معدل الحضور حسب الشهر'
  , 'dashboard.superAdmin.charts.attendanceRate.subtitle': 'أداء الحضور عبر الزمن'
  , 'dashboard.superAdmin.charts.attendance': 'الحضور'
  , 'dashboard.superAdmin.charts.target': 'الهدف'
  , 'dashboard.superAdmin.charts.absentEmployees.title': 'اتجاه الموظفين الغائبين'
  , 'dashboard.superAdmin.charts.absentEmployees.subtitle': 'الحركة الشهرية لحجم الغياب'
  , 'dashboard.superAdmin.charts.absentEmployees': 'الموظفون الغائبون'
  , 'dashboard.superAdmin.charts.lateArrivals.title': 'اتجاه التأخر'
  , 'dashboard.superAdmin.charts.lateArrivals.subtitle': 'سجلات التأخر الشهرية'
  , 'dashboard.superAdmin.charts.lateArrivals': 'تأخر'
  , 'dashboard.superAdmin.charts.earlyOut.title': 'اتجاه الخروج المبكر'
  , 'dashboard.superAdmin.charts.earlyOut.subtitle': 'سجلات الخروج المبكر الشهرية'
  , 'dashboard.superAdmin.charts.earlyOut': 'خروج مبكر'
  , 'dashboard.superAdmin.charts.compliance.title': 'اتجاه الامتثال'
  , 'dashboard.superAdmin.charts.compliance.subtitle': 'أداء الامتثال'
  , 'dashboard.superAdmin.charts.compliance': 'الامتثال'
  , 'dashboard.superAdmin.charts.openViolations.title': 'اتجاه المخالفات المفتوحة'
  , 'dashboard.superAdmin.charts.openViolations.subtitle': 'المخالفات المفتوحة عبر الزمن'
  , 'dashboard.superAdmin.charts.openViolations': 'المخالفات المفتوحة'
  , 'common.superAdmin': 'المشرف العام'

};
